const en = {
  'auth.signInTitle': 'Sign In',
  'auth.emailPlaceholder': 'Email',
  'auth.passwordPlaceholder': 'Password',
  'auth.loginButton': 'Login',
  'auth.signingIn': 'Signing in…',
  'auth.forgotPassword': 'Forgot password?',
  'auth.forgotPassword.title': 'Forgot Password',
  'auth.forgotPassword.submit': 'Send reset link',
  'auth.forgotPassword.sending': 'Sending…',
  'auth.forgotPassword.success': 'If an account exists for that email, a reset link has been sent.',
  'auth.forgotPassword.errors.requestFailed': 'Unable to process request.',
  'auth.resetPassword.title': 'Reset Password',
  'auth.resetPassword.newPasswordPlaceholder': 'New Password',
  'auth.resetPassword.success': 'Password reset successfully.',
  'auth.resetPassword.errors.invalidLink': 'Invalid reset link.',
  'auth.resetPassword.errors.passwordsMismatch': 'Passwords do not match',
  'auth.resetPassword.errors.passwordPolicy': 'Password does not meet complexity requirements.{issues}',
  'auth.resetPassword.errors.resetFailed': 'Failed to reset password',
  'auth.acceptInvite.title': 'Accept Invite',
  'auth.acceptInvite.success': 'Invite accepted. You can now log in.',
  'auth.acceptInvite.errors.invalidLink': 'Invalid invite link.',
  'auth.acceptInvite.errors.passwordsMismatch': 'Passwords do not match',
  'auth.acceptInvite.errors.passwordMin': 'Password must be at least {min} characters',
  'auth.acceptInvite.errors.acceptFailed': 'Failed to accept invite',
  'auth.invalidCredentials': 'Invalid email or password.',
  'auth.accountNotApproved': 'Your account is awaiting approval.',
  'auth.sessionExpired': 'Session expired. Please log in again.',
  'auth.loginFailed': 'Login failed.',
  'auth.verifyEmail.title': 'Email Verification',
  'auth.verifyEmail.loading': 'Verifying your email…',
  'auth.verifyEmail.missingToken': 'Verification token is missing from this link.',
  'auth.verifyEmail.invalidOrExpired': 'Verification link is invalid or expired.',
  'auth.verifyEmail.successTitle': 'Email verified',
  'auth.verifyEmail.successMessage':
    'Thanks — your email has been verified. Your registration is now pending review. You’ll receive an email once your registration has been reviewed and approved.',
  'auth.verifyEmail.cta.login': 'Go to login',
  'auth.verifyEmail.cta.signup': 'Create an account',
  'signup.languageLabel': 'Language',
  'signup.documentTitle': 'Sign Up | Umpire Assistant',
  'signup.title': 'Create your account',
  'signup.rolesLoading': 'Loading roles…',
  'signup.receivedTitle': 'Registration received',
  'signup.receivedDescription':
    "Thanks! Please verify your email address and give our SuperAdmin team time to approve your access. We'll notify you once your modules are activated.",
  'signup.languageCatalogLabel': '{native} ({english})',
  'signup.inviteNotice': "You're joining a team invitation. Review your details below to continue.",
  'signup.firstNamePlaceholder': 'Jane',
  'signup.lastNamePlaceholder': 'Doe',
  'signup.emailPlaceholder': 'you@example.com',
  'signup.passwordLabel': 'Password',
  'signup.passwordPlaceholder': 'Create a strong password',
  'signup.confirmPasswordLabel': 'Confirm password',
  'signup.confirmPasswordPlaceholder': 'Re-enter your password',
  'signup.accountTypeLabel': 'Account type',
  'signup.accountTypeIndividual': 'Individual Account',
  'signup.accountTypeCompany': 'Company/Team',
  'signup.companyPlaceholder': 'Your organization',
  'signup.companyHelper': 'Required for Company/Team accounts.',
  'signup.selectRole': 'Select your role',
  'signup.referralCodeLabel': 'Referral Code (optional)',
  'signup.referralCodePlaceholder': 'Enter a referral code',
  'signup.captchaDisabled': 'CAPTCHA is disabled in this environment.',
  'signup.captchaLoading': 'Loading CAPTCHA…',
  'signup.eulaAgreementPrefix': 'I agree to the',
  'signup.eulaLink': 'End User License Agreement',
  'signup.eulaAgreementSuffix': '. My acceptance will be recorded with this signup.',
  'signup.approvalNotice':
    'Approval is required before you can access any modules. Company administrators will review pending join requests when applicable.',
  'signup.alreadyHaveAccount': 'Already have an account?',
  'signup.submitting': 'Submitting…',
  'signup.submit': 'Submit for approval',
  'signup.eulaRequired': 'You must accept the End User License Agreement.',
  'signup.companyRequired': 'Company is required for Company/Team accounts.',
  'signup.confirmPasswordRequired': 'Confirm password is required.',
  'signup.passwordsMismatch': 'Passwords do not match.',
  'signup.captchaRequired': 'Please complete the CAPTCHA challenge.',
  'signup.passwordWeak': 'Password does not meet complexity requirements.',
  'signup.submitError': 'Unable to complete signup at this time.',
  'signup.supportCode': 'Support code: {code}',
  'signup.inviteLoadError': 'Unable to load invite details.',
  'signup.loadRolesErrorStatus': 'Failed to load roles ({status})',
  'signup.loadRolesError': 'Unable to load available roles. Please try again later.',
  'signup.passwordStrength.veryWeak': 'Very weak',
  'signup.passwordStrength.weak': 'Weak',
  'signup.passwordStrength.fair': 'Fair',
  'signup.passwordStrength.good': 'Good',
  'signup.passwordStrength.strong': 'Strong',
  'signup.passwordPolicyOk': 'Meets complexity requirements.',
  'signup.passwordPolicyFail': 'Password does not meet complexity requirements.',
  'signup.passwordPolicyHint':
    'At least 12 characters and 3 of 4: lowercase, uppercase, number, symbol.',
  'signup.passwordStrengthSummary': '{strength}. {helper}',
  'header.language': 'Language',
  'header.prepareLanguage': 'Prepare language',
  'header.preparingTranslations': 'Preparing translations…',
  'header.languageReady': 'Translations ready.',
  'header.prepareFailed': 'Translation prep failed.',
  'profile.title': 'Profile Settings',
  'profile.subtitle': 'Update your account details and password settings.',
  'profile.email': 'Email',
  'profile.firstName': 'First name',
  'profile.lastName': 'Last name',
  'profile.timezone': 'Timezone',
  'profile.detectTimezone': 'Detect',
  'profile.timezonePlaceholder': 'Select or type a timezone (e.g., America/New_York)',
  'profile.useBrowserTimezone': 'Use browser timezone',
  'profile.language': 'Language',
  'profile.defaultContainerState': 'Default Container State',
  'profile.defaultContainerState.help':
    'Controls whether expandable sections are open or collapsed by default.',
  'profile.defaultContainerState.expanded': 'Expanded',
  'profile.defaultContainerState.collapsed': 'Collapsed',
  'profile.defaultStartPage.title': 'Default page at login',
  'profile.defaultStartPage.description':
    'Choose where to land after signing in. If unavailable, Welcome will be used.',
  'profile.defaultStartPage.label': 'Default page',
  'profile.defaultStartPage.option.welcome': 'Welcome',
  'profile.defaultStartPage.option.adminDashboard': 'Admin Dashboard',
  'profile.defaultStartPage.option.uaDashboard': 'UA Dashboard',
  'profile.defaultStartPage.option.adrDashboard': 'ADR Dashboard',
  'profile.defaultStartPage.option.sfDashboard': 'SettleFast Dashboard',
  'profile.defaultStartPage.toast.saveSuccess': 'Default page preference saved.',
  'profile.defaultStartPage.toast.saveError': 'Unable to save default page preference.',
  'profile.save': 'Save',
  'profile.cancel': 'Cancel',
  'profile.edit': 'Edit',
  'profile.saving': 'Saving…',
  'profile.saved': 'Profile saved.',
  'profile.saveFailed': 'Unable to save profile.',
  'profile.loadFailed': 'Unable to load profile.',
  'profile.invalidResponse': 'Received an invalid response from the server.',
  'profile.language.select': 'Select',
  'profile.language.loadFailed': 'Unable to load languages.',
  'profile.language.loadFailedStatus': 'Failed to load locales ({status}).',
  'profile.validation.firstNameRequired': 'First name is required.',
  'profile.validation.firstNameTooLong': 'First name must be 255 characters or fewer.',
  'profile.validation.lastNameRequired': 'Last name is required.',
  'profile.validation.lastNameTooLong': 'Last name must be 255 characters or fewer.',
  'profile.validation.timezoneTooLong': 'Timezone must be 64 characters or fewer.',
  'profile.password.title': 'Password',
  'profile.password.description':
    'Send yourself a password reset email to update your login credentials.',
  'profile.password.sendButton': 'Send password reset email',
  'profile.password.sending': 'Sending…',
  'profile.password.sendFailed': 'Unable to send reset email.',
  'profile.password.emailUnavailable': 'Email is unavailable for this account.',
  'businessProfiles.personal.title': 'Business Profiles',
  'businessProfiles.personal.subtitle': 'Manage the business profiles you use for billing.',
  'businessProfiles.company.title': 'Company Business Profiles',
  'businessProfiles.company.subtitle': 'Manage business profiles shared across your company.',
  'businessProfiles.actions.add': 'Add profile',
  'businessProfiles.actions.edit': 'Edit',
  'businessProfiles.actions.delete': 'Delete',
  'businessProfiles.actions.save': 'Save',
  'businessProfiles.actions.cancel': 'Cancel',
  'businessProfiles.actions.uploadLogo': 'Upload logo',
  'businessProfiles.actions.removeLogo': 'Remove logo',
  'businessProfiles.emptyState.title': 'No business profiles yet',
  'businessProfiles.emptyState.body': 'Create a business profile to reuse across invoices.',
  'businessProfiles.form.profileName': 'Profile name',
  'businessProfiles.form.companyName': 'Company name',
  'businessProfiles.form.ein': 'EIN',
  'businessProfiles.form.address1': 'Address line 1',
  'businessProfiles.form.address2': 'Address line 2',
  'businessProfiles.form.city': 'City',
  'businessProfiles.form.state': 'State',
  'businessProfiles.form.zip': 'Zip',
  'businessProfiles.form.country': 'Country',
  'businessProfiles.form.countryLegacyHint':
    'Current value: {value}. Select a country to standardize.',
  'businessProfiles.form.telephone': 'Telephone',
  'businessProfiles.form.email': 'Email',
  'businessProfiles.form.logo': 'Logo',
  'businessProfiles.form.scope': 'Scope',
  'businessProfiles.form.scope.personal': 'Personal',
  'businessProfiles.form.scope.company': 'Company',
  'businessProfiles.confirmDelete.title': 'Delete business profile?',
  'businessProfiles.confirmDelete.body': 'This action cannot be undone.',
  'businessProfiles.toast.created': 'Business profile created.',
  'businessProfiles.toast.updated': 'Business profile updated.',
  'businessProfiles.toast.deleted': 'Business profile deleted.',
  'businessProfiles.toast.logoUploaded': 'Logo uploaded.',
  'businessProfiles.logo.saveBeforeUpload': 'Save this profile before uploading a logo.',
  'businessProfiles.errors.unauthorized': 'You are not authorized to view this page.',
  'businessProfiles.errors.loadFailed': 'Unable to load business profiles.',
  'businessProfiles.errors.saveFailed': 'Unable to save business profile.',
  'businessProfiles.errors.deleteFailed': 'Unable to delete business profile.',
  'businessProfiles.errors.logoUploadFailed': 'Unable to upload logo.',
  'account.hub.pageTitle': 'My Account',
  'account.hub.subtitle':
    'Use the links below to manage your profile, settings, and billing details.',
  'account.hub.profileSettings': 'Profile / Settings',
  'layout.header.appName': 'Umpire Assistant',
  'layout.header.logoAlt': 'Umpire Assistant',
  'layout.header.language': 'Language',
  'layout.header.prepareLanguage': 'Prepare language',
  'layout.header.preparingTranslations': 'Preparing translations…',
  'layout.header.languageReady': 'Translations ready.',
  'layout.header.prepareFailed': 'Translation prep failed.',
  'layout.header.toggleTheme': 'Toggle theme',
  'layout.header.section.ua': 'UA',
  'layout.header.section.adr': 'ADR',
  'layout.header.section.settleFast': 'SettleFast',
  'layout.header.section.globalAdmin': 'Global Admin',
  'layout.header.section.admin': 'Admin',
  'layout.header.pageTitle.uaDashboard': 'Dashboard',
  'layout.header.pageTitle.projects': 'Projects',
  'layout.header.pageTitle.typeOfLoss': 'Type of Loss',
  'layout.header.pageTitle.hourlyRate': 'Hourly Rate',
  'layout.header.pageTitle.invoiceCenter': 'Invoice Center',
  'layout.header.pageTitle.adrDashboard': 'ADR Dashboard',
  'layout.header.pageTitle.adrProjects': 'ADR Projects',
  'layout.header.pageTitle.adrTypeOfLoss': 'ADR Type of Loss',
  'layout.header.pageTitle.caseReadyDashboard': 'ADR Case Ready Dashboard',
  'layout.header.pageTitle.caseReadyTypeOfLoss': 'Type of Loss – ADR Case Ready',
  'layout.header.pageTitle.settleFastDashboard': 'SettleFast Dashboard',
  'layout.header.pageTitle.settleFastProjects': 'SettleFast Projects',
  'layout.header.pageTitle.settleFastTypeOfLoss': 'SettleFast Type of Loss',
  'layout.header.pageTitle.companies': 'Companies',
  'layout.header.pageTitle.settings': 'Settings',
  'layout.header.pageTitle.users': 'Users',
  'layout.header.pageTitle.pendingApprovals': 'Pending Approvals',
  'layout.header.pageTitle.generalInvoiceSettings': 'General Invoice Settings',
  'layout.footer.copyright':
    'Copyright {year} Umpire Assistant. All Rights Reserved. U.S. Patents Pending - {patents}.',
  'layout.language.english': 'English',
  'layout.language.spanish': 'Español',
  'layout.language.loadLocalesError': 'Failed to load locales.',
  'layout.language.loadCatalogError': 'Failed to load locale catalog.',
  'layout.language.searchPlaceholder': 'Search language',
  'layout.sidebar.expand': 'Expand sidebar',
  'layout.sidebar.collapse': 'Collapse sidebar',
  'layout.sidebar.expandSection': 'Expand section',
  'layout.sidebar.collapseSection': 'Collapse section',
  'layout.sidebar.section.umpireAssistant': 'UA',
  'layout.sidebar.section.adr': 'ADR',
  'layout.sidebar.section.caseReady': 'ADR Case Ready',
  'layout.sidebar.section.settleFast': 'SettleFast',
  'layout.sidebar.section.globalAdmin': 'Global Admin',
  'layout.sidebar.section.welcome': 'Welcome',
  'layout.sidebar.section.companyAdmin': 'Company Admin',
  'layout.sidebar.section.billingSettings': 'Billing & Settings',
  'layout.sidebar.section.learningSupport': 'Learning and Support',
  'nav.globalAdmin.reassignProjects': 'Reassign Projects',
  'nav.reportingCenter': 'Reporting Center',
  'layout.sidebar.link.uaDashboard': 'UA Dashboard',
  'layout.sidebar.link.projects': 'Projects',
  'layout.sidebar.link.typeOfLoss': 'Type of Loss',
  'layout.sidebar.link.invoiceCenter': 'Invoice Center',
  'layout.sidebar.link.adrDashboard': 'ADR Dashboard',
  'layout.sidebar.link.caseReadyDashboard': 'Dashboard',
  'layout.sidebar.link.settleFastDashboard': 'SettleFast Dashboard',
  'layout.sidebar.link.welcome': 'Welcome',
  'layout.sidebar.link.dashboard': 'Dashboard',
  'layout.sidebar.link.users': 'Users',
  'layout.sidebar.link.pendingApprovals': 'Pending Approvals',
  'layout.sidebar.link.companies': 'Companies',
  'layout.sidebar.link.i18n': 'Manage Languages and Locales',
  'layout.sidebar.link.referrals': 'Referrals',
  'layout.sidebar.link.learningAndSupport': 'Learning and Support',
  'layout.sidebar.link.whatsNew': 'What’s New',
  'layout.sidebar.link.adminWhatsNew': 'What’s New (Admin)',
  'layout.sidebar.link.usersGuide': 'User’s Guide',
  'layout.sidebar.link.billing': 'Billing',
  'layout.sidebar.link.companyUsers': 'Company Users',
  'layout.sidebar.link.inviteTeamMembers': 'Invite Team Members',
  'layout.sidebar.link.generalInvoiceSettings': 'General Invoice Settings',
  'layout.sidebar.link.reassignProjects': 'Reassign Projects',
  'layout.sidebar.link.auditReports': 'Audit Reports',
  'layout.sidebar.link.companyBilling': 'Company Billing',
  'layout.sidebar.link.settings': 'Settings',
  'layout.sidebar.link.privacy': 'Privacy',
  'layout.sidebar.link.referUsers': 'Refer Users',
  'layout.sidebar.link.businessProfiles': 'Business Profiles',
  'layout.sidebar.link.faqs': 'FAQs',
  'layout.sidebar.link.trainingVideos': 'Training and Update Videos',
  'layout.sidebar.link.support': 'Support',
  'layout.sidebar.link.feedback': 'Feedback',
  'layout.menu.companySubscriptionBilling': 'Company Subscription & Billing',
  'layout.menu.subscriptionBilling': 'Subscription & Billing',
  'layout.menu.companyAdmin': 'Company Admin',
  'layout.menu.generalInvoiceSettings': 'General Invoice Settings',
  'layout.menu.signOut': 'Sign out',
  'layout.menu.toggleMenu': 'Toggle Menu',
  'layout.support.support': 'Support',
  'layout.support.feedback': 'Feedback',
  'support.pageTitle': 'Support',
  'support.heading': 'Support',
  'support.subjectPrefix': 'UA Support Request {versionLabel}',
  'support.appVersionPrefix': 'App Version:',
  'support.success': 'Thanks! Your message has been sent.',
  'support.fields.firstName': 'First Name',
  'support.fields.lastName': 'Last Name',
  'support.fields.email': 'Email',
  'support.fields.subject': 'Subject',
  'support.fields.message': 'Message',
  'support.actions.send': 'Send',
  'support.errors.sendFailed': 'Unable to send',
  'settings.startPage.title': 'Start Page',
  'settings.startPage.description': 'Choose where to go first after you sign in.',
  'settings.startPage.option.welcome': 'Welcome Hub',
  'settings.startPage.option.ua': 'UA Dashboard',
  'settings.startPage.option.adr': 'ADR Dashboard',
  'settings.startPage.option.caseReady': 'ADR Case Ready Dashboard',
  'settings.startPage.option.sf': 'SettleFast Dashboard',
  'settings.startPage.option.adminDashboard': 'Admin Dashboard',
  'settings.startPage.note': 'This preference is saved to your account and used on your next login.',
  'settings.startPage.toast.saved': 'Start page preference saved.',
  'settings.startPage.toast.error': 'Unable to save start page preference.',

  'settings.privacy.title': 'Privacy',
  'settings.privacy.download.title': 'Download My Data',
  'settings.privacy.download.description':
    'This downloads a JSON file containing your account and activity metadata.',
  'settings.privacy.download.cta': 'Download My Data',
  'settings.privacy.delete.title': 'Request Account Deletion',
  'settings.privacy.delete.description':
    'Deleting your account will anonymize your profile and sign you out.',
  'settings.privacy.delete.adminDescription':
    'Contact support to delete this administrative account.',
  'settings.privacy.delete.confirm': 'I understand this cannot be undone.',
  'settings.privacy.delete.cta': 'Request Deletion',
  'legal.subprocessors.title': 'Subprocessors',
  'legal.subprocessors.columns.vendor': 'Vendor',
  'legal.subprocessors.columns.purpose': 'Purpose',
  'legal.subprocessors.columns.dataCategories': 'Data Categories',
  'legal.subprocessors.columns.regions': 'Location/Regions',
  'legal.subprocessors.columns.website': 'Website',
  'legal.subprocessors.disclaimer': 'We will update this list as we add vendors.',
  'admin.billing.title': 'Billing console',
  'admin.billing.subtitle':
    'SuperAdmin tools for managing pricing, credits, subscriptions, and transaction history.',
  'admin.auditReports.title': 'Audit Reports',
  'admin.auditReports.filters.apply': 'Apply',
  'admin.auditReports.filters.clear': 'Clear',
  'admin.auditReports.filters.dateFrom': 'Date From',
  'admin.auditReports.filters.dateTo': 'Date To',
  'admin.auditReports.exportCsv': 'Download CSV',
  'admin.auditReports.columns.when': 'When',
  'admin.auditReports.columns.action': 'Action',
  'admin.auditReports.columns.actor': 'Actor',
  'admin.auditReports.columns.project': 'Project',
  'admin.auditReports.columns.entity': 'Entity',
  'admin.auditReports.columns.correlation': 'Correlation',
  'admin.auditReports.columns.payload': 'Payload',
  'admin.auditReports.payload.view': 'View',
  'admin.auditReports.empty': 'No audits found.',
  'admin.auditReports.loading': 'Loading...',
  'admin.auditReports.loadMore': 'Load more',
  'admin.auditReports.orgRequired': 'Select a company to view audits.',
  'admin.auditReports.orgPlaceholder': 'Select company',
  'admin.billing.adjustCredits': 'Adjust credits',
  'admin.billing.requestFailed': 'Request failed',
  'admin.billing.overview.loadFailedTitle': 'Unable to load overview',
  'admin.billing.pricing.loadFailedTitle': 'Unable to load pricing catalog',
  'admin.billing.subscribers.loadFailedTitle': 'Unable to load subscribers',
  'admin.billing.transactions.loadFailedTitle': 'Unable to load transactions',
  'admin.billing.pricing.updateFailed': 'Failed to update pricing map',
  'admin.billing.transactions.downloadFailed': 'Unable to download CSV',
  'admin.billing.transactions.downloadFailedTitle': 'Download failed',
  'admin.billing.tabs.overview': 'Overview',
  'admin.billing.tabs.transactions': 'Transactions',
  'admin.billing.tabs.subscribers': 'Subscribers',
  'admin.billing.tabs.pricing': 'Pricing & Products',
  'admin.billing.tabs.tools': 'Tools',
  'admin.billing.tabs.promos': 'Promos',
  'admin.billing.promos.title': 'Promo usage',
  'admin.billing.promos.filters.from': 'From',
  'admin.billing.promos.filters.to': 'To',
  'admin.billing.promos.filters.code': 'Promo code',
  'admin.billing.promos.filters.apply': 'Apply',
  'admin.billing.promos.summary.redemptions': 'Redemptions',
  'admin.billing.promos.summary.discount': 'Discounts given',
  'admin.billing.promos.table.redeemedAt': 'Redeemed',
  'admin.billing.promos.table.code': 'Code',
  'admin.billing.promos.table.billingAccountId': 'Billing account',
  'admin.billing.promos.table.discount': 'Discount',
  'admin.billing.promos.table.session': 'Checkout session',
  'admin.billing.promos.empty': 'No promo redemptions found for this range.',
  'admin.billing.promos.loadFailed': 'Unable to load promo redemptions.',
  'admin.billing.promos.pagination.prev': 'Previous',
  'admin.billing.promos.pagination.next': 'Next',
  'admin.learningSupport.pageTitle': 'Learning and Support',
  'admin.learningSupport.subtitle':
    'Manage FAQs, training videos, and the User’s Guide shown to users.',
  'admin.learningSupport.signInPrompt': 'Please sign in to manage learning and support content.',
  'admin.learningSupport.notAuthorized': 'Not authorized',
  'admin.learningSupport.tabs.faqs': 'FAQs',
  'admin.learningSupport.tabs.videos': 'Videos',
  'admin.learningSupport.tabs.userGuide': 'User’s Guide',
  'admin.learningSupport.loading': 'Loading...',
  'admin.learningSupport.addCategory': 'Add Category',
  'admin.learningSupport.confirmDeleteCategory': 'Delete this category?',
  'admin.learningSupport.confirmDeleteFaq': 'Delete this FAQ?',
  'admin.learningSupport.confirmDeleteVideo': 'Delete this video?',
  'admin.learningSupport.faqs.loadCategoriesFailed': 'Failed to load FAQ categories',
  'admin.learningSupport.faqs.loadItemsFailed': 'Failed to load FAQs',
  'admin.learningSupport.faqs.loadFailed': 'Unable to load FAQs',
  'admin.learningSupport.faqs.createCategoryFailed': 'Failed to create category',
  'admin.learningSupport.faqs.updateCategoryFailed': 'Failed to update category',
  'admin.learningSupport.faqs.deleteCategoryFailed': 'Failed to delete category',
  'admin.learningSupport.faqs.createItemFailed': 'Failed to create FAQ',
  'admin.learningSupport.faqs.updateItemFailed': 'Failed to update FAQ',
  'admin.learningSupport.faqs.deleteItemFailed': 'Failed to delete FAQ',
  'admin.learningSupport.faqs.addCategoryTitle': 'Add FAQ Category',
  'admin.learningSupport.faqs.categoryNamePlaceholder': 'Category name',
  'admin.learningSupport.faqs.categoriesTitle': 'FAQ Categories',
  'admin.learningSupport.faqs.addItemTitle': 'Add FAQ',
  'admin.learningSupport.faqs.answerPlaceholder': 'Answer (HTML allowed)',
  'admin.learningSupport.faqs.addItemButton': 'Add FAQ',
  'admin.learningSupport.faqs.itemsTitle': 'FAQs',
  'admin.learningSupport.videos.loadCategoriesFailed': 'Failed to load video categories',
  'admin.learningSupport.videos.loadItemsFailed': 'Failed to load videos',
  'admin.learningSupport.videos.loadFailed': 'Unable to load videos',
  'admin.learningSupport.videos.createCategoryFailed': 'Failed to create category',
  'admin.learningSupport.videos.updateCategoryFailed': 'Failed to update category',
  'admin.learningSupport.videos.deleteCategoryFailed': 'Failed to delete category',
  'admin.learningSupport.videos.createItemFailed': 'Failed to create video',
  'admin.learningSupport.videos.updateItemFailed': 'Failed to update video',
  'admin.learningSupport.videos.deleteItemFailed': 'Failed to delete video',
  'admin.learningSupport.videos.addCategoryTitle': 'Add Video Category',
  'admin.learningSupport.videos.categoryNamePlaceholder': 'Category name',
  'admin.learningSupport.videos.categoriesTitle': 'Video Categories',
  'admin.learningSupport.videos.addItemTitle': 'Add Video',
  'admin.learningSupport.videos.youtubeUrlPlaceholder': 'YouTube URL',
  'admin.learningSupport.videos.addItemButton': 'Add Video',
  'admin.learningSupport.videos.itemsTitle': 'Videos',
  'admin.learningSupport.videos.videoIdLabel': 'Video ID: {id}',
  'admin.learningSupport.videos.playlistIdLabel': 'Playlist ID: {id}',
  'admin.learningSupport.guide.loadFailed': 'Failed to load user guide',
  'admin.learningSupport.guide.selectFile': 'Please select a PDF file to upload.',
  'admin.learningSupport.guide.uploadFailed': 'Upload failed',
  'admin.learningSupport.guide.uploadSuccess': 'User guide uploaded successfully.',
  'admin.learningSupport.guide.filenameLabel': 'Filename: {name}',
  'admin.learningSupport.guide.defaultName': 'User guide',
  'admin.learningSupport.guide.sizeLabel': 'Size: {size} bytes',
  'admin.learningSupport.guide.uploadedLabel': 'Uploaded: {date}',
  'admin.learningSupport.guide.uploadedRecently': 'Recently',
  'admin.learningSupport.guide.viewCurrent': 'View current PDF',
  'admin.learningSupport.guide.comingSoon': 'User’s Guide Is Coming Soon',
  'admin.learningSupport.guide.uploadLabel': 'Upload PDF',
  'admin.learningSupport.guide.uploading': 'Uploading...',
  'admin.learningSupport.guide.uploadButton': 'Upload User’s Guide',
  'learning.faqs.pageTitle': 'FAQs',
  'learning.faqs.title': 'FAQs',
  'learning.faqs.subtitle': 'Find quick answers to common questions.',
  'learning.faqs.empty': 'FAQs Are Coming Soon',
  'learning.faqs.tagsLabel': 'Tags: {tags}',
  'learning.faqs.errors.loadFailed': 'Unable to load FAQs',
  'learning.userGuide.pageTitle': 'User’s Guide',
  'learning.userGuide.title': 'User’s Guide',
  'learning.userGuide.subtitle': 'Review the latest user guide documentation.',
  'learning.userGuide.empty': 'User’s Guide Is Coming Soon',
  'learning.userGuide.lastUpdated': 'Last updated {date}',
  'learning.userGuide.lastUpdatedFallback': 'Last updated recently',
  'learning.userGuide.actions.download': 'Download PDF',
  'learning.userGuide.pdfTitle': 'User guide PDF',
  'learning.userGuide.errors.loadFailed': 'Unable to load user guide',
  'learning.videos.pageTitle': 'Training Videos',
  'learning.videos.title': 'Training and Update Videos',
  'learning.videos.subtitle': 'Learn the latest workflows and product updates.',
  'learning.videos.empty': 'Training Videos Are Coming Soon',
  'learning.videos.watchOnYouTube': 'Watch on YouTube',
  'learning.videos.tagsLabel': 'Tags: {tags}',
  'learning.videos.errors.loadFailed': 'Unable to load videos',
  'feedback.pageTitle': 'Feature Suggestion / Feedback',
  'feedback.title': 'Feature Suggestion / Feedback',
  'feedback.versionLabel': '({version})',
  'feedback.subjectPrefix': 'UA Feature Request {versionLabel}',
  'feedback.appVersionLabel': 'App Version:',
  'feedback.appVersionLine': 'App Version: {version}',
  'feedback.labels.subject': 'Subject',
  'feedback.success': 'Thanks! Your feedback has been sent.',
  'feedback.errors.sendFailed': 'Unable to send',
  'admin.companies.pageTitle': 'Companies',
  'admin.companies.subtitle':
    'Manage company admin assignments for organizations within your scope.',
  'admin.companies.addCompany': 'Add Company',
  'admin.companies.accessRestrictedTitle': 'Access restricted',
  'admin.companies.searchPlaceholder': 'Search companies',
  'admin.companies.sort.nameAsc': 'Name (A–Z)',
  'admin.companies.sort.nameDesc': 'Name (Z–A)',
  'admin.companies.sort.usersDesc': 'Users (High → Low)',
  'admin.companies.sort.usersAsc': 'Users (Low → High)',
  'admin.companies.sort.adminsDesc': 'Admins (High → Low)',
  'admin.companies.sort.newest': 'Newest (Org ID desc)',
  'admin.companies.expandAll': 'Expand All',
  'admin.companies.collapseAll': 'Collapse All',
  'admin.companies.pagination.prev': 'Previous',
  'admin.companies.pagination.next': 'Next',
  'admin.companies.pagination.showingRange': 'Showing {start}–{end}',
  'admin.companies.pagination.pageSize': 'Page size',
  'admin.companies.companyTypeLabel': 'Company Type',
  'admin.companies.companyType.all': 'All',
  'admin.companies.companyType.single': 'Single-user',
  'admin.companies.companyType.multi': 'Multi-user',
  'admin.companies.loading': 'Loading companies…',
  'admin.companies.empty': 'No companies available.',
  'admin.companies.filteredEmpty': 'No companies match the selected filters.',
  'admin.companies.organizationFallback': 'Organization {id}',
  'admin.companies.orgIdLabel': 'Org ID: {id}',
  'admin.companies.userIdLabel': 'User ID: {id}',
  'admin.companies.usersCount': 'Users: {count}',
  'admin.companies.projectsCount': 'Projects: {count}',
  'admin.companies.moduleCounts':
    'UA: {ua} · ADR: {adr} · SettleFast: {settleFast}',
  'admin.companies.adminsSectionTitle': 'Company Admins',
  'admin.companies.assignAdmins': 'Assign Company Admin(s)',
  'admin.companies.adminsEmpty': 'No company admins assigned yet.',
  'admin.companies.usersSectionTitle': 'Company Users',
  'admin.companies.assignUsers': 'Assign User(s)',
  'admin.companies.usersEmpty': 'No users assigned to this company yet.',
  'admin.companies.noName': '(No name)',
  'admin.companies.roleUser': 'User',
  'admin.companies.removeUserAria': 'Remove {email}',
  'admin.companies.assignAdminsTitle': 'Assign Company Admin(s)',
  'admin.companies.assignAdminsSubmit': 'Assign Admins',
  'admin.companies.assignUsersTitle': 'Assign User(s)',
  'admin.companies.assignUsersSubmit': 'Assign Users',
  'admin.companies.createTitle': 'Add Company',
  'admin.companies.editTitle': 'Edit Company',
  'admin.companies.companyNameLabel': 'Company Name',
  'admin.companies.companyNamePlaceholder': 'Enter company name',
  'admin.companies.creating': 'Creating…',
  'admin.companies.saving': 'Saving…',
  'admin.companies.removeTitle': 'Remove company user',
  'admin.companies.removePrompt':
    'Remove {email} (ID {id}) from this company?',
  'admin.companies.removePromptFallback': 'Remove this user from the company?',
  'admin.companies.removeConfirmInstruction': 'Type {word} to confirm.',
  'admin.companies.removing': 'Removing…',
  'admin.companies.confirmRemove': 'Confirm Remove',
  'admin.companies.assigning': 'Assigning…',
  'admin.companies.loadFailed': 'Failed to load companies',
  'admin.companies.requestFailed': 'Request failed',
  'admin.companies.adminAssignFailed': 'Failed to assign company admins.',
  'admin.companies.membersAssignFailed': 'Failed to assign users.',
  'admin.companies.removeFailed': 'Failed to remove user.',
  'admin.companies.createFailed': 'Failed to create company.',
  'admin.companies.updateFailed': 'Failed to update company.',
  'admin.companies.validation.nameRequired': 'Company name is required.',
  'admin.companies.validation.nameTooLong': 'Company name must be 255 characters or less.',
  'admin.companies.validation.duplicateName':
    'An organization with that name already exists.',
  'admin.companies.userSearch.label': 'Search users (name, email, or ID)',
  'admin.companies.userSearch.placeholder': 'Search by name, email, or ID',
  'admin.companies.userSearch.searching': 'Searching users…',
  'admin.companies.userSearch.resultSingle': '{count} result',
  'admin.companies.userSearch.resultMultiple': '{count} results',
  'admin.companies.userSearch.prompt': 'Enter a search term to find users.',
  'admin.companies.userSearch.noResults': 'No users found.',
  'admin.companies.userSearch.selectedCount': 'Selected: {count}',
  'admin.companies.userSearch.selectedUserLine': '{name} · {email} · ID {id}',
  'admin.companies.userSearch.noneSelected': 'No users selected yet.',
  'admin.companies.userSearch.fetchFailed': 'Unable to fetch users',
  'admin.companyBilling.pageTitle': 'Company Billing',
  'admin.companyBilling.subtitle':
    'Manage your company billing, payment method, and subscription plan.',
  'admin.companyBilling.managedByAdmin': 'Billing is managed by your Company Admin.',
  'admin.companyBilling.orgIdRequired':
    'Please provide an org_id in the URL to view company billing details.',
  'admin.companyBilling.loadFailed': 'Failed to load data',
  'admin.companyBilling.loadFailedDescription':
    'Unable to load organization billing information. Please refresh to try again.',
  'admin.companyBilling.noBillingInfo': 'No billing information available.',
  'admin.companyBilling.tabs.overview': 'Overview',
  'admin.companyBilling.tabs.payment': 'Payment Method',
  'admin.companyBilling.tabs.plans': 'Plans & Credits',
  'admin.companyBilling.tabs.history': 'Invoice Activity',
  'admin.companyBilling.cards.credits': 'Credits',
  'admin.companyBilling.creditsSummary': 'Free: {free} · Prepaid: {prepaid}',
  'admin.companyBilling.cards.defaultCard': 'Default card',
  'admin.companyBilling.defaultCardNone': 'No default card on file',
  'admin.companyBilling.defaultCardFallback': 'Card',
  'admin.companyBilling.cardLastFour': '•••• {last4}',
  'admin.companyBilling.cardExpiry': 'exp. {month}/{year}',
  'admin.companyBilling.cards.subscriptionStatus': 'Subscription status',
  'admin.companyBilling.subscription.none': 'No subscription',
  'admin.companyBilling.subscription.activeCanceling': 'Active (canceling)',
  'admin.companyBilling.subscription.active': 'Active',
  'admin.companyBilling.subscription.trialing': 'Trialing',
  'admin.companyBilling.subscription.pastDue': 'Past due',
  'admin.companyBilling.subscription.unpaid': 'Unpaid',
  'admin.companyBilling.subscription.incomplete': 'Incomplete',
  'admin.companyBilling.subscription.canceled': 'Canceled',
  'admin.companyBilling.subscription.unknown': 'Unknown',
  'admin.companyBilling.currentPeriodRange': 'Current period: {start} – {end}',
  'admin.companyBilling.currentPeriodSingle': 'Current period: {start}',
  'admin.companyBilling.seatsSummary': 'Included: {included} · Invites: {invites}',
  'admin.companyBilling.seatOverageNotice': '{count} overage seats will be billed at renewal.',
  'admin.companyBilling.paymentMethodTitle': 'Payment method',
  'admin.companyBilling.stripeNotConfigured':
    'Stripe is not configured. Set NEXT_PUBLIC_STRIPE to enable payment method management.',
  'admin.companyBilling.plansTitle': 'Plans & Credits',
  'admin.companyBilling.plansSubtitle': 'Choose a subscription plan or buy project credits.',
  'admin.companyBilling.viewPlansCta': 'View Plans / Buy Credits',
  'admin.companyBilling.plansPickerLabel': 'PlansPicker (admin/company-billing)',
  'admin.companyBilling.invoiceActivityTitle': 'Invoice activity',
  'admin.companyBilling.promoCodes.title': 'Promo Codes',
  'admin.companyBilling.promoCodes.loadFailed': 'Unable to load promo codes.',
  'admin.companyBilling.promoCodes.syncButton': 'Sync from Stripe',
  'admin.companyBilling.promoCodes.syncSuccess': 'Sync completed.',
  'admin.companyBilling.promoCodes.syncFailed': 'Sync failed.',
  'admin.companyBilling.promoCodes.createTitle': 'Create Promo Code',
  'admin.companyBilling.promoCodes.codeLabel': 'Code',
  'admin.companyBilling.promoCodes.percentOffLabel': 'Percent off',
  'admin.companyBilling.promoCodes.startsAtLabel': 'Starts',
  'admin.companyBilling.promoCodes.endsAtLabel': 'Ends',
  'admin.companyBilling.promoCodes.activeLabel': 'Active',
  'admin.companyBilling.promoCodes.notesLabel': 'Notes',
  'admin.companyBilling.promoCodes.createButton': 'Create',
  'admin.companyBilling.promoCodes.creatingButton': 'Creating…',
  'admin.companyBilling.promoCodes.createFailed': 'Unable to create promo code.',
  'admin.companyBilling.promoCodes.tableCode': 'Code',
  'admin.companyBilling.promoCodes.tableDiscount': 'Discount',
  'admin.companyBilling.promoCodes.tableWindow': 'Window',
  'admin.companyBilling.promoCodes.tableActive': 'Active',
  'admin.companyBilling.promoCodes.tableRedemptions': 'Redemptions',
  'admin.companyBilling.promoCodes.tableLastRedeemed': 'Last redeemed',
  'admin.companyBilling.promoCodes.tableStripeId': 'Stripe ID',
  'admin.companyBilling.promoCodes.enable': 'Enable',
  'admin.companyBilling.promoCodes.disable': 'Disable',
  'admin.companyBilling.promoCodes.empty': 'No promo codes yet.',
  'admin.companyUsers.pageTitle': 'Company Users',
  'admin.companyUsers.subtitle':
    'View the users within your organizations along with their current modules and status flags.',
  'admin.companyUsers.companyLabel': 'Company',
  'admin.companyUsers.companyPlaceholder': 'Select a company',
  'admin.companyUsers.selectCompanyHint': 'Select a company to view users and billing.',
  'admin.companyUsers.selectCompanyRequired': 'Please select a company.',
  'admin.companyUsers.companiesLoadFailed': 'Failed to load companies',
  'admin.companyUsers.inviteButton': 'Invite team member',
  'admin.companyUsers.inviteModalTitle': 'Invite team member',
  'admin.companyUsers.inviteSendButton': 'Send invite',
  'admin.companyUsers.overviewTitle': 'Organization overview',
  'admin.companyUsers.overviewUsersTotal': 'Total users',
  'admin.companyUsers.overviewUsersActive': 'Active users',
  'admin.companyUsers.overviewUsersAuthorized': 'Authorized users',
  'admin.companyUsers.overviewRolesBreakdown': 'Roles',
  'admin.companyUsers.overviewInvitesPending': 'Pending invites',
  'admin.companyUsers.overviewInvitesOldest': 'Oldest pending invite',
  'admin.companyUsers.overviewSeats': 'Seats',
  'admin.companyUsers.overviewProjects': 'Projects',
  'admin.companyUsers.overviewProjectsByStatus': 'By status',
  'admin.companyUsers.activityTitle': 'Recent activity',
  'admin.companyUsers.activityFilterAll': 'All',
  'admin.companyUsers.activityFilterInvites': 'Invites',
  'admin.companyUsers.activityFilterProjects': 'Projects',
  'admin.companyUsers.activityFilterAuth': 'Auth',
  'admin.companyUsers.activityEmpty': 'No recent activity.',
  'admin.companyUsers.activityLoadMore': 'Load more',
  'admin.companyUsers.activityProjectId': 'Project ID: {{id}}',
  'admin.companyUsers.activityInvitee': 'Invitee: {{email}}',
  'admin.companyUsers.accessRestricted': 'Access restricted',
  'admin.companyUsers.contactAdmin': 'Contact your Company Admin to manage users and billing.',
  'admin.companyUsers.rolesLoadFailed': 'Failed to load roles',
  'admin.companyUsers.rolesLoadFailedDescription': 'Unable to load roles',
  'admin.companyUsers.requestFailed': 'Request failed',
  'admin.companyUsers.loadFailed': 'Failed to load company users',
  'admin.companyUsers.resetLinkFailed': 'Failed to send reset link',
  'admin.companyUsers.resetLinkSent': 'Reset link sent to {email}',
  'admin.companyUsers.resetLinkCreated':
    'Reset link created (email not sent). Copy link: {link}',
  'admin.companyUsers.inviteOrgRequired': 'Organization context is required to send an invite.',
  'admin.companyUsers.inviteFailed': 'Failed to send invite',
  'admin.companyUsers.inviteSentTitle': 'Invite sent',
  'admin.companyUsers.inviteSentMessage': 'Invite sent.',
  'admin.companyUsers.seatSyncWarning': 'Seat billing may be out of sync: {message}',
  'admin.companyUsers.seatCountBillingNotice':
    'Seats will be billed at next renewal based on seat count.',
  'admin.companyUsers.cancelInviteFailed': 'Failed to cancel invite',
  'admin.companyUsers.inviteCanceledTitle': 'Invite canceled',
  'admin.companyUsers.inviteRevoked': 'Invite revoked successfully.',
  'admin.companyUsers.cancelFailedTitle': 'Cancel failed',
  'admin.companyUsers.referralEnsureFailed': 'Failed to ensure referral code',
  'admin.companyUsers.referralCodeGenerated': 'Referral code generated: {code}',
  'admin.companyUsers.referralCodeExists': 'Referral code already present: {code}',
  'admin.companyUsers.seatsUsed': 'Seats used',
  'admin.companyUsers.seatsMembersInvites': 'Members: {members} · Invites: {invites}',
  'admin.companyUsers.includedSeats': 'Included seats',
  'admin.companyUsers.seatAddonQty': 'Seat add-on qty: {count}',
  'admin.companyUsers.seatOverage': 'Seat overage',
  'admin.companyUsers.seatsBilledAtRenewal': 'Seats billed at renewal.',
  'admin.companyUsers.inviteUserTitle': 'Invite User',
  'admin.companyUsers.inviteUserSubtitle': 'Send an invite to join your organization.',
  'admin.companyUsers.companyOptional': 'Company (optional)',
  'admin.companyUsers.roleOptional': 'Role (optional)',
  'admin.companyUsers.selectRole': 'Select a role',
  'admin.companyUsers.inviteSending': 'Sending…',
  'admin.companyUsers.sendInvite': 'Send invite',
  'admin.companyUsers.pendingInvitesTitle': 'Pending Invites',
  'admin.companyUsers.pendingInvitesCount': '{count} open',
  'admin.companyUsers.inviteFallback': 'Invite',
  'admin.companyUsers.inviteRoleLabel': 'Role: {role}',
  'admin.companyUsers.inviteExpiresLabel': 'Expires: {date}',
  'admin.companyUsers.inviteNeverExpires': 'Never',
  'admin.companyUsers.inviteCanceling': 'Canceling…',
  'admin.companyUsers.cancelInvite': 'Cancel invite',
  'admin.companyUsers.noPendingInvites': 'No pending invites.',
  'admin.companyUsers.loadingUsers': 'Loading users…',
  'admin.companyUsers.noUsersFound': 'No users found.',
  'admin.companyUsers.table.orgId': 'Org ID',
  'admin.companyUsers.table.statusFlags': 'Status Flags',
  'admin.companyUsers.table.activeSubscriber': 'Active Subscriber',
  'admin.companyUsers.table.freeCredits': 'Free Credits (Used / Avail)',
  'admin.companyUsers.table.paidCredits': 'Paid Credits (Used / Avail)',
  'admin.companyUsers.activeSubscriberYes': 'Yes',
  'admin.companyUsers.viewBillingHistory': 'View billing history',
  'admin.companyUsers.noBillingAccount': 'No billing account',
  'admin.companyUsers.resetSending': 'Sending…',
  'admin.companyUsers.sendResetLink': 'Send reset link',
  'admin.companyUsers.referralGenerating': 'Generating…',
  'admin.companyUsers.generateReferralCode': 'Generate referral code',
  'admin.companyUsers.modules.ua': 'UA',
  'admin.companyUsers.modules.adr': 'ADR',
  'admin.companyUsers.modules.settleFast': 'SettleFast',
  'invoiceCenter.pageTitle': 'Invoice Center',
  'invoiceCenter.pageTitleWithModule': 'Invoice Center — {module}',
  'rates.pageTitleWithModule': 'Rates — {module}',
  'invoiceCenter.subtitle': 'Manage project invoices and payments.',
  'invoiceCenter.defaultsHelper':
    'Billing Defaults prefill new invoices and will fill missing defaults on existing draft invoices.',
  'invoiceCenter.defaultsHint':
    'Set Billing Defaults and Invoice Profile once — they prefill invoices and fix missing defaults on draft invoices.',
  'invoiceCenter.billingDefaultsButton': 'Billing Defaults (Rates & Minimums)',
  'invoiceCenter.invoiceProfileButton': 'Invoice Profile (Payee, Address, Logo)',
  'invoiceCenter.status.billingDefaults': 'Billing Defaults: {state}',
  'invoiceCenter.status.invoiceProfile': 'Invoice Profile: {state}',
  'invoiceCenter.status.standardLogo': 'Standard Logo: {state}',
  'invoiceCenter.status.configured': 'Configured',
  'invoiceCenter.status.notConfiguredDefaults': 'Not configured (defaults)',
  'invoiceCenter.status.notConfigured': 'Not configured',
  'invoiceCenter.status.uploaded': 'Uploaded',
  'invoiceCenter.status.notUploaded': 'Not uploaded',
  'invoiceCenter.filters.scope': 'Scope',
  'invoiceCenter.filters.workflowStatus': 'Workflow Status',
  'invoiceCenter.filters.balanceDueOnly': 'Balance Due Only',
  'invoiceCenter.filters.all': 'All',
  'invoiceCenter.scope.mine': 'Mine',
  'invoiceCenter.scope.organization': 'Organization',
  'invoiceCenter.scope.all': 'All',
  'invoiceCenter.searchPlaceholder': 'Invoice # or Project',
  'invoiceCenter.table.lastPaymentDate': 'Last Payment Date',
  'invoiceCenter.loading': 'Loading invoices...',
  'invoiceCenter.empty': 'No invoices found.',
  'invoiceCenter.projectFallback': 'Project #{id}',
  'invoiceCenter.actions.payments': 'Payments',
  'invoiceCenter.errors.loadFailed': 'Failed to load',
  'invoiceCenter.errors.loadInvoices': 'Failed to load invoices. Please refresh.',
  'invoiceCenter.errors.sessionExpired': 'Session expired. Please log in again.',
  'invoiceCenter.errors.updateInvoiceStatus': 'Failed to update invoice status. Please try again.',
  'invoiceCenter.errors.updateWorkflowStatus': 'Failed to update workflow status.',
  'invoiceCenter.settings.title': 'Invoice Billing Settings',
  'invoiceCenter.settings.billingModeLabel': 'Billing Mode (Hourly vs Flat)',
  'invoiceCenter.settings.billingMode.hourly': 'Hourly',
  'invoiceCenter.settings.billingMode.flat': 'Flat',
  'invoiceCenter.settings.fields.hourlyRate': 'Hourly Rate',
  'invoiceCenter.settings.fields.minBillingMinutes': 'Minimum Billing Minutes',
  'invoiceCenter.settings.fields.retainer': 'Retainer',
  'invoiceCenter.settings.fields.retainerDisplay': 'Retainer display on invoice',
  'invoiceCenter.settings.flatDisplay.time': 'Include time details on invoice',
  'invoiceCenter.settings.flatDisplay.fee': 'Show retainer line only',
  'invoiceCenter.settings.fields.mileageRate': 'Mileage rate ($/mile)',
  'invoiceCenter.settings.actions.save': 'Save Settings',
  'invoiceCenter.settings.errors.hourlyRate': 'Hourly rate must be a non-negative number.',
  'invoiceCenter.settings.errors.minBillingMinutes':
    'Minimum billing minutes must be an integer of 1 or more.',
  'invoiceCenter.settings.errors.projectFee': 'Project fee must be a non-negative number.',
  'invoiceCenter.settings.errors.mileageRate': 'Mileage rate must be a non-negative number.',
  'invoiceCenter.settings.errors.saveFailed': 'Failed to save invoice settings.',
  'invoiceCenter.rateSettings.title': 'Billing Defaults (Rates & Minimums)',
  'invoiceCenter.rateSettings.subtitle':
    'These defaults prefill new invoices for the selected module.',
  'invoiceCenter.rateSettings.fields.hourlyRate': 'Hourly rate (default)',
  'invoiceCenter.rateSettings.fields.flatRate': 'Flat project fee (default)',
  'invoiceCenter.rateSettings.fields.mileageRate': 'Mileage rate ($/mile) (default)',
  'invoiceCenter.rateSettings.fields.minBillingMinutes': 'Minimum billing (minutes)',
  'invoiceCenter.rateSettings.fields.defaultBillingMode': 'Default billing mode for new invoices',
  'invoiceCenter.rateSettings.saved': 'Billing settings saved',
  'invoiceCenter.rateSettings.errors.loadFailed': 'Failed to load',
  'invoiceCenter.rateSettings.errors.saveFailed': 'Failed to save',
  'invoiceCenter.rateSettings.errors.minBillingMinutes':
    'Minimum billing minutes must be an integer between 1 and 240',
  'invoiceCenter.recipients.title': 'Invoice Recipients',
  'invoiceCenter.recipients.types.carrier': 'Carrier',
  'invoiceCenter.recipients.types.insured': 'Insured',
  'invoiceCenter.recipients.types.other': 'Other',
  'invoiceCenter.recipients.emptyOther': 'No other recipients yet.',
  'invoiceCenter.recipients.newRecipient': 'New Recipient',
  'invoiceCenter.recipients.defaultBadge': 'Default',
  'invoiceCenter.recipients.actions.addOther': '+ Add Other Recipient',
  'invoiceCenter.recipients.actions.setDefault': 'Set Default',
  'invoiceCenter.recipients.fields.companyName': 'Company name',
  'invoiceCenter.recipients.fields.attentionTo': 'Attention to',
  'invoiceCenter.recipients.fields.addressLine1': 'Address line 1',
  'invoiceCenter.recipients.fields.addressLine2': 'Address line 2',
  'invoiceCenter.recipients.fields.city': 'City',
  'invoiceCenter.recipients.fields.state': 'State',
  'invoiceCenter.recipients.fields.zip': 'Zip',
  'invoiceCenter.recipients.toast.saved': 'Recipient saved',
  'invoiceCenter.recipients.toast.deleted': 'Recipient deleted',
  'invoiceCenter.recipients.toast.saveFailed': 'Failed to save recipient',
  'invoiceCenter.recipients.toast.deleteFailed': 'Failed to delete recipient',
  'invoiceCenter.recipients.errors.loadFailed': 'Failed to load',
  'invoiceCenter.recipients.errors.saveFailed': 'Failed to save recipient',
  'invoiceCenter.recipients.errors.deleteFailed': 'Failed to delete recipient',
  'invoicePdf.title': 'INVOICE',
  'invoicePdf.meta.invoiceNumber': 'Invoice #{number}',
  'invoicePdf.meta.invoiceIdSuffix': ' (ID: {id})',
  'invoicePdf.meta.date': 'Date: {date}',
  'invoicePdf.meta.projectName': 'Project Name: {name}',
  'invoicePdf.meta.claimNumber': 'Claim Number: {number}',
  'invoicePdf.table.description': 'DESCRIPTION',
  'invoicePdf.table.startDateTime': 'START DATE & TIME',
  'invoicePdf.table.endDateTime': 'END DATE & TIME',
  'invoicePdf.table.timeSpent': 'TIME SPENT',
  'invoicePdf.table.price': 'PRICE',
  'invoicePdf.table.defaultDescription': 'Application time',
  'invoicePdf.table.includedInFlatFee': 'Included in flat fee',
  'invoicePdf.table.notApplicable': 'N/A',
  'invoicePdf.table.total': 'TOTAL:',
  'invoicePdf.summary.title': 'SUMMARY',
  'invoicePdf.summary.totalTime': 'TOTAL TIME:',
  'invoicePdf.summary.totalAmount': 'TOTAL AMOUNT:',
  'invoicePdf.summary.timeBilled': 'Time billed: {hours} hours @ ${rate}/hr',
  'invoicePdf.summary.flatProjectFee': 'Flat project fee:',
  'invoiceCenter.workflow.projectStarted': 'Project Started',
  'invoiceCenter.workflow.depositReceived': 'Deposit Received',
  'invoiceCenter.workflow.projectInProgress': 'Project in Progress',
  'invoiceCenter.workflow.projectComplete': 'Project Complete',
  'invoiceCenter.workflow.balanceDue': 'Balance Due',
  'invoiceCenter.workflow.paidAndClosed': 'Paid and Closed',
  'invoiceCenter.module.ua': 'Umpire Assistant',
  'invoiceCenter.module.adr': 'ADR',
  'invoiceCenter.module.settleFast': 'SettleFast',
  'invoiceCenter.addPayment.title': 'Payments',
  'invoiceCenter.addPayment.ledgerTitle': 'Payment Ledger',
  'invoiceCenter.addPayment.linkedExport': 'Linked to export #{id}',
  'invoiceCenter.addPayment.noPayments': 'No payments recorded yet.',
  'invoiceCenter.addPayment.loadFailed': 'Failed to load',
  'invoiceCenter.addPayment.addCreditTitle': 'Add Credit / Refund',
  'invoiceCenter.addPayment.addPaymentTitle': 'Add Payment',
  'invoiceCenter.addPayment.markPaidAfter': 'Mark export as paid after recording this payment',
  'invoiceCenter.addPayment.paymentDate': 'Payment date',
  'invoiceCenter.addPayment.entryType': 'Entry Type',
  'invoiceCenter.addPayment.entryTypePayment': 'Payment',
  'invoiceCenter.addPayment.entryTypeCredit': 'Credit / Refund',
  'invoiceCenter.addPayment.otherMethodLabel': 'Other method label',
  'invoiceCenter.addPayment.recordCredit': 'Record Credit/Refund',
  'invoiceCenter.addPayment.recordPayment': 'Record Payment',
  'invoiceCenter.addPayment.method.ach': 'ACH',
  'invoiceCenter.addPayment.method.check': 'Check',
  'invoiceCenter.addPayment.method.zelle': 'Zelle',
  'invoiceCenter.addPayment.method.creditCard': 'Credit Card',
  'invoiceCenter.addPayment.method.wire': 'Wire',
  'invoiceCenter.addPayment.method.other': 'Other',
  'invoiceCenter.addPayment.methodWithLabel': ' ({label})',
  'invoiceCenter.addPayment.validation.paymentDateRequired': 'Payment date is required',
  'invoiceCenter.addPayment.validation.amountPositive': 'Amount must be greater than 0',
  'invoiceCenter.addPayment.validation.otherMethodRequired': 'Other method label is required',
  'invoiceCenter.addPayment.saveFailed': 'Failed to save',
  'invoiceCenter.addPayment.markPaidFailed': 'Failed to mark export paid',
  'invoiceCenter.addPayment.creditRecorded': 'Credit recorded',
  'invoiceCenter.addPayment.creditRecordedExport': 'Credit recorded for export',
  'invoiceCenter.addPayment.paymentRecorded': 'Payment recorded',
  'invoiceCenter.addPayment.paymentRecordedExport': 'Payment recorded for export',
  'invoiceCenter.generalSettings.title': 'Invoice Profile (Payee, Address, Logo)',
  'invoiceCenter.generalSettings.loading': 'Loading invoice settings...',
  'invoiceCenter.generalSettings.unauthorized':
    'Unauthorized. Please sign in to manage invoice settings.',
  'invoiceCenter.generalSettings.loadFailed': 'Failed to load settings',
  'invoiceCenter.generalSettings.saveSuccess': 'Invoice settings saved.',
  'invoiceCenter.generalSettings.saveFailedTitle': 'Save failed',
  'invoiceCenter.generalSettings.saveFailed': 'Failed to save settings',
  'invoiceCenter.generalSettings.uploading': 'Uploading…',
  'invoiceCenter.generalSettings.logoUploaded': 'Logo uploaded.',
  'invoiceCenter.generalSettings.uploadFailedTitle': 'Upload failed',
  'invoiceCenter.generalSettings.uploadFailed': 'Upload failed.',
  'invoiceCenter.generalSettings.issuerTitle': 'Issuer details',
  'invoiceCenter.generalSettings.issuerSubtitle':
    'Defaults used for invoice “From” and payable-to information.',
  'invoiceCenter.generalSettings.companyName': 'Company name',
  'invoiceCenter.generalSettings.makePayableTo': 'Make payable to',
  'invoiceCenter.generalSettings.addressLine1': 'Address line 1',
  'invoiceCenter.generalSettings.addressLine2': 'Address line 2',
  'invoiceCenter.generalSettings.city': 'City',
  'invoiceCenter.generalSettings.state': 'State',
  'invoiceCenter.generalSettings.zip': 'ZIP',
  'invoiceCenter.generalSettings.paymentInstructionsTitle': 'Payment Instructions',
  'invoiceCenter.generalSettings.paymentInstructionsSubtitle':
    'Add payment instructions for invoices (e.g., ACH, check, wire).',
  'invoiceCenter.generalSettings.noPaymentMethods': 'No payment methods added yet.',
  'invoiceCenter.generalSettings.methodLabel': 'Method label',
  'invoiceCenter.generalSettings.methodDetails': 'Details',
  'invoiceCenter.generalSettings.addPaymentMethod': 'Add payment method',
  'invoiceCenter.generalSettings.logoPreferencesTitle': 'Logo preferences',
  'invoiceCenter.generalSettings.logoPreferencesSubtitle': 'Choose how invoice logos are selected.',
  'invoiceCenter.generalSettings.logoPreferencesNote':
    'Prefer project logo uses the project’s logo when set; otherwise it falls back to the standard logo.',
  'invoiceCenter.generalSettings.logoPreferenceProject':
    'Prefer project logo when available (use standard logo as fallback)',
  'invoiceCenter.generalSettings.logoPreferenceStandard': 'Always use standard logo',
  'invoiceCenter.generalSettings.standardLogoLabel': 'Standard logo',
  'invoiceCenter.generalSettings.standardLogoHelper':
    'Upload a standard logo. If a project doesn’t have a logo, this standard logo will be used as a fallback.',
  'invoiceCenter.generalSettings.uploadFileLabel': 'File: {name}',
  'invoiceCenter.generalSettings.standardLogoFallback':
    'Standard Logo (used as fallback when a project has no logo)',
  'invoiceCenter.generalSettings.standardLogoAlt': 'Standard logo',
  'invoiceCenter.generalSettings.saveButton': 'Save settings',
  'invoiceCenter.detailModal.title': 'Invoice Detail',
  'invoiceCenter.detailModal.loading': 'Loading invoice detail...',
  'invoiceCenter.detailModal.loadFailed': 'Failed to load',
  'invoiceCenter.detailModal.errors.loadInvoice': 'Failed to load invoice detail.',
  'invoiceCenter.detailModal.errors.loadExportHistory': 'Failed to load export history.',
  'invoiceCenter.detailModal.errors.updateExport': 'Failed to update export',
  'invoiceCenter.detailModal.errors.updateExportStatus': 'Failed to update export status',
  'invoiceCenter.detailModal.errors.sessionExpired': 'Session expired. Please log in again.',
  'invoiceCenter.detailModal.errors.updateWorkflowStatus': 'Failed to update workflow status.',
  'invoiceCenter.detailModal.errors.updateInvoiceStatus':
    'Failed to update invoice status. Please try again.',
  'invoiceCenter.detailModal.projectFallback': 'Project #{id}',
  'invoiceCenter.detailModal.invoiceNumber': 'Invoice #{number}',
  'invoiceCenter.detailModal.workflowStatus': 'Workflow Status',
  'invoiceCenter.detailModal.workflow.projectStarted': 'Project Started',
  'invoiceCenter.detailModal.workflow.retainerReceived': 'Retainer Received',
  'invoiceCenter.detailModal.workflow.projectInProgress': 'Project in Progress',
  'invoiceCenter.detailModal.workflow.projectComplete': 'Project Complete',
  'invoiceCenter.detailModal.workflow.balanceDue': 'Balance Due',
  'invoiceCenter.detailModal.workflow.paidAndClosed': 'Paid and Closed',
  'invoiceCenter.detailModal.actions.payments': 'Payments',
  'invoiceCenter.detailModal.actions.generatePdf': 'Generate Invoice PDF',
  'invoiceCenter.detailModal.actions.recipients': 'Recipients',
  'invoiceCenter.detailModal.actions.addExpense': 'Add Expense',
  'invoiceCenter.detailModal.actions.invoiceSettings': 'Invoice Settings',
  'invoiceCenter.detailModal.actions.openProject': 'Open Project',
  'invoiceCenter.detailModal.actions.openFinalInvoice': 'Open Final Invoice',
  'invoiceCenter.detailModal.actions.downloadPdf': 'Download PDF',
  'invoiceCenter.detailModal.actions.recordPayment': 'Record Payment',
  'invoiceCenter.detailModal.actions.markPaid': 'Mark Paid',
  'invoiceCenter.detailModal.actions.markSent': 'Mark Sent',
  'invoiceCenter.detailModal.actions.void': 'Void',
  'invoiceCenter.detailModal.recipientsHintReady':
    'Generates a PDF and creates an Issued Invoice record below.',
  'invoiceCenter.detailModal.recipientsHintMissing':
    'Tip: Add Invoice Recipients before sending so PDFs include the right contact details.',
  'invoiceCenter.detailModal.issuedInvoicesTitle': 'Issued Invoices',
  'invoiceCenter.detailModal.issuedInvoicesHelper':
    'Workflow Status tracks your project/invoice lifecycle.',
  'invoiceCenter.detailModal.issuedInvoicesHelperStatus':
    'Issued Invoices track generated PDFs and their Sent/Paid/Void status.',
  'invoiceCenter.detailModal.noExports': 'No exports issued yet.',
  'invoiceCenter.detailModal.exportNumber': 'Export #',
  'invoiceCenter.detailModal.recipient': 'Recipient',
  'invoiceCenter.detailModal.type': 'Type',
  'invoiceCenter.detailModal.issued': 'Issued',
  'invoiceCenter.detailModal.sent': 'Sent',
  'invoiceCenter.detailModal.paidDate': 'Paid',
  'invoiceCenter.detailModal.exportStatus.issued': 'Issued',
  'invoiceCenter.detailModal.exportStatus.sent': 'Sent',
  'invoiceCenter.detailModal.exportStatus.paid': 'Paid',
  'invoiceCenter.detailModal.exportStatus.void': 'Void',
  'invoiceCenter.detailModal.recipient.carrier': 'Carrier',
  'invoiceCenter.detailModal.recipient.insured': 'Insured',
  'invoiceCenter.detailModal.recipient.other': 'Other',
  'invoiceCenter.detailModal.exportType.full': 'Full',
  'invoiceCenter.detailModal.exportType.deposit': 'Deposit',
  'invoiceCenter.detailModal.exportType.custom': 'Custom',
  'invoiceCenter.detailModal.exportType.retainer': 'Retainer',
  'invoiceCenter.detailModal.exportType.retainerDeposit': 'Retainer Deposit',
  'invoiceCenter.detailModal.lastPayment': 'Last Payment',
  'invoiceCenter.detailModal.timeLineItems': 'Time Line Items',
  'invoiceCenter.detailModal.noTimeEntries': 'No time entries recorded.',
  'invoiceCenter.detailModal.duration': 'Duration',
  'invoiceCenter.detailModal.billedDuration': 'Billed Duration',
  'invoiceCenter.detailModal.durationZero': '0m',
  'invoiceCenter.detailModal.durationHoursMinutes': '{hours}h {minutes}m',
  'invoiceCenter.detailModal.durationMinutes': '{minutes}m',
  'invoiceCenter.detailModal.retainerTitle': 'Retainer',
  'invoiceCenter.detailModal.retainerLine': 'Retainer',
  'invoiceCenter.detailModal.expenseLineItems': 'Expense Line Items',
  'invoiceCenter.detailModal.noExpenses': 'No expenses recorded.',
  'billing.account.pageTitle': 'Subscription & Billing',
  'billing.account.subtitle':
    'Manage your payment method, subscription, and view your billing history.',
  'billing.account.tabs.overview': 'Overview',
  'billing.account.tabs.paymentMethod': 'Payment Method',
  'billing.account.tabs.plansCredits': 'Plans & Credits',
  'billing.account.tabs.invoiceActivity': 'Invoice Activity',
  'billing.account.companyManaged': 'Billing is managed by your Company Admin.',
  'billing.account.companyManagedHelp':
    'Contact your admin if you need changes to billing or plan access.',
  'billing.account.loadError':
    'Unable to load billing information. Please refresh the page to try again.',
  'billing.account.loadFailed': 'Failed to load data',
  'billing.account.credits.projectCredits': 'Project credits',
  'billing.account.credits.free': 'Free',
  'billing.account.credits.prepaid': 'Prepaid',
  'billing.account.credits.subscription': 'Subscription',
  'billing.account.credits.usage': '{used}/{assigned} used • {remaining} left',
  'billing.account.credits.subscriptionUnlimited': 'Unlimited • {used} created',
  'billing.account.credits.notActive': 'Not active',
  'billing.account.credits.helper':
    'Free credits apply before subscriptions or pay-as-you-go charges.',
  'billing.account.credits.remaining': 'Credits remaining',
  'billing.account.defaultCard.title': 'Default card',
  'billing.account.defaultCard.none': 'No default card on file',
  'billing.account.defaultCard.brandFallback': 'Card',
  'billing.account.defaultCard.expiration': 'exp. {month}/{year}',
  'billing.account.defaultCard.helper':
    'Update your card below to change where charges are billed.',
  'billing.account.subscription.title': 'Subscription status',
  'billing.account.subscription.status.none': 'No subscription',
  'billing.account.subscription.status.activeCanceling': 'Active (canceling)',
  'billing.account.subscription.status.active': 'Active',
  'billing.account.subscription.status.trialing': 'Trialing',
  'billing.account.subscription.status.pastDue': 'Past due',
  'billing.account.subscription.status.unpaid': 'Unpaid',
  'billing.account.subscription.status.incomplete': 'Incomplete',
  'billing.account.subscription.status.canceled': 'Canceled',
  'billing.account.subscription.status.unknown': 'Unknown',
  'billing.account.subscription.periodStarted': 'Current period started {date}',
  'billing.account.subscription.renews': 'Renews {date}',
  'billing.account.payment.title': 'Payment method',
  'billing.account.payment.stripeMissing':
    'Stripe publishable key is not configured. Payment method updates are disabled.',
  'billing.account.plans.title': 'Plans & Credits',
  'billing.account.plans.subtitle': 'Choose a subscription plan or buy project credits.',
  'billing.account.plans.cta': 'View Plans / Buy Credits',
  'billing.account.plansPickerLabel': 'PlansPicker (account/billing)',
  'billing.account.history.title': 'Invoice activity',
  'billing.page.title': 'Billing Plans',
  'billing.page.success': 'Billing updated. You can continue.',
  'billing.page.dismiss': 'Dismiss',
  'billing.page.plansPickerLabel': 'PlansPicker (billing/index)',
  'billing.page.continue': 'Continue',
  'billing.page.limitReached.heading': "You've reached your project limit",
  'billing.page.limitReached.body':
    'Upgrade to Unlimited or buy additional project credits to continue.',
  'billing.page.limitReached.upgradeCta': 'Upgrade to Unlimited',
  'billing.page.limitReached.buyCreditsCta': 'Buy Project Credits',
  'billing.plansPicker.term.monthly': 'Monthly',
  'billing.plansPicker.term.annualMonthly': 'Annual Paid Monthly',
  'billing.plansPicker.term.annualUpfront': 'Annual',
  'billing.plansPicker.tier.solo': 'Solo',
  'billing.plansPicker.tier.starter': 'Starter',
  'billing.plansPicker.tier.established': 'Established',
  'billing.plansPicker.tier.growth': 'Growth',
  'billing.plansPicker.tier.scaling': 'Scaling',
  'billing.plansPicker.notice.paymentMethod':
    'You may be prompted to add a payment method during checkout.',
  'billing.plansPicker.tabs.creditPacks': 'Credit Packs',
  'billing.plansPicker.tabs.subscriptions': 'Subscriptions',
  'billing.plansPicker.warnings.paygUnavailable':
    'Pay-as-you-go credit packs are not enabled for this account.',
  'billing.plansPicker.warnings.subscriptionUnavailable':
    'Subscriptions are not enabled for this account.',
  'billing.plansPicker.pack.label': 'Credit Pack',
  'billing.plansPicker.pack.projects': '{count} Project{suffix}',
  'billing.plansPicker.pack.creditsFallback': 'Credits',
  'billing.plansPicker.pack.bestValue': 'Best value',
  'billing.plansPicker.pack.perProject': '{amount} per project',
  'billing.plansPicker.pack.perProjectCheckout': 'Per-project rate available at checkout',
  'billing.plansPicker.pack.savePercent': 'Save {percent}%',
  'billing.plansPicker.promo.label': 'Promo code',
  'billing.plansPicker.promo.placeholder': 'Enter a promo code',
  'billing.plansPicker.promo.helper': 'Applies to project credits only.',
  'billing.plansPicker.promo.errors.invalid': 'That promo code is not valid.',
  'billing.plansPicker.promo.errors.expired': 'That promo code is not active.',
  'billing.plansPicker.promo.errors.notSynced': 'That promo code is not available yet.',
  'billing.plansPicker.promo.errors.maxed': 'That promo code has reached its redemption limit.',
  'billing.plansPicker.subscription.whyTitle': 'Why subscribe?',
  'billing.plansPicker.subscription.benefit.unlimitedProjects': 'Unlimited projects',
  'billing.plansPicker.subscription.benefit.simplifiedBilling': 'Simplified billing',
  'billing.plansPicker.subscription.benefit.teamSeats': 'Team seat options',
  'billing.plansPicker.subscription.seatsNeeded': 'Seats needed',
  'billing.plansPicker.subscription.includedSeats': 'Included seats for this tier: {count}',
  'billing.plansPicker.subscription.seatWarning':
    'You currently have {count} seats in use (members + invites). Seats needed cannot be below seats in use.',
  'billing.plansPicker.subscription.additionalSeatsNote':
    'Additional seats will be added to checkout as a per-seat add-on (quantity = {count}).',
  'billing.plansPicker.subscription.label': 'Subscription',
  'billing.plansPicker.subscription.basicLabel': 'Basic',
  'billing.plansPicker.subscription.unlimitedLabel': 'Unlimited',
  'billing.plansPicker.subscription.limitedBadge': 'Limited',
  'billing.plansPicker.subscription.unlimitedBadge': 'Unlimited',
  'billing.plansPicker.subscription.basicDetail': '2 projects/month • Rollover up to 12 months',
  'billing.plansPicker.subscription.unlimitedDetail': 'Unlimited projects',
  'billing.plansPicker.subscription.currentPlan': 'Current plan',
  'billing.plansPicker.subscription.planFallback': 'Plan',
  'billing.plansPicker.subscription.mostPopular': 'Most popular',
  'billing.plansPicker.subscription.planIncludes':
    '{plan} includes {count} Seat{suffix} — {amount}',
  'billing.plansPicker.subscription.additionalSeatsDetail':
    '{count} Additional Seat{suffix} ({perSeat} x {count}) = {total}',
  'billing.plansPicker.subscription.perMonth': '{amount} per month',
  'billing.plansPicker.subscription.includesSeats': 'Includes {count} seats',
  'billing.plansPicker.subscription.seatAddonBilling': 'Seat add-ons billed at renewal.',
  'billing.plansPicker.subscription.savePerMonth': 'Save {amount}/mo',
  'billing.plansPicker.subscription.savePercent': 'Save {percent}%',
  'billing.plansPicker.subscription.recommendNextTier': 'Consider {{tier}} to save {{savings}}',
  'billing.plansPicker.actions.startingCheckout': 'Starting checkout...',
  'billing.plansPicker.actions.switchingPlan': 'Switching your plan...',
  'billing.plansPicker.actions.upgradeToUnlimited': 'Upgrade to Unlimited',
  'billing.plansPicker.actions.switchToBasic': 'Switch to Basic',
  'billing.plansPicker.actions.buyPack': 'Buy Pack',
  'billing.plansPicker.actions.startSubscription': 'Start Subscription',
  'billing.plansPicker.empty.creditPacks': 'No credit packs are available right now.',
  'billing.plansPicker.empty.subscriptions': 'No subscriptions are available right now.',
  'billing.plansPicker.errors.loadPlans': 'Unable to load plans.',
  'billing.plansPicker.errors.missingFields':
    'Billing options response was missing expected fields. Please try again.',
  'billing.plansPicker.errors.loadOptions': 'Failed to load billing options',
  'billing.plansPicker.errors.loadSeatUsage': 'Failed to load seat usage',
  'billing.plansPicker.errors.checkout': 'Unable to start checkout',
  'billing.plansPicker.errors.loadCurrentSubscription': 'Failed to load current subscription',
  'billing.plansPicker.errors.planSwitchFailed': 'Unable to switch plan',
  'billing.plansPicker.errors.checkoutTitle': 'Checkout failed',
  'billing.plansPicker.subscription.switchSuccess': 'Your plan was updated.',
  'billing.history.title': 'Billing history',
  'billing.history.actions.downloadCsv': 'Download CSV',
  'billing.history.sections.invoices': 'Invoices',
  'billing.history.sections.charges': 'Charges',
  'billing.history.sections.projectDecisions': 'Project decisions',
  'billing.history.columns.invoiceId': 'Invoice ID',
  'billing.history.columns.issued': 'Issued',
  'billing.history.columns.subtotal': 'Subtotal',
  'billing.history.columns.tax': 'Tax',
  'billing.history.columns.amountDue': 'Amount due',
  'billing.history.columns.amountPaid': 'Amount paid',
  'billing.history.columns.chargeId': 'Charge ID',
  'billing.history.columns.created': 'Created',
  'billing.history.columns.fee': 'Fee',
  'billing.history.columns.net': 'Net',
  'billing.history.columns.projectId': 'Project ID',
  'billing.history.columns.module': 'Module',
  'billing.history.columns.decision': 'Decision',
  'billing.history.columns.unitPrice': 'Unit price',
  'billing.history.columns.total': 'Total',
  'billing.history.empty.invoices': 'No invoices yet.',
  'billing.history.empty.charges': 'No charges yet.',
  'billing.history.empty.projectCharges': 'No project charges yet.',
  'billing.errorBoundary.defaultLabel': 'Billing UI',
  'billing.errorBoundary.title': 'Billing UI error',
  'billing.errorBoundary.unknownError': 'Unknown billing UI error',
  'billing.errorBoundary.refreshMessage':
    'Please refresh. If this keeps happening, contact support.',
  'billing.paymentMethod.cardDetails': 'Card details',
  'billing.paymentMethod.saveCard': 'Save card',
  'billing.paymentMethod.errors.stripeNotReady': 'Stripe is not ready. Please try again in a moment.',
  'billing.paymentMethod.errors.cardUnavailable': 'Card input is not available.',
  'billing.paymentMethod.errors.invalidOrg':
    'A valid organization is required to update the payment method.',
  'billing.paymentMethod.errors.startVerificationFailed': 'Failed to start card verification.',
  'billing.paymentMethod.errors.missingClientSecret': 'Stripe client secret was not returned.',
  'billing.paymentMethod.errors.confirmationFailed': 'Card confirmation failed.',
  'billing.paymentMethod.errors.missingPaymentMethod':
    'Stripe did not return a payment method identifier.',
  'billing.paymentMethod.errors.attachFailed': 'Failed to attach payment method.',
  'billing.paymentMethod.errors.unexpected': 'An unexpected error occurred. Please try again.',
  'billing.paymentMethod.toast.updatedTitle': 'Payment method updated',
  'billing.paymentMethod.toast.updatedDescription': 'Your default payment method has been saved.',
  'billing.paymentMethod.toast.failedTitle': 'Unable to update payment method',
  'billing.subscriptionManager.title': 'Subscriptions are managed as a single plan',
  'billing.subscriptionManager.description':
    'Use the Plans & Credits tab to choose a plan or buy project credits.',
  'billing.subscriptionManager.actionDefault': 'View Plans / Buy Credits',
  'billing.admin.drilldown.title': 'Account drilldown',
  'billing.admin.drilldown.loading': 'Loading account summary…',
  'billing.admin.drilldown.errors.loadSummary': 'Unable to load account summary',
  'billing.admin.drilldown.accountTitle': 'Account #{id}',
  'billing.admin.drilldown.ownerLabel': '{ownerType} #{ownerId}',
  'billing.admin.drilldown.createdAt': 'Created {date}',
  'billing.admin.drilldown.actions.openStripeCustomer': 'Open customer in Stripe',
  'billing.admin.drilldown.actions.adjustCredits': 'Adjust credits',
  'billing.admin.drilldown.actions.replayStripeEvent': 'Replay Stripe event',
  'billing.admin.drilldown.labels.stripeCustomer': 'Stripe customer',
  'billing.admin.drilldown.labels.lastChargeId': 'Last charge id',
  'billing.admin.drilldown.labels.defaultPaymentMethod': 'Default payment method',
  'billing.admin.drilldown.labels.stripeSubscription': 'Stripe subscription',
  'billing.admin.drilldown.labels.currentPeriodEnd': 'Current period end',
  'billing.admin.drilldown.labels.cancelAtPeriodEnd': 'Cancel at period end',
  'billing.admin.drilldown.labels.freeRemaining': 'Free remaining',
  'billing.admin.drilldown.labels.prepaidRemaining': 'Prepaid remaining',
  'billing.admin.drilldown.sections.subscription': 'Subscription',
  'billing.admin.drilldown.sections.credits': 'Credits',
  'billing.admin.drilldown.sections.recentCharges': 'Recent charges',
  'billing.admin.drilldown.sections.projectCharges': 'Project charges',
  'billing.admin.drilldown.bucketLine': '{bucket}: {value}',
  'billing.admin.drilldown.projectChargeLine': '{type}: {count}',
  'billing.admin.drilldown.columns.charge': 'Charge',
  'billing.admin.drilldown.columns.net': 'Net',
  'billing.admin.drilldown.columns.created': 'Created',
  'billing.admin.drilldown.columns.project': 'Project',
  'billing.admin.drilldown.columns.module': 'Module',
  'billing.admin.drilldown.columns.type': 'Type',
  'billing.admin.drilldown.columns.occurred': 'Occurred',
  'billing.admin.drilldown.empty.subscription': 'No active subscription on record.',
  'billing.admin.drilldown.empty.recentCharges': 'No recent charges found.',
  'billing.admin.drilldown.empty.projectChargeActivity': 'No project charge activity.',
  'billing.admin.drilldown.empty.recentProjectCharges': 'No recent project charges found.',
  'billing.admin.overview.title': 'Overview',
  'billing.admin.overview.subtitle':
    'Subscription run rate, PAYG activity, and Stripe settlement totals.',
  'billing.admin.overview.errors.timeseries': 'Unable to load timeseries',
  'billing.admin.overview.tiles.mrr': 'Monthly recurring revenue',
  'billing.admin.overview.tiles.arr': 'Annual recurring revenue',
  'billing.admin.overview.tiles.paygDecisions': 'PAYG decisions',
  'billing.admin.overview.tiles.activeSubscribers': 'Active subscribers',
  'billing.admin.overview.tiles.trialing': 'Trialing',
  'billing.admin.overview.tiles.newSubscribersRange': 'New subs (range)',
  'billing.admin.overview.tiles.cancellationsRange': 'Cancellations (range)',
  'billing.admin.overview.tiles.failedChargesRange': 'Failed charges (range)',
  'billing.admin.overview.tiles.creditsSoldRange': 'Credits sold (range)',
  'billing.admin.overview.tiles.projectsCreatedRange': 'Projects created (range)',
  'billing.admin.overview.tiles.grossVolume': 'Gross volume',
  'billing.admin.overview.tiles.fees': 'Fees',
  'billing.admin.overview.tiles.net': 'Net',
  'billing.admin.overview.revenue.title': 'Daily revenue',
  'billing.admin.overview.revenue.subtitle': 'Gross vs net totals',
  'billing.admin.overview.revenue.legend.gross': 'Gross',
  'billing.admin.overview.revenue.legend.net': 'Net',
  'billing.admin.overview.revenue.error': 'Unable to load revenue trend.',
  'billing.admin.overview.revenue.empty': 'No activity in this range.',
  'billing.admin.overview.revenue.tooltip': '{day}: Gross {gross}, Net {net}',
  'billing.admin.overview.subs.title': 'Daily subs',
  'billing.admin.overview.subs.subtitle': 'New vs cancellations',
  'billing.admin.overview.subs.legend.new': 'New',
  'billing.admin.overview.subs.legend.canceled': 'Canceled',
  'billing.admin.overview.subs.error': 'Unable to load subscription trend.',
  'billing.admin.overview.subs.empty': 'No activity in this range.',
  'billing.admin.overview.subs.tooltip': '{day}: New {newCount}, Canceled {canceledCount}',
  'billing.admin.adjustCredits.title': 'Adjust global credits',
  'billing.admin.adjustCredits.labels.accountId': 'Billing account ID',
  'billing.admin.adjustCredits.labels.delta': 'Delta (positive to add, negative to remove)',
  'billing.admin.adjustCredits.placeholders.accountId': '123',
  'billing.admin.adjustCredits.placeholders.delta': '5',
  'billing.admin.adjustCredits.submit': 'Adjust credits',
  'billing.admin.adjustCredits.updating': 'Updating…',
  'billing.admin.adjustCredits.errors.invalidAccountId': 'Please provide a valid billing account id.',
  'billing.admin.adjustCredits.errors.invalidDelta': 'Delta must be a non-zero integer.',
  'billing.admin.adjustCredits.errors.updateFailed': 'Failed to adjust credits',
  'billing.admin.adjustCredits.errors.unexpected': 'Unable to adjust credits. Please try again.',
  'billing.admin.adjustCredits.toast.updatedTitle': 'Credits updated',
  'billing.admin.adjustCredits.toast.updatedDescription': 'Account now has {credits} credits.',
  'billing.admin.adjustCredits.toast.failedTitle': 'Unable to adjust credits',
  'billing.admin.subscribers.accountId': '#{id}',
  'billing.admin.tools.replay.title': 'Replay Stripe event',
  'billing.admin.tools.replay.description':
    'Use this to reprocess a Stripe event through the webhook logic.',
  'billing.admin.tools.replay.eventIdLabel': 'Event ID',
  'billing.admin.tools.replay.eventIdPlaceholder': 'evt_...',
  'billing.admin.tools.replay.actions.replaying': 'Replaying…',
  'billing.admin.tools.replay.actions.run': 'Replay event',
  'billing.admin.tools.replay.errors.invalidEventId':
    'Event ID must start with "evt_" and be longer than 10 characters.',
  'billing.admin.tools.replay.errors.failed': 'Replay failed',
  'billing.admin.tools.replay.errors.network': 'Unable to reach replay endpoint',
  'billing.admin.tools.backfill.title': 'Backfill',
  'billing.admin.tools.backfill.description':
    'Run a Stripe backfill for a date range. Leave account ID blank to target all accounts.',
  'billing.admin.tools.backfill.kindLabel': 'Backfill kind',
  'billing.admin.tools.backfill.kind.all': 'All',
  'billing.admin.tools.backfill.kind.subscriptions': 'Subscriptions',
  'billing.admin.tools.backfill.kind.invoices': 'Invoices',
  'billing.admin.tools.backfill.kind.charges': 'Charges',
  'billing.admin.tools.backfill.accountIdLabel': 'Account ID (optional)',
  'billing.admin.tools.backfill.accountIdPlaceholder': '123',
  'billing.admin.tools.backfill.fromLabel': 'From',
  'billing.admin.tools.backfill.toLabel': 'To',
  'billing.admin.tools.backfill.actions.running': 'Running…',
  'billing.admin.tools.backfill.actions.run': 'Run backfill',
  'billing.admin.tools.backfill.errors.invalidDates':
    'Provide valid from/to dates in YYYY-MM-DD format.',
  'billing.admin.tools.backfill.errors.invalidAccountId': 'Account ID must be a positive integer.',
  'billing.admin.tools.backfill.errors.failed': 'Backfill failed',
  'billing.admin.tools.backfill.errors.network': 'Unable to reach backfill endpoint',
  'billing.admin.tools.adjust.title': 'Adjust credits',
  'billing.admin.tools.adjust.description':
    'Open the credits adjustment modal for a specific billing account.',
  'billing.admin.tools.adjust.accountIdLabel': 'Account ID',
  'billing.admin.tools.adjust.accountIdPlaceholder': '123',
  'billing.admin.tools.adjust.actions.open': 'Open Adjust Credits',
  'billing.admin.tools.adjust.errors.missingAccountId':
    'Provide an account ID before opening the modal.',
  'billing.admin.tools.adjust.errors.invalidAccountId': 'Account ID must be a positive integer.',
  'billing.admin.tools.result.success': 'Success',
  'billing.admin.tools.result.error': 'Error',
  'billing.admin.pricingMap.updatedTitle': 'Pricing catalog updated',
  'billing.admin.pricingMap.updateFailed': 'Failed to update pricing catalog. Please try again.',
  'billing.admin.pricingMap.updateFailedTitle': 'Unable to update pricing catalog',
  'billing.admin.pricingMap.discardChangesConfirm':
    'You have unsaved changes. Discard changes and exit edit mode?',
  'billing.admin.pricingMap.title': 'Pricing catalog',
  'billing.admin.pricingMap.subtitle':
    'Update Stripe price ids and billing amounts for each catalog entry.',
  'billing.admin.pricingMap.enableEditing': 'Enable editing',
  'billing.admin.pricingMap.saving': 'Saving…',
  'billing.admin.pricingMap.saveChanges': 'Save changes',
  'billing.admin.pricingMap.editingWarning':
    'Edits affect live billing configuration. Verify Stripe price IDs and amounts before saving.',
  'billing.admin.pricingMap.searchPlaceholder':
    'Search price key, Stripe price ID, type, scope, term…',
  'billing.admin.pricingMap.activeOnly': 'Active only',
  'billing.admin.pricingMap.showingCount': 'Showing {filtered} of {total}',
  'billing.admin.pricingMap.columns.priceKey': 'Price key',
  'billing.admin.pricingMap.columns.productType': 'Product type',
  'billing.admin.pricingMap.columns.scope': 'Scope',
  'billing.admin.pricingMap.columns.term': 'Term',
  'billing.admin.pricingMap.columns.credits': 'Credits',
  'billing.admin.pricingMap.columns.includedSeats': 'Included seats',
  'billing.admin.pricingMap.columns.stripePriceId': 'Stripe price ID',
  'billing.admin.pricingMap.columns.amountCents': 'Amount (¢)',
  'billing.admin.pricingMap.columns.display': 'Display',
  'billing.admin.pricingMap.columns.active': 'Active',
  'billing.admin.pricingMap.createdAt': 'Created {date}',
  'billing.admin.pricingMap.updatedAt': 'Updated {date}',
  'billing.admin.pricingMap.toggleLabel': 'Toggle {key}',
  'billing.admin.pricingMap.emptyState': 'No pricing catalog entries found.',
  'billing.admin.pricingMap.noMatches': 'No entries match your filters.',
  'billing.admin.subscribers.title': 'Subscribers',
  'billing.admin.subscribers.subtitle': 'Active and trialing subscriptions by module.',
  'billing.admin.subscribers.status.active': 'Active',
  'billing.admin.subscribers.status.trialing': 'Trialing',
  'billing.admin.subscribers.status.any': 'Any',
  'billing.admin.subscribers.status.unknown': 'unknown',
  'billing.admin.subscribers.columns.account': 'Account',
  'billing.admin.subscribers.columns.subscription': 'Subscription',
  'billing.admin.subscribers.columns.period': 'Period',
  'billing.admin.subscribers.columns.items': 'Items',
  'billing.admin.subscribers.accountType': '{type}',
  'billing.admin.subscribers.orgId': 'Org #{id}',
  'billing.admin.subscribers.userId': 'User #{id}',
  'billing.admin.subscribers.subscriptionId': 'ID {id}',
  'billing.admin.subscribers.periodTo': 'to {date}',
  'billing.admin.subscribers.noItems': 'No items',
  'billing.admin.subscribers.loading': 'Loading subscribers…',
  'billing.admin.subscribers.emptyState': 'No subscribers found for this filter.',
  'billing.admin.subscribers.loadMore': 'Load more',
  'billing.admin.transactions.title': 'Transactions',
  'billing.admin.transactions.subtitle': 'Invoices, charges, and project-level billing decisions.',
  'billing.admin.transactions.exportCsv': 'Export CSV',
  'billing.admin.transactions.filters.type': 'Type',
  'billing.admin.transactions.filters.typeAll': 'All',
  'billing.admin.transactions.filters.typeInvoices': 'Invoices',
  'billing.admin.transactions.filters.typeCharges': 'Charges',
  'billing.admin.transactions.filters.typeProjects': 'Project charges',
  'billing.admin.transactions.filters.accountType': 'Account type',
  'billing.admin.transactions.filters.accountTypeAny': 'Any',
  'billing.admin.transactions.filters.accountTypeUser': 'User',
  'billing.admin.transactions.filters.accountTypeOrg': 'Organization',
  'billing.admin.transactions.filters.accountId': 'Account ID',
  'billing.admin.transactions.filters.orgType': 'Org type',
  'billing.admin.transactions.filters.orgTypePlaceholder': 'InsuranceCompany',
  'billing.admin.transactions.filters.module': 'Module',
  'billing.admin.transactions.filters.modulePlaceholder': 'UA',
  'billing.admin.transactions.filters.chargeType': 'Charge type',
  'billing.admin.transactions.filters.chargeTypePlaceholder': 'payg',
  'billing.admin.transactions.filters.statusPlaceholder': 'paid',
  'billing.admin.transactions.filters.from': 'From',
  'billing.admin.transactions.filters.to': 'To',
  'billing.admin.transactions.applyFilters': 'Apply filters',
  'billing.admin.transactions.columns.account': 'Account',
  'billing.admin.transactions.columns.invoice': 'Invoice',
  'billing.admin.transactions.columns.amounts': 'Amounts',
  'billing.admin.transactions.columns.issued': 'Issued',
  'billing.admin.transactions.columns.charge': 'Charge',
  'billing.admin.transactions.columns.created': 'Created',
  'billing.admin.transactions.columns.project': 'Project',
  'billing.admin.transactions.columns.module': 'Module',
  'billing.admin.transactions.columns.type': 'Type',
  'billing.admin.transactions.columns.total': 'Total',
  'billing.admin.transactions.columns.when': 'When',
  'billing.admin.transactions.statusUnknown': 'unknown',
  'billing.admin.transactions.invoices.title': 'Invoices',
  'billing.admin.transactions.invoices.amountDue': 'Due {amount}',
  'billing.admin.transactions.invoices.amountsDetail': 'Paid {paid} · Net {net}',
  'billing.admin.transactions.invoices.loading': 'Loading invoices…',
  'billing.admin.transactions.invoices.emptyState': 'No invoices for this filter.',
  'billing.admin.transactions.charges.title': 'Charges',
  'billing.admin.transactions.charges.amountGross': 'Gross {amount}',
  'billing.admin.transactions.charges.amountsDetail': 'Fees {fees} · Net {net}',
  'billing.admin.transactions.charges.loading': 'Loading charges…',
  'billing.admin.transactions.charges.emptyState': 'No charges for this filter.',
  'billing.admin.transactions.projects.title': 'Project charges',
  'billing.admin.transactions.projects.loading': 'Loading project charges…',
  'billing.admin.transactions.projects.emptyState': 'No project charges for this filter.',
  'projects.setup.section.project': 'PROJECT',
  'projects.setup.projectName': 'Project Name*',
  'projects.setup.umpireName': 'Umpire Name*',
  'projects.setup.section.insuredInfo': 'INSURED’S INFORMATION',
  'projects.setup.insuredName': 'Insured’s Name*',
  'projects.setup.insuranceProviderName': 'Insurance Provider Name*',
  'projects.setup.policyNumber': 'Policy Number*',
  'projects.setup.claimNumber': 'Claim Number*',
  'projects.setup.dateOfLoss': 'Date of Loss*',
  'projects.setup.uploadLogo': 'Upload Logo (Recommended: 80×80 px)',
  'projects.setup.typeOfLoss': 'Type of Loss*',
  'projects.setup.causeOfLoss': 'Cause of Loss*',
  'projects.setup.select': 'Select',
  'projects.businessProfile.label': 'Business Profile',
  'projects.businessProfile.sectionTitle': 'Business Profile',
  'projects.businessProfile.none': 'Not set',
  'projects.setup.section.lossLocation': 'LOCATION OF THE LOSS',
  'projects.setup.address': 'Address*',
  'projects.setup.city': 'City*',
  'projects.setup.state': 'State*',
  'projects.setup.zipCode': 'Zip Code*',
  'projects.setup.section.appraiserInfo': 'APPRAISER INFORMATION',
  'projects.setup.insuredAppraiser': 'Insured Appraiser*',
  'projects.setup.carrierAppraiser': 'Carrier Appraiser*',
  'projects.upload.uploadCarrierFile': 'Upload Carrier File',
  'projects.upload.uploadInsuredFile': 'Upload Insured File',
  'projects.upload.unlinkCarrierAria': 'Unlink carrier PDF',
  'projects.upload.unlinkInsuredAria': 'Unlink insured PDF',
  'projects.upload.carrierPdf': 'Carrier PDF',
  'projects.upload.insuredPdf': 'Insured PDF',
  'projects.upload.idleHelp': 'Click to choose or drop a PDF here',
  'projects.upload.uploading': 'Uploading {name}…',
  'projects.upload.processing': 'Processing and extracting…',
  'projects.upload.complete': 'Complete: {name}',
  'projects.upload.failed': 'Upload failed: {error}',
  'projects.upload.uploadFailed': 'Upload failed',
  'projects.upload.unlinkFailed': 'Unlink failed',
  'projects.upload.nextMatchMerge': 'Next: Match & Merge',
  'initialDispute.invoiceExport.title': 'Undisputed/Disputed Invoice',
  'initialDispute.invoiceExport.areaSummary': 'Area Summary',
  'initialDispute.invoiceExport.lineItem': 'Line Item',
  'initialDispute.invoiceExport.pdf': 'PDF',
  'initialDispute.invoiceExport.excel': 'Excel',
  'projects.timeEntry.title.edit': 'Edit Entry',
  'projects.timeEntry.title.add': 'Add Entry',
  'projects.timeEntry.startTime': 'Start Time',
  'projects.timeEntry.endTime': 'End Time',
  'projects.timeEntry.expenditure': 'Expenditure ($)',
  'projects.timeEntry.saveFailed': 'Failed to save',
  'projects.timeEntry.errors.startEndRequired': 'Start and end times are required',
  'projects.timeEntry.errors.endAfterStart': 'End time must be after start time',
  'projects.adrProjectModal.validation.titleRequired': 'Title is required',
  'projects.adrProjectModal.validation.typeOfLossRequired': 'Type of Loss is required',
  'projects.adrProjectModal.title.edit': 'Edit Project',
  'projects.adrProjectModal.title.add': 'Add Project',
  'projects.adrProjectModal.fields.projectName': 'Project Name',
  'projects.adrProjectModal.fields.typeOfLoss': 'Type of Loss',
  'projects.adrProjectModal.typeOfLoss.select': 'Select Type of Loss',
  'projects.adrProjectModal.typeOfLoss.empty': 'No types available',
  'projects.adrProjectModal.fields.causeOfLoss': 'Cause of Loss',
  'projects.adrProjectModal.causeOfLoss.select': 'Select Cause of Loss',
  'projects.adrProjectModal.causeOfLoss.empty': 'No causes available',
  'projects.adrProjectModal.actions.update': 'Update',
  'projects.timeTracker.confirmDelete': 'Delete this entry?',
  'projects.timeTracker.title': 'Time Tracker',
  'projects.timeTracker.actions.addEntry': 'Add Entry',
  'projects.timeTracker.empty': 'No time entries.',
  'projects.timeTracker.columns.start': 'Start',
  'projects.timeTracker.columns.end': 'End',
  'projects.timeTracker.columns.duration': 'Duration',
  'projects.timeTracker.columns.expenditure': 'Expenditure',
  'projects.timeTracker.defaultDescription': 'Application time',
  'typeOfLoss.list.dragToReorder': 'Drag to reorder',
  'typeOfLoss.list.emptyCoverages': 'No coverages',
  'typeOfLoss.list.errors.saveOrderFailed': 'Failed to save order.',
  'typeOfLoss.list.actions.addType': 'Add Type of Loss',
  'typeOfLoss.list.empty': 'No Types of Loss programmed.',
  'typeOfLoss.deleteModal.title': 'Delete Type of Loss',
  'typeOfLoss.deleteModal.description':
    'Are you sure you want to permanently delete {lossTypeName}?',
  'typeOfLoss.modal.coverages.dragToReorder': 'Drag to reorder',
  'typeOfLoss.modal.validation.lossTypeRequired': 'Type of Loss is required',
  'typeOfLoss.modal.validation.coverageRequired': 'Coverage name is required',
  'typeOfLoss.modal.errors.saveFailed': 'Failed to save',
  'typeOfLoss.modal.title.edit': 'Edit Type of Loss',
  'typeOfLoss.modal.title.add': 'Add Type of Loss',
  'typeOfLoss.modal.actions.saveChanges': 'Save Changes',
  'typeOfLoss.modal.actions.addType': 'Add Type of Loss',
  'typeOfLoss.ua.pageTitle': 'Type of Loss – Umpire Assistant',
  'typeOfLoss.adr.pageTitle': 'Type of Loss – ADR',
  'typeOfLoss.cr.pageTitle': 'Type of Loss – ADR Case Ready',
  'typeOfLoss.sf.pageTitle': 'Type of Loss – SettleFast',
  'typeOfLoss.modal.fields.lossType': 'Loss Type',
  'typeOfLoss.modal.fields.coverages': 'Coverages',
  'typeOfLoss.modal.actions.addCoverage': 'Add Coverage',
  'typeOfLoss.table.createdAt': 'Created At',
  'ui.passwordInput.hidePassword': 'Hide password',
  'ui.passwordInput.showPassword': 'Show password',
  'ui.signaturePad.errors.saveFailedStatus': 'Failed to save signature (HTTP {status}).',
  'ui.signaturePad.errors.saveFailed': 'Failed to save signature.',
  'ui.signaturePad.actions.replace': 'Replace',
  'ui.signaturePad.actions.clear': 'Clear',
  'ui.signaturePad.state.saved': 'Saved',
  'ui.signaturePad.previewAlt': '{label} signature',
  'ui.signaturePad.empty': 'No signature yet.',
  'ui.filters.active.allUsers': 'All Users',
  'ui.filters.active.inactive': 'Inactive',
  'ui.filters.active.ariaLabel': 'Active filter',
  'ui.filters.module.allModules': 'All Modules',
  'ui.filters.module.adr': 'ADR',
  'ui.filters.module.umpireAssistant': 'Umpire Assistant',
  'ui.filters.module.settleFast': 'SettleFast',
  'ui.filters.module.ariaLabel': 'Module filter',
  'ui.filters.role.allRoles': 'All Roles',
  'ui.filters.role.superadmin': 'Superadmin',
  'ui.filters.role.companyAdmin': 'Company Admin',
  'ui.filters.role.user': 'User',
  'ui.filters.role.ariaLabel': 'Role filter',
  'ui.modals.changeAccountType.title': 'Change Account Type',
  'ui.modals.changeAccountType.description':
    'Convert this user between Company and Individual account types.',
  'ui.modals.changeAccountType.fields.targetAccountType': 'Target account type',
  'ui.modals.changeAccountType.fields.existingCompany': 'Choose existing company',
  'ui.modals.changeAccountType.fields.newCompany': 'Create new company',
  'ui.modals.changeAccountType.accountTypes.individual': 'Individual',
  'ui.modals.changeAccountType.accountTypes.company': 'Company',
  'ui.modals.changeAccountType.placeholders.selectCompany': 'Select a company',
  'ui.modals.changeAccountType.placeholders.companyName': 'Enter company name',
  'ui.modals.changeAccountType.helperText.companyNameOverrides':
    'Entering a name will ignore the dropdown selection.',
  'ui.modals.changeAccountType.loadingCompanies': 'Loading companies...',
  'ui.modals.changeAccountType.independentNotice':
    'Membership will be moved to an Independent organization named',
  'ui.modals.changeAccountType.independentLabel': 'Independent: {label}',
  'ui.modals.changeAccountType.independentPlaceholder': '{name} ({email})',
  'ui.modals.changeAccountType.errors.loadCompaniesFailed': 'Failed to load companies',
  'ui.modals.changeAccountType.errors.selectUser': 'Select a user before changing account type.',
  'ui.modals.changeAccountType.errors.selectCompanyOrName':
    'Select an existing company or enter a new company name.',
  'ui.modals.changeAccountType.errors.companyNameTooLong':
    'Company name must be 255 characters or fewer.',
  'ui.modals.changeAccountType.errors.saveFailed': 'Failed to change account type',
  'ui.modals.changeAccountType.toast.successTitle': 'Account type updated',
  'ui.modals.changeAccountType.toast.successDescription': 'User converted to {accountType}.',
  'ui.modals.changeAccountType.toast.errorTitle': 'Change failed',
  'ui.modals.confirmBulkAction.title': 'Confirm Bulk Action',
  'ui.modals.confirmBulkAction.description':
    'Are you sure you want to {action} the selected {count} users?',
  'ui.modals.confirmBulkAction.actions.delete': 'permanently delete',
  'ui.modals.confirmBulkAction.actions.unauthorize': 'unauthorize',
  'ui.modals.confirmBulkAction.actions.deactivate': 'deactivate',
  'ui.modals.editBillingTypes.title': 'Edit Billing Types',
  'ui.modals.editBillingTypes.description':
    'Manage billing options for this user and company policy enforcement.',
  'ui.modals.editBillingTypes.loadingOptions': 'Loading billing options…',
  'ui.modals.editBillingTypes.sections.userBillingOptions': 'User Billing Options',
  'ui.modals.editBillingTypes.sections.companyPolicy': 'Company/Team Policy (Enforced)',
  'ui.modals.editBillingTypes.sections.effectiveOptions': 'Effective Billing Options',
  'ui.modals.editBillingTypes.fields.allowPayg': 'Allow Pay As You Go',
  'ui.modals.editBillingTypes.fields.allowSubscription': 'Allow Subscription',
  'ui.modals.editBillingTypes.fields.companyAllowPayg': 'Company allows Pay As You Go',
  'ui.modals.editBillingTypes.fields.companyAllowSubscription': 'Company allows Subscription',
  'ui.modals.editBillingTypes.fields.updateCompanyPolicy': 'Update company policy',
  'ui.modals.editBillingTypes.labels.orgId': 'Org ID: {orgId}',
  'ui.modals.editBillingTypes.labels.effectivePayg': 'Effective PAYG:',
  'ui.modals.editBillingTypes.labels.effectiveSubscription': 'Effective Subscription:',
  'ui.modals.editBillingTypes.helperText.effectiveClamped':
    'Effective options for this user are clamped by company policy.',
  'ui.modals.editBillingTypes.errors.invalidUserId': 'Invalid user id.',
  'ui.modals.editBillingTypes.errors.loadFailed': 'Failed to load billing options',
  'ui.modals.editBillingTypes.errors.saveFailed': 'Failed to update billing options',
  'ui.modals.editReferralCode.title': 'Edit Referral Code',
  'ui.modals.editReferralCode.description': 'Update the referral code for this user.',
  'ui.modals.editReferralCode.fields.referralCode': 'Referral Code',
  'ui.modals.editReferralCode.placeholders.referralCode':
    'Enter referral code or leave blank',
  'ui.modals.editReferralCode.helperText.referralCode': 'Letters/numbers only, max 32',
  'ui.modals.editReferralCode.errors.saveFailed': 'Failed to update referral code',
  'ui.modals.editUser.title': 'Edit User',
  'ui.modals.editUser.company.unassigned': 'Unassigned / Independent',
  'ui.modals.editUser.loadingCompanies': 'Loading companies...',
  'ui.modals.editUser.orgOption': 'Org {orgId}',
  'ui.modals.editUser.helperText.organizationId':
    "Enter the organization ID to manage this user's modules.",
  'ui.modals.editUser.modules.ua': 'Umpire Assistant',
  'ui.modals.editUser.modules.adr': 'ADR',
  'ui.modals.editUser.modules.cr': 'ADR Case Ready',
  'ui.modals.editUser.modules.settleFast': 'SettleFast',
  'ui.modals.editUser.errors.loadModulesFailed': 'Failed to load modules',
  'ui.modals.editUser.errors.loadCompaniesFailed': 'Failed to load companies',
  'ui.modals.editUser.errors.organizationRequired': 'Organization is required before assigning modules.',
  'ui.modals.editUser.errors.saveProfileFailed': 'Failed to save user profile',
  'ui.modals.editUser.errors.saveModulesFailed': 'Failed to save modules',
  'admin.users.pageTitle': 'Global Users',
  'admin.invoiceSettings.pageTitle': 'General Invoice Settings',
  'admin.users.loadUsersError': 'Failed to load users.',
  'admin.users.loadUsersTitle': 'Failed to load users',
  'admin.users.loadLocalesError': 'Failed to load locales.',
  'admin.users.loadLocalesTitle': 'Failed to load locales',
  'admin.users.loadStatusError': 'Failed to load status.',
  'admin.users.loadStatusTitle': 'Failed to load i18n status',
  'admin.users.loadCatalogError': 'Failed to load catalog.',
  'admin.users.loadCatalogTitle': 'Failed to load catalog',
  'admin.users.installLocaleError': 'Failed to install locale.',
  'admin.users.installLocaleTitle': 'Failed to install locale',
  'admin.users.localeInstalledTitle': 'Locale installed',
  'admin.users.localeInstalledDescription': '{locale} is now installed.',
  'admin.users.generateTranslationsError': 'Failed to generate translations.',
  'admin.users.generateTranslationsTitle': 'Failed to generate translations',
  'admin.users.generatedTranslationsTitle': 'Generated missing translations',
  'admin.users.generatedTranslationsDescription':
    'Processed {processed}, generated {generated}{errorsClause}.',
  'admin.users.generatedTranslationsErrors': ' with errors ({errors})',
  'admin.users.syncedKeysTitle': 'Synced i18n keys',
  'admin.users.syncedKeysDescription': 'Extracted {extracted} keys. Upserted {upserted}.',
  'admin.users.syncKeysError': 'Failed to sync i18n keys.',
  'admin.users.syncKeysTitle': 'Failed to sync i18n keys',
  'admin.users.bulkActionFailed': 'Bulk action failed',
  'admin.users.invalidUserTitle': 'Invalid user',
  'admin.users.invalidUserDescription': 'Unable to open billing settings for this user.',
  'admin.users.inviteUser': 'Invite User',
  'admin.users.inviteSent': 'Invite sent',
  'admin.users.tools.title': 'Tools',
  'admin.users.tools.exportMailchimp': 'Download users (Mailchimp CSV)',
  'admin.users.tools.createdSince': 'Created since',
  'admin.users.i18nConsoleTitle': 'I18n Console',
  'admin.users.i18nConsoleDescription':
    'Manage installed locales, sync keys, and generate missing translations.',
  'admin.users.installedLocales': 'Installed Locales',
  'admin.users.activeLocaleLabel': 'Active locale to manage',
  'admin.users.noLocalesInstalled': 'No locales installed',
  'admin.users.catalogSearchTitle': 'Catalog Search + Install',
  'admin.users.catalogSearchPlaceholder': 'Search locale catalog',
  'admin.users.searching': 'Searching…',
  'admin.users.search': 'Search',
  'admin.users.unknownName': 'Unknown name',
  'admin.users.installing': 'Installing…',
  'admin.users.catalogSearchHelper': 'Search the catalog to install additional locales.',
  'admin.users.syncing': 'Syncing…',
  'admin.users.syncI18nKeys': 'Sync i18n Keys',
  'admin.users.generating': 'Generating…',
  'admin.users.generateMissing': 'Generate Missing',
  'admin.users.status': 'Status',
  'admin.users.refreshing': 'Refreshing…',
  'admin.users.refreshStatus': 'Refresh Status',
  'admin.users.selectLocaleToViewStatus': 'Select a locale to view status.',
  'admin.users.totalKeys': 'Total Keys',
  'admin.users.translated': 'Translated',
  'admin.users.missing': 'Missing',
  'admin.users.aiGenerated': 'AI Generated',
  'admin.users.manual': 'Manual',
  'admin.users.needsReview': 'Needs Review',
  'admin.users.latestError': 'Latest error: {key} — {error}{timestamp}',
  'admin.users.latestErrorTimestamp': ' ({timestamp})',
  'admin.users.unknownKey': 'Unknown key',
  'admin.users.localeDisplayName': ' — {name}',
  'admin.users.localeNativeName': ' ({name})',
  'admin.users.localeNativeNameBullet': ' • {name}',
  'admin.users.searchPlaceholder': 'Search name or email',
  'admin.users.allCompanies': 'All Companies',
  'admin.users.sortLabel': 'Sort {direction}',
  'admin.users.sortAsc': 'A-Z',
  'admin.users.sortDesc': 'Z-A',
  'admin.users.pagination': 'Pagination',
  'admin.users.infiniteScroll': 'Infinite Scroll',
  'admin.users.bulkActions': 'Bulk Actions',
  'admin.users.verify': 'Verify',
  'admin.users.unverify': 'Unverify',
  'admin.users.authorize': 'Authorize',
  'admin.users.unauthorize': 'Unauthorize',
  'admin.users.activate': 'Activate',
  'admin.users.deactivate': 'Deactivate',
  'admin.users.delete': 'Delete',
  'admin.users.showingRange': 'Showing {start}–{end} of {total}',
  'admin.users.noUsersFound': 'No users found',
  'admin.users.showingUsers': 'Showing {count} users',
  'admin.i18n.pageTitle': 'Manage Languages and Locales',
  'admin.i18n.title': 'Manage Languages and Locales',
  'admin.i18n.subtitle': 'Install locales and review AI-generated translations.',
  'admin.i18n.loadLocalesError': 'Failed to load locales.',
  'admin.i18n.loadLocalesTitle': 'Failed to load locales',
  'admin.i18n.loadReviewQueueError': 'Failed to load review queue.',
  'admin.i18n.loadReviewQueueTitle': 'Failed to load review queue',
  'admin.i18n.updateTranslationError': 'Failed to update translation.',
  'admin.i18n.savedTranslationTitle': 'Saved translation',
  'admin.i18n.savedTranslationDescription': '{key} updated.',
  'admin.i18n.saveTranslationTitle': 'Failed to save translation',
  'admin.i18n.approveTranslationError': 'Failed to approve translation.',
  'admin.i18n.approvedTranslationTitle': 'Approved translation',
  'admin.i18n.approvedTranslationDescription': '{key} approved.',
  'admin.i18n.approveTranslationTitle': 'Failed to approve translation',
  'admin.i18n.markedForReviewTitle': 'Marked for review',
  'admin.i18n.markedForReviewDescription': '{key} flagged for review.',
  'admin.i18n.markForReviewTitle': 'Failed to mark for review',
  'admin.i18n.refreshing': 'Refreshing…',
  'admin.i18n.localeLabel': 'Locale',
  'admin.i18n.localeDisplayName': ' — {name}',
  'admin.i18n.localeNativeName': ' ({name})',
  'admin.i18n.noLocalesInstalled': 'No locales installed',
  'admin.i18n.noTranslationsPending': 'No translations pending review.',
  'admin.i18n.selectLocaleToBegin': 'Select a locale to begin.',
  'admin.i18n.table.key': 'Key',
  'admin.i18n.table.english': 'English',
  'admin.i18n.table.currentTranslation': 'Current Translation',
  'admin.i18n.table.error': 'Error',
  'admin.i18n.table.actions': 'Actions',
  'admin.i18n.needsReviewAction': 'Needs Review',
  'admin.i18n.pageStatus': 'Page {current} of {total}',
  'admin.i18n.installSectionTitle': 'Install languages and locales',
  'admin.i18n.installSectionHelp':
    'Search the locale catalog and install a locale to make it available to users.',
  'admin.i18n.catalogSearchPlaceholder': 'Search languages (e.g., Spanish, es, Français)…',
  'admin.i18n.catalogColCode': 'Code',
  'admin.i18n.catalogColEnglish': 'English name',
  'admin.i18n.catalogColNative': 'Native name',
  'admin.i18n.catalogColStatus': 'Status',
  'admin.i18n.catalogColAction': 'Action',
  'admin.i18n.catalogStatusInstalled': 'Installed',
  'admin.i18n.catalogActionInstall': 'Install',
  'admin.i18n.catalogActionInstalled': 'Installed',
  'admin.i18n.catalogEmpty': 'No matching locales found.',
  'admin.i18n.catalogLoading': 'Loading…',
  'admin.i18n.catalogError': 'Unable to load locale catalog.',
  'admin.i18n.installError': 'Unable to install locale.',
  'admin.i18n.installSuccess': 'Locale installed.',
  'admin.i18n.ops.title': 'Translation Ops',
  'admin.i18n.ops.help': 'Sync keys from source and generate missing translations for review.',
  'admin.i18n.ops.syncKeys': 'Sync Keys',
  'admin.i18n.ops.syncKeysSuccess': 'Keys synced.',
  'admin.i18n.ops.syncKeysError': 'Unable to sync keys.',
  'admin.i18n.ops.generateMissing': 'Generate Missing (AI → Needs Review)',
  'admin.i18n.ops.generateMissingSuccess': 'Translations enqueued for review.',
  'admin.i18n.ops.generateMissingError': 'Unable to generate translations.',
  'admin.i18n.ops.selectLocaleHint':
    'Select a non-English installed locale to generate translations.',
  'admin.i18n.tabs.locales': 'Locales',
  'admin.i18n.tabs.generate': 'Generate',
  'admin.i18n.tabs.reviewQueue': 'Review Queue',
  'admin.i18n.openManualEditor': 'Open Manual Editor',
  'admin.translations.pageTitle': 'Translation Editor',
  'admin.translations.searchPlaceholder': 'Search keys or text…',
  'admin.translations.filter.needsReview.all': 'All',
  'admin.translations.filter.needsReview.only': 'Needs review',
  'admin.translations.filter.needsReview.approved': 'Approved',
  'admin.translations.filter.source.all': 'All sources',
  'admin.translations.filter.source.ai': 'AI',
  'admin.translations.filter.source.manual': 'Manual',
  'admin.translations.filter.source.seed': 'Seed',
  'admin.translations.table.key': 'Key',
  'admin.translations.table.english': 'English',
  'admin.translations.table.value': 'Translation',
  'admin.translations.table.status': 'Status',
  'admin.translations.table.source': 'Source',
  'admin.translations.table.actions': 'Actions',
  'admin.translations.action.save': 'Save',
  'admin.translations.action.approve': 'Approve',
  'admin.translations.status.needsReview': 'Needs review',
  'admin.translations.status.approved': 'Approved',
  'admin.translations.empty': 'No results.',
  'admin.translations.error': 'Unable to load translations.',
  'admin.dashboard.pageTitle': 'Global Admin Dashboard',
  'admin.dashboard.header': 'Global Admin Overview',
  'admin.dashboard.subheader':
    'Track billing health, user growth, approvals, and referrals with fast access to core admin tools.',
  'admin.dashboard.adminShortcuts': 'Admin shortcuts',
  'admin.dashboard.atAGlance': 'At a glance',
  'admin.dashboard.keyRatios': 'Key ratios',
  'admin.dashboard.trends': 'Trends',
  'admin.dashboard.lastDays': 'Last {days} days',
  'admin.dashboard.trendRange7d': '7 days',
  'admin.dashboard.trendRange14d': '14 days',
  'admin.dashboard.trendRange30d': '30 days',
  'admin.dashboard.trend.loading': 'Loading trend...',
  'admin.dashboard.trend.empty': 'No activity in this range.',
  'admin.dashboard.revenue': 'Revenue',
  'admin.dashboard.dailyNetRevenue': 'Daily net revenue',
  'admin.dashboard.revenueTrendError': 'Unable to load revenue trend.',
  'admin.dashboard.newUsers': 'New users',
  'admin.dashboard.dailySignups': 'Daily signups',
  'admin.dashboard.newUsersTrendError': 'Unable to load new users trend.',
  'admin.dashboard.newOrgs': 'New orgs',
  'admin.dashboard.dailyNewOrgs': 'Daily new orgs',
  'admin.dashboard.approvals': 'Approvals',
  'admin.dashboard.dailyAuthorizations': 'Daily authorizations',
  'admin.dashboard.approvalsTrendError': 'Unable to load approvals trend.',
  'admin.dashboard.projectsClosed': 'Projects closed',
  'admin.dashboard.dailyProjectsClosed': 'Daily projects closed',
  'admin.dashboard.referralsAccepted': 'Referrals accepted',
  'admin.dashboard.dailyReferralsAccepted': 'Daily referrals accepted',
  'admin.dashboard.approvalRate7d': 'Approval rate (7d)',
  'admin.dashboard.approvalRateSubtitle': 'Approvals ÷ new users',
  'admin.dashboard.referralAcceptanceRate7d': 'Referral acceptance rate (7d)',
  'admin.dashboard.referralRateSubtitle': 'Accepted referrals ÷ sent referrals',
  'admin.dashboard.loadError': 'Failed to load',
  'admin.dashboard.revenueBilling': 'Revenue & Billing',
  'admin.dashboard.promoRedemptions7d': 'Promo redemptions (7d)',
  'admin.dashboard.promoRedemptions30d': 'Promo redemptions (30d)',
  'admin.dashboard.promoDiscount7d': 'Discounts given (7d)',
  'admin.dashboard.promoDiscount30d': 'Discounts given (30d)',
  'admin.dashboard.revenueAllTime': 'Revenue (All-time)',
  'admin.dashboard.promoRedemptionsAllTime': 'Promo Redemptions (All-time)',
  'admin.dashboard.promoDiscountAllTime': 'Promo Discounts (All-time)',
  'admin.dashboard.totalUsers': 'Total Users',
  'admin.dashboard.totalOrgs': 'Total Orgs',
  'admin.dashboard.approvalsAllTime': 'Approvals (All-time)',
  'admin.dashboard.projectsClosedAllTime': 'Projects Closed (All-time)',
  'admin.dashboard.totalReferrals': 'Total Referrals',
  'admin.dashboard.totalReferralsAccepted': 'Total Referrals Accepted',
  'admin.dashboard.promoRedemptions': 'Promo redemptions',
  'admin.dashboard.dailyPromoRedemptions': 'Daily promo redemptions',
  'admin.dashboard.promoTrendError': 'Unable to load promo trend.',
  'admin.dashboard.revenue7d': 'Revenue (7d)',
  'admin.dashboard.revenue30d': 'Revenue (30d)',
  'admin.dashboard.activeSubscriptions': 'Active subscriptions',
  'admin.dashboard.pastDueSubscriptions': 'Past-due subscriptions',
  'admin.dashboard.growth': 'Growth',
  'admin.dashboard.newUsers7d': 'New users (7d)',
  'admin.dashboard.newUsers30d': 'New users (30d)',
  'admin.dashboard.referralsSent7d': 'Referrals sent (7d)',
  'admin.dashboard.referralsSent30d': 'Referrals sent (30d)',
  'admin.dashboard.referralsExpiredOpen': 'Referrals expired (open)',
  'admin.dashboard.newOrgs7d': 'New orgs (7d)',
  'admin.dashboard.newOrgs30d': 'New orgs (30d)',
  'admin.dashboard.engagement': 'Engagement',
  'admin.dashboard.dauToday': 'DAU (today)',
  'admin.dashboard.wau7d': 'WAU (7d)',
  'admin.dashboard.mau30d': 'MAU (30d)',
  'admin.dashboard.operations': 'Operations',
  'admin.dashboard.pendingApprovals': 'Pending approvals',
  'admin.dashboard.recentUsers.title': 'Last 25 new users',
  'admin.dashboard.recentUsers.columns.name': 'Name',
  'admin.dashboard.recentUsers.columns.email': 'Email',
  'admin.dashboard.recentUsers.columns.referrer': 'Referrer',
  'admin.dashboard.recentUsers.columns.signedUp': 'Signed up',
  'admin.dashboard.recentUsers.loading': 'Loading recent users...',
  'admin.dashboard.recentUsers.empty': 'No recent users yet.',
  'admin.dashboard.recentUsers.error': 'Unable to load recent users.',
  'admin.dashboard.loadingPreview': 'Loading preview...',
  'admin.dashboard.previewLoadError': 'Unable to load preview.',
  'admin.dashboard.noPendingApprovals': 'No pending approvals.',
  'admin.dashboard.referredByName': 'Referred by: {name}',
  'admin.dashboard.referredByCode': 'Referred by code: {code}',
  'admin.dashboard.referredByEmpty': 'Referred by: {symbol}',
  'admin.dashboard.viewPendingApprovals': 'View pending approvals',
  'admin.dashboard.viewAll': 'View all',
  'admin.dashboard.shortcuts.users.title': 'Users',
  'admin.dashboard.shortcuts.users.description': 'Search, verify, and manage user accounts.',
  'admin.dashboard.shortcuts.companies.title': 'Companies',
  'admin.dashboard.shortcuts.companies.description': 'Review organizations, plans, and owner details.',
  'admin.dashboard.shortcuts.billing.title': 'Billing',
  'admin.dashboard.shortcuts.billing.description': 'Inspect subscriptions, invoices, and dunning status.',
  'admin.dashboard.shortcuts.pendingApprovals.title': 'Pending approvals',
  'admin.dashboard.shortcuts.pendingApprovals.description': 'Approve new users awaiting access.',
  'admin.dashboard.shortcuts.referrals.title': 'Referrals',
  'admin.dashboard.shortcuts.referrals.description': 'Monitor invites and referral acceptance trends.',
  'dashboard.noModules': 'No modules available.',
  'dashboard.ua.pageTitle': 'Umpire Assistant Dashboard',
  'dashboard.ua.loadFailed': 'Failed to load',
  'dashboard.ua.actions.newProject': 'New Project',
  'dashboard.ua.actions.invoiceSettings': 'Invoice Settings',
  'dashboard.ua.actions.billing': 'Billing',
  'dashboard.ua.actions.myAccount': 'My Account',
  'dashboard.ua.cards.totalProjects': 'Total Projects',
  'dashboard.ua.cards.activeProjects': 'Active Projects',
  'dashboard.ua.cards.closedProjects': 'Closed Projects',
  'dashboard.ua.cards.invoicesInProgressCount': 'Invoices In Progress (Count)',
  'dashboard.ua.cards.invoicesInProgressAmountDue': 'Invoices In Progress (Amount Due)',
  'dashboard.ua.cards.invoicesClosedCount': 'Invoices Closed (Count)',
  'dashboard.ua.cards.closedInvoiceRevenueAmount': 'Closed Invoice Revenue (Amount)',
  'dashboard.ua.recentProjects.title': 'Last 10 Projects (Newest First)',
  'dashboard.ua.recentProjects.empty': 'No projects yet.',
  'dashboard.ua.recentProjects.columns.project': 'Project',
  'dashboard.ua.recentProjects.columns.status': 'Status',
  'dashboard.ua.recentProjects.columns.created': 'Created',
  'dashboard.ua.recentProjects.projectNumber': 'Project #{id}',
  'dashboard.adr.pageTitle': 'ADR Dashboard',
  'dashboard.adr.loadFailed': 'Failed to load',
  'dashboard.adr.actions.newProject': 'New Project',
  'dashboard.adr.actions.invoiceSettings': 'Invoice Settings',
  'dashboard.adr.actions.billing': 'Billing',
  'dashboard.adr.actions.myAccount': 'My Account',
  'dashboard.adr.cards.totalCases': 'Total ADR Cases',
  'dashboard.adr.cards.activeDisputes': 'Active Disputes',
  'dashboard.adr.cards.closedCases': 'Closed ADR Cases',
  'dashboard.adr.cards.invoicesInProgressCount': 'Invoices In Progress (Count)',
  'dashboard.adr.cards.invoicesInProgressAmountDue': 'Invoices In Progress (Amount Due)',
  'dashboard.adr.cards.invoicesClosedCount': 'Invoices Closed (Count)',
  'dashboard.adr.cards.closedInvoiceRevenueAmount': 'Closed Invoice Revenue (Amount)',
  'dashboard.adr.recentProjects.title': 'Last 10 Projects (Newest First)',
  'dashboard.adr.recentProjects.empty': 'No projects yet.',
  'dashboard.adr.recentProjects.columns.project': 'Project',
  'dashboard.adr.recentProjects.columns.status': 'Status',
  'dashboard.adr.recentProjects.columns.created': 'Created',
  'dashboard.adr.recentProjects.projectNumber': 'Project #{id}',
  'dashboard.cr.pageTitle': 'ADR Case Ready Dashboard',
  'dashboard.cr.loadFailed': 'Failed to load',
  'dashboard.cr.actions.newProject': 'New Project',
  'dashboard.cr.actions.invoiceSettings': 'Invoice Settings',
  'dashboard.cr.actions.billing': 'Billing',
  'dashboard.cr.actions.myAccount': 'My Account',
  'dashboard.cr.cards.totalCases': 'Total Case Ready Cases',
  'dashboard.cr.cards.activeDisputes': 'Active Disputes',
  'dashboard.cr.cards.closedCases': 'Closed Case Ready Cases',
  'dashboard.cr.cards.invoicesInProgressCount': 'Invoices In Progress (Count)',
  'dashboard.cr.cards.invoicesInProgressAmountDue': 'Invoices In Progress (Amount Due)',
  'dashboard.cr.cards.invoicesClosedCount': 'Invoices Closed (Count)',
  'dashboard.cr.cards.closedInvoiceRevenueAmount': 'Closed Invoice Revenue (Amount)',
  'dashboard.cr.recentProjects.title': 'Last 10 Projects (Newest First)',
  'dashboard.cr.recentProjects.empty': 'No projects yet.',
  'dashboard.cr.recentProjects.columns.project': 'Project',
  'dashboard.cr.recentProjects.columns.status': 'Status',
  'dashboard.cr.recentProjects.columns.created': 'Created',
  'dashboard.cr.recentProjects.projectNumber': 'Project #{id}',
  'admin.dashboard.approvals7d': 'Approvals (7d)',
  'admin.dashboard.approvals30d': 'Approvals (30d)',
  'admin.pendingApprovals.title': 'Pending Approvals',
  'admin.pendingApprovals.subtitle': 'Review new user registrations awaiting SuperAdmin approval.',
  'admin.pendingApprovals.loading': 'Loading pending approvals…',
  'admin.pendingApprovals.empty': 'No pending approvals.',
  'admin.pendingApprovals.loadError': 'Failed to load pending approvals',
  'admin.pendingApprovals.approveError': 'Failed to approve user',
  'admin.pendingApprovals.approvedTitle': 'User approved',
  'admin.pendingApprovals.approvedDescription': 'Approved {email}',
  'admin.pendingApprovals.approvedErrorTitle': 'Approval failed',
  'admin.pendingApprovals.membershipNone': 'none',
  'admin.pendingApprovals.membershipPending': 'Membership Pending',
  'admin.pendingApprovals.referredBy': 'Referred by: {name} ({code})',
  'admin.pendingApprovals.unknownReferrer': 'Unknown',
  'admin.pendingApprovals.emailVerifiedYes': 'Yes',
  'admin.pendingApprovals.emailVerifiedNo': 'No',
  'admin.pendingApprovals.billingPayAsYouGo': 'Pay As You Go',
  'admin.pendingApprovals.billingSubscription': 'Subscription',
  'admin.pendingApprovals.overrideMembershipPending': 'Override membership pending',
  'admin.pendingApprovals.freeProjects': 'Free projects',
  'admin.dashboard.activeProjectsGlobal': 'Active projects (global)',
  'admin.dashboard.referralsAccepted7d': 'Referrals accepted (7d)',
  'admin.dashboard.referralsAccepted30d': 'Referrals accepted (30d)',
  'admin.dashboard.projectsClosed7d': 'Projects closed (7d)',
  'admin.dashboard.projectsClosed30d': 'Projects closed (30d)',
  'admin.dashboard.referrals': 'Referrals',
  'admin.globalReassign.title': 'Reassign Projects',
  'admin.globalReassign.subtitle': 'Reassign projects across companies or independent projects.',
  'admin.globalReassign.scopeLabel': 'Scope',
  'admin.globalReassign.scopeCompany': 'Company',
  'admin.globalReassign.scopeIndependent': 'Independent',
  'admin.globalReassign.companyLabel': 'Company',
  'admin.globalReassign.companyPlaceholder': 'Select a company',
  'admin.globalReassign.userLabel': 'User',
  'admin.globalReassign.userPlaceholder': 'Select a user',
  'admin.globalReassign.currentOwnerLabel': 'Current owner',
  'admin.globalReassign.currentOwnerPlaceholder': 'All users',
  'admin.globalReassign.assignToLabel': 'Assign to',
  'admin.globalReassign.assignToPlaceholder': 'Select a user',
  'admin.globalReassign.userSearchPlaceholder': 'Search by name or email',
  'admin.globalReassign.projectLabel': 'Project',
  'admin.globalReassign.projectPlaceholder': 'Select a project',
  'admin.globalReassign.projectOption': '{projectName} ({userName}) - Proj ID {projectId}',
  'admin.globalReassign.reassignButton': 'Reassign Project',
  'admin.globalReassign.selectScopeHint': 'Select a scope to continue.',
  'admin.globalReassign.selectCompanyHint': 'Select a company to load users and projects.',
  'admin.globalReassign.selectUserHint': 'Select a user to load projects.',
  'admin.globalReassign.noProjects': 'No projects available.',
  'admin.globalReassign.success': 'Project reassigned.',
  'admin.globalReassign.failure': 'Unable to reassign project.',
  'admin.projects.reassign.title': 'Reassign Projects',
  'admin.projects.reassign.companyScope': 'Company scope',
  'admin.projects.reassign.companyScopeAll': 'Show All',
  'admin.projects.reassign.companyScopeIndependent': 'None / Independent',
  'admin.projects.reassign.companyDivider': '──────────',
  'admin.projects.reassign.companyScopePlaceholder': 'Select a company',
  'admin.projects.reassign.selectCompanyHint': 'Select a company to load users and projects.',
  'admin.projects.reassign.allUsers': 'All Users',
  'admin.projects.reassign.currentOwnerLabel': 'Current owner',
  'admin.projects.reassign.currentOwnerPlaceholder': 'All users',
  'admin.projects.reassign.assignToLabel': 'Assign to',
  'admin.projects.reassign.assignToPlaceholder': 'Select a user',
  'admin.projects.reassign.userSearchPlaceholder': 'Search by name or email',
  'admin.projects.reassign.selectProject': 'Select project',
  'admin.projects.reassign.noProjects': 'No projects available',
  'admin.projects.reassign.untitledProject': 'Untitled Project',
  'admin.projects.reassign.projectOption': '{name} (ID {id})',
  'admin.projects.reassign.previewLoading': 'Loading preview…',
  'admin.projects.reassign.previewEmpty': 'Select a project to preview.',
  'admin.projects.reassign.submit': 'Reassign Project',
  'admin.projects.reassign.lookupSummary': 'Advanced: Lookup by ID/OID',
  'admin.projects.reassign.lookupLabel': 'Project ID or OID',
  'admin.projects.reassign.lookupPlaceholder': 'Project ID or legacy Mongo OID',
  'admin.projects.reassign.lookupLoading': 'Looking up project…',
  'admin.projects.reassign.lookupFailed': 'Lookup failed',
  'admin.projects.reassign.reassignFailed': 'Failed to reassign',
  'admin.projects.reassign.reassigned': 'Project reassigned',
  'admin.projects.reassign.httpError': 'HTTP {status}',
  'admin.projects.reassign.companiesLoadError': 'Companies failed to load: {message}',
  'admin.projects.reassign.usersLoadError': 'Users failed to load: {message}',
  'admin.projects.reassign.projectsLoadError': 'Projects failed to load: {message}',
  'admin.projects.reassign.unexpectedError': 'Unexpected error',
  'admin.referrals.pageTitle': 'Referral Tracker',
  'admin.referrals.subtitle': 'Review referral performance by referrer and date range.',
  'admin.referrals.summaryTitle': 'Summary',
  'admin.referrals.summarySubtitle': 'Global referral performance at a glance.',
  'admin.referrals.summaryLifetime': 'Lifetime Referrals',
  'admin.referrals.summaryLast30': 'Referrals (Last 30 Days)',
  'admin.referrals.hideZeroSenders': 'Hide users with 0 invites sent',
  'admin.referrals.loadingSummary': 'Loading referral summary…',
  'admin.referrals.noReferrersInRange': 'No referrers with invites sent in this date range.',
  'admin.referrals.emptyRange': 'No referral data for this range.',
  'admin.referrals.summaryLoadFailed': 'Failed to load referral summary',
  'admin.referrals.totalsLoadFailed': 'Failed to load referral totals',
  'admin.referrals.detailsLoadFailed': 'Failed to load details',
  'admin.referrals.toast.loadSummaryTitle': 'Failed to load referrals',
  'admin.referrals.toast.loadTotalsTitle': 'Failed to load referral totals',
  'admin.referrals.columns.referrer': 'Referrer',
  'admin.referrals.columns.referralCode': 'Referral Code',
  'admin.referrals.columns.invitesSent': 'Invites Sent',
  'admin.referrals.columns.invitesUsed': 'Invites Used',
  'admin.referrals.columns.referredSignups': 'Referred Signups',
  'admin.referrals.columns.referredApproved': 'Referred Approved',
  'admin.referrals.columns.invitesExpiredOpen': 'Expired',
  'admin.referrals.columns.revenueNet': 'Revenue (Net)',
  'admin.referrals.metrics.invitesSent': 'Invites Sent',
  'admin.referrals.metrics.invitesUsed': 'Invites Used',
  'admin.referrals.metrics.referredSignups': 'Referred Signups',
  'admin.referrals.metrics.referredApproved': 'Referred Approved',
  'admin.referrals.metrics.invitesExpiredOpen': 'Expired (open)',
  'admin.referrals.metrics.netRevenue': 'Net Revenue',
  'admin.referrals.sort.directionAscending': 'ascending',
  'admin.referrals.sort.directionDescending': 'descending',
  'admin.referrals.sort.aria': 'Sort by {label}',
  'admin.referrals.sort.ariaCurrent': 'Sort by {label} (currently {direction})',
  'admin.referrals.detail.title': 'Referral Details',
  'admin.referrals.detail.invitesSent': 'Invites Sent',
  'admin.referrals.detail.invitesUsed': 'Invites Used',
  'admin.referrals.detail.referredSignups': 'Referred Signups',
  'admin.referrals.detail.referredApproved': 'Referred Approved',
  'admin.referrals.detail.accepted': 'Accepted',
  'admin.referrals.detail.loading': 'Loading details…',
  'admin.referrals.detail.empty': 'No results for this range.',
  'admin.referrals.pendingAwards.title': 'Credits pending approval',
  'admin.referrals.pendingAwards.subtitle': 'Review and approve referral credit rewards.',
  'admin.referrals.pendingAwards.table.triggered': 'Triggered',
  'admin.referrals.pendingAwards.table.referrer': 'Referrer',
  'admin.referrals.pendingAwards.table.referred': 'Referred',
  'admin.referrals.pendingAwards.table.event': 'Event',
  'admin.referrals.pendingAwards.table.credits': 'Credits',
  'admin.referrals.pendingAwards.table.evidence': 'Evidence',
  'admin.referrals.pendingAwards.table.notes': 'Notes',
  'admin.referrals.pendingAwards.table.actions': 'Actions',
  'admin.referrals.pendingAwards.actions.approve': 'Approve',
  'admin.referrals.pendingAwards.actions.reject': 'Reject',
  'admin.referrals.pendingAwards.actions.reviewNotesLabel': 'Review notes',
  'admin.referrals.pendingAwards.empty': 'No pending referral credit awards.',
  'admin.referrals.pendingAwards.loadFailed': 'Unable to load pending awards.',
  'admin.referrals.pendingAwards.toast.approved': 'Referral reward approved.',
  'admin.referrals.pendingAwards.toast.rejected': 'Referral reward rejected.',
  'admin.referrals.pendingAwards.toast.actionFailed': 'Unable to update referral reward.',
  'admin.referrals.pendingAwards.pagination.prev': 'Previous',
  'admin.referrals.pendingAwards.pagination.next': 'Next',
  'admin.referrals.pendingAwards.event.signup': 'Signup',
  'admin.referrals.pendingAwards.event.payg_pack': 'PAYG pack purchase',
  'admin.referrals.pendingAwards.event.subscription': 'Subscription start',
  'admin.referrals.tools.title': 'Tools',
  'admin.referrals.tools.exportExpired': 'Download expired eligible referrals (CSV)',
  'admin.referrals.tools.exportPending': 'Download pending referrals (CSV)',
  'admin.referrals.tools.exportUsers': 'Download users (Mailchimp CSV)',
  'admin.referrals.tools.createdSince': 'Created since',
  'admin.referrals.tools.uploadCsv': 'Upload CSV',
  'admin.referrals.tools.uploadHelp': 'Upload a CSV to create a resend job.',
  'admin.referrals.tools.uploading': 'Uploading…',
  'admin.referrals.jobs.title': 'Import jobs',
  'admin.referrals.jobs.view': 'View',
  'admin.referrals.jobs.runOnce': 'Run once',
  'admin.referrals.jobs.empty': 'No import jobs found.',
  'admin.referrals.jobs.columns.created': 'Created',
  'admin.referrals.jobs.columns.job': 'Job',
  'admin.referrals.jobs.columns.status': 'Status',
  'admin.referrals.jobs.columns.total': 'Total',
  'admin.referrals.jobs.columns.queued': 'Queued',
  'admin.referrals.jobs.columns.sent': 'Sent',
  'admin.referrals.jobs.columns.skipped': 'Skipped',
  'admin.referrals.jobs.columns.failed': 'Failed',
  'admin.referrals.jobs.columns.actions': 'Actions',
  'admin.referrals.jobDetail.title': 'Job detail',
  'admin.referrals.jobDetail.queuedRows': 'Queued rows',
  'admin.referrals.jobDetail.loadFailed': 'Unable to load job detail.',
  'admin.referrals.tools.toast.uploadSuccess': 'Import job created.',
  'admin.referrals.tools.toast.uploadFailed': 'Unable to upload CSV.',
  'admin.referrals.tools.toast.runSuccess': 'Processed one row.',
  'admin.referrals.tools.toast.runFailed': 'Unable to run job.',
  'admin.settings.pageTitle': 'Settings',
  'admin.settings.title': 'Settings',
  'admin.settings.subtitle': 'Manage your profile settings.',
  'admin.settings.referUsersTitle': 'Refer Users',
  'admin.settings.referUsersDescription': 'Send an invitation email that pre-populates signup details.',
  'admin.settings.inviteSent': 'Invite sent.',
  'admin.settings.copyLink': 'Copy link',
  'admin.settings.firstName': 'First Name',
  'admin.settings.lastName': 'Last Name',
  'admin.settings.emailAddress': 'Email Address',
  'admin.settings.companyOptional': 'Company (optional)',
  'admin.settings.roleLabel': 'Role',
  'admin.settings.selectRole': 'Select a role',
  'admin.settings.inviteType': 'Invite Type',
  'admin.settings.inviteTypeReferral': 'Referral Invite',
  'admin.settings.inviteTypeCompany': 'Company/Team Invite',
  'admin.settings.organization': 'Organization',
  'admin.settings.sending': 'Sending…',
  'admin.settings.sendInvite': 'Send Invite',
  'admin.settings.recentInvitesTitle': 'Recent Invites',
  'admin.settings.loadingInvites': 'Loading invites…',
  'admin.settings.noInvites': 'No invites yet.',
  'admin.settings.table.invitee': 'Invitee',
  'admin.settings.table.role': 'Role',
  'admin.settings.table.type': 'Type',
  'admin.settings.table.status': 'Status',
  'admin.settings.table.created': 'Created',
  'admin.settings.table.redeemed': 'Redeemed',
  'admin.settings.table.link': 'Link',
  'admin.settings.loadRolesError': 'Failed to load roles.',
  'admin.settings.loadInvitesError': 'Failed to load invites.',
  'admin.settings.sendInviteError': 'Failed to send invite.',
  'admin.settings.inviteTeamMembers.pageTitle': 'Invite Team Members',
  'admin.settings.inviteTeamMembers.accessRestricted': 'Access restricted',
  'admin.settings.inviteTeamMembers.accessRequired': 'Company Admin or Super Admin access is required.',
  'admin.settings.inviteTeamMembers.title': 'Invite Team Members',
  'admin.settings.inviteTeamMembers.subtitle': 'Invite a user to join your organization.',
  'admin.settings.inviteTeamMembers.inviteSent': 'Invite sent to {name}',
  'admin.settings.inviteTeamMembers.firstName': 'First name',
  'admin.settings.inviteTeamMembers.lastName': 'Last name',
  'admin.settings.inviteTeamMembers.email': 'Email',
  'admin.settings.inviteTeamMembers.roleOptional': 'Role (optional)',
  'admin.settings.inviteTeamMembers.selectRole': 'Select a role',
  'admin.settings.inviteTeamMembers.sending': 'Sending…',
  'admin.settings.inviteTeamMembers.sendInvite': 'Send invite',
  'admin.settings.inviteTeamMembers.orgRequired': 'Organization context is required to send an invite.',
  'admin.settings.inviteTeamMembers.loadRolesError': 'Failed to load roles.',
  'admin.settings.inviteTeamMembers.sendInviteError': 'Failed to send invite.',
  'admin.inviteTeamMembers.redirecting': 'Redirecting…',
  'admin.settings.userGuide.pageTitle': 'User’s Guide',
  'admin.settings.userGuide.redirecting': 'Redirecting...',
  'modals.inviteUser.title': 'Invite User',
  'modals.inviteUser.selectCompany': 'Select Company',
  'modals.inviteUser.sending': 'Sending...',
  'modals.inviteUser.sendInvite': 'Send Invite',
  'modals.grantFreeProjects.title': 'Grant Free Project(s)',
  'modals.grantFreeProjects.subtitle': "Adds free credits to the user's billing account.",
  'modals.grantFreeProjects.selectUserError': 'Select a user before granting free projects.',
  'modals.grantFreeProjects.countRangeError': 'Enter a free project count between 1 and 1000.',
  'modals.grantFreeProjects.grantError': 'Failed to grant free projects',
  'modals.grantFreeProjects.grantedTitle': 'Free projects granted',
  'modals.grantFreeProjects.grantedDescription': 'Added {count} free project(s).',
  'modals.grantFreeProjects.grantFailedTitle': 'Grant failed',
  'modals.grantFreeProjects.grantFailedDescription': 'Unable to grant free projects.',
  'modals.grantFreeProjects.countLabel': 'Free projects to grant',
  'modals.grantFreeProjects.noteLabel': 'Note (optional)',
  'modals.grantFreeProjects.nameLabel': 'Name:',
  'modals.grantFreeProjects.emailLabel': 'Email:',
  'modals.grantFreeProjects.granting': 'Granting...',
  'modals.grantFreeProjects.grant': 'Grant',
  'tables.users.actionsLabel': 'Actions',
  'tables.users.editUser': 'Edit User',
  'tables.users.editBillingTypes': 'Edit Billing Types',
  'tables.users.editReferralCode': 'Edit Referral Code',
  'tables.users.billingHistory': 'Billing / History',
  'tables.users.noBillingAccount': 'No billing account',
  'tables.users.grantFreeProjects': 'Grant Free Project(s)…',
  'tables.users.changeAccountType': 'Change Account Type…',
  'tables.users.makeSuperAdmin': 'Make SuperAdmin',
  'tables.users.removeSuperAdmin': 'Remove SuperAdmin',
  'tables.users.resendVerificationEmail': 'Resend Verification Email',
  'tables.users.verifyEmail': 'Verify Email',
  'tables.users.unverifyEmail': 'Unverify Email',
  'tables.users.authorize': 'Authorize',
  'tables.users.unauthorize': 'Unauthorize',
  'tables.users.activate': 'Activate',
  'tables.users.deactivate': 'Deactivate',
  'tables.users.deleteUser': 'Delete User',
  'tables.users.confirmDelete': 'Are you sure you want to delete {identifier}? This will remove their access.',
  'tables.users.confirmDeleteFallback': 'this user',
  'tables.users.actionFailed': 'Failed to {action}',
  'tables.users.actionCompleted': 'Action completed successfully.',
  'tables.users.actionFailedTitle': 'Action failed',
  'tables.users.actionFailedDescription': 'Unable to perform action.',
  'tables.users.resendVerificationError': 'Failed to resend verification email',
  'tables.users.verificationEmailSentTitle': 'Verification email sent.',
  'tables.users.verificationEmailSentDescription': 'Verification email sent.',
  'tables.users.resendFailedTitle': 'Resend failed',
  'tables.users.resendFailedDescription': 'Unable to resend verification email.',
  'tables.users.referralCode': 'Referral Code',
  'tables.users.activeSubscriber': 'Active Subscriber',
  'tables.users.freeCredits': 'Free Credits (Used / Avail)',
  'tables.users.paidCredits': 'Paid Credits (Used / Avail)',
  'tables.users.yes': 'Yes',
  'tables.users.referralCodeLabel': 'Referral code: {code}',
  'tables.users.activeSubscriberLabel': 'Active Subscriber: {value}',
  'tables.users.freeCreditsLabel': 'Free Credits: {used} / {available}',
  'tables.users.paidCreditsLabel': 'Paid Credits: {used} / {available}',
  'projectsv2.detail.pageTitle': 'Project',
  'projectsv2.detail.invalidId': 'Invalid project ID',
  'projectsv2.detail.tabs.organize': 'Organize Items',
  'projectsv2.detail.tabs.pair': 'Pair Items',
  'projectsv2.detail.tabs.summary': 'Initial Summary',
  'projectsv2.detail.tabs.selections': 'Selections',
  'projectsv2.detail.tabs.final': 'Final Summary',
  'projectsv2.detail.owner': 'Owner: {owner}',
  'projectsv2.detail.updatedAt': 'Updated {date}',
  'projectsv2.projects.pageTitle': 'Projects',
  'projectsv2.setup.pageTitle': 'Setup Project',
  'projectsv2.setup.pageTitleWithName': 'Setup Project - {name}',
  'projectsv2.setup.createdAt': 'Created {date}',
  'projectsv2.setup.updatedAt': 'Updated {date}',
  'projectsv2.setup.closedNotice': 'This project is closed (read-only).',
  'projectsv2.setup.logoAlt': 'Logo',
  'projectsv2.setup.signors': '{count} signor(s)',
  'projectsv2.setup.sections.project': 'Project',
  'projectsv2.setup.sections.insuredInformation': 'Insured’s Information',
  'projectsv2.setup.sections.locationOfLoss': 'Location of the Loss',
  'projectsv2.setup.sections.appraiserInformation': 'Appraiser Information',
  'projectsv2.setup.sections.representativeInformation': 'Representative Information',
  'projectsv2.setup.sections.claimFinancials': 'Claim Financials',
  'projectsv2.setup.fields.projectName': 'Project Name',
  'projectsv2.setup.fields.umpireName': 'Umpire Name',
  'projectsv2.setup.fields.insuredName': 'Insured’s Name',
  'projectsv2.setup.fields.insuranceProviderName': 'Insurance Provider Name',
  'projectsv2.setup.fields.claimNumber': 'Claim Number',
  'projectsv2.setup.fields.policyNumber': 'Policy Number',
  'projectsv2.setup.fields.lossDate': 'Date of Loss',
  'projectsv2.setup.fields.logo': 'Logo',
  'projectsv2.setup.fields.typeOfLoss': 'Type of Loss',
  'projectsv2.setup.fields.causeOfLoss': 'Cause of Loss',
  'projectsv2.setup.fields.address': 'Address',
  'projectsv2.setup.fields.city': 'City',
  'projectsv2.setup.fields.state': 'State',
  'projectsv2.setup.fields.zipCode': 'Zip Code',
  'projectsv2.setup.fields.deductibleAmount': 'Deductible Amount',
  'projectsv2.setup.fields.priorPayments': 'Prior Payments',
  'projectsv2.setup.fields.insured': 'Insured',
  'projectsv2.setup.fields.insuredAppraiser': 'Insured Appraiser',
  'projectsv2.setup.fields.carrierRepresentative': 'Carrier’s Representative',
  'projectsv2.setup.fields.carrierAppraiser': 'Carrier Appraiser',
  'projectsv2.finalInvoice.pageTitle': 'Final Invoice',
  'projectsv2.steps.setupProject': 'SETUP PROJECT',
  'projectsv2.steps.upload': 'UPLOAD',
  'projectsv2.steps.organizeItems': 'ORGANIZE ITEMS',
  'projectsv2.steps.pairItems': 'PAIR ITEMS',
  'projectsv2.steps.initialDispute': 'INITIAL DISPUTE SUMMARY',
  'projectsv2.steps.selections': 'SELECTIONS',
  'projectsv2.steps.finalDispute': 'FINAL DISPUTE SUMMARY',
  'projectsv2.steps.finalAward': 'FINAL AWARD',
  'projectsv2.steps.finalRelease': 'FINAL RELEASE',
  'projectsv2.steps.finalInvoice': 'FINAL INVOICE',
  'projectsv2.common.closedReadOnly': 'Project is Closed (read-only)',
  'projectsv2.help.helpWithFile': 'Help',
  'projectsv2.help.stopHelping': 'Stop Helping',
  'projectsv2.help.helpingLabel': 'Helping',
  'projectsv2.help.toastStarted': 'You’re now helping with this file.',
  'projectsv2.help.toastStopped': 'You stopped helping with this file.',
  'projectsv2.header.errors.failedToLoadProject': 'Failed to load project',
  'projectsv2.header.labels.project': 'Project',
  'projectsv2.header.status.closed': 'Closed',
  'projectsv2.header.cta.continueToOrganize': 'Continue to Organize',
  'projectsv2.header.cta.goToPairItems': 'Go to Pair Items',
  'projectsv2.header.cta.continueToInitialDispute': 'Continue to Initial Dispute Summary',
  'projectsv2.header.cta.continueToSelections': 'Continue to Selections',
  'projectsv2.header.cta.continueToFinalDispute': 'Continue to Final Dispute Summary',
  'projectsv2.header.cta.continueToFinalOutcome': 'Continue to {label}',
  'projectsv2.header.cta.continueToFinalInvoice': 'Continue to Final Invoice',
  'projectsv2.header.cta.backToFinalDispute': 'Back to Final Dispute Summary',
  'projectsv2.header.cta.backToFinalRelease': 'Back to Final Release',
  'projectsv2.upload.projectDetails': 'Project Details',
  'projectsv2.upload.unassigned': 'Unassigned',
  'projectsv2.upload.uploadingWithName': 'Uploading {name}…',
  'projectsv2.upload.processing': 'Processing…',
  'projectsv2.upload.confirmRemoveFile':
    'Remove this {label} PDF and all associated items? This cannot be undone.',
  'projectsv2.upload.toastFileRemoved': '{label} file removed.',
  'projectsv2.upload.toastUploadReceived': 'Upload received. Parsing in background…',
  'projectsv2.upload.toastUploadSlow':
    'Upload received but parse service is slow. We’ll keep trying — use “Reparse” if needed.',
  'projectsv2.upload.toastDeleteFailed': 'Delete failed',
  'projectsv2.upload.toastReingestFailed': 'Re-ingest failed',
  'projectsv2.upload.titles.carrier': 'Upload Carrier Estimate',
  'projectsv2.upload.titles.insured': 'Upload Insured Estimate',
  'projectsv2.upload.dropzone.prompt': 'Click to choose a file or drag here.',
  'projectsv2.upload.dropzone.supported': 'Supported: PDF, XLSX, CSV, XML.',
  'projectsv2.upload.status.parsed': 'Parsed',
  'projectsv2.upload.status.parsing': 'Parsing...',
  'projectsv2.upload.actions.reparse': 'Reparse',
  'projectsv2.upload.actions.deleteFile': 'Delete File',
  'projectsv2.upload.actions.downloadJson': 'Download JSON',
  'projectsv2.upload.actions.downloadFile': 'Download File',
  'projectsv2.upload.actions.markAsCarrier': 'Mark as Carrier',
  'projectsv2.upload.actions.markAsInsured': 'Mark as Insured',
  'projectsv2.upload.actions.unassign': 'Unassign',
  'projectsv2.pair.title': 'Pair Items',
  'projectsv2.pair.pageTitle': 'Pair Items',
  'projectsv2.pair.pageTitleWithName': 'Pair Items - {name}',
  'projectsv2.pair.empty.title': 'No items yet',
  'projectsv2.pair.empty.body': 'Upload files to start pairing items.',
  'projectsv2.pair.empty.noPairingItems': 'No items available for pairing.',
  'projectsv2.pair.layout.label': 'Layout',
  'projectsv2.pair.layout.lanes': 'Lanes',
  'projectsv2.pair.layout.unified': 'Unified',
  'projectsv2.selections.title': 'Selections',
  'projectsv2.selections.download.pdf': 'PDF',
  'projectsv2.selections.download.xlsx': 'XLSX',
  'projectsv2.selections.loadingAreas': 'Loading areas…',
  'projectsv2.selections.loadingSelections': 'Loading selections…',
  'projectsv2.selections.emptyNoPairings': 'No pairings yet.',
  'projectsv2.selections.toast.saved': 'Selections saved.',
  'projectsv2.selections.toast.partialRefresh':
    'Some rows may not have been updated. Refreshing to reconcile.',
  'projectsv2.selections.errors.refreshFailed': 'Refresh failed',
  'projectsv2.selections.errors.refreshFailedDescription': 'Failed to refresh selections.',
  'projectsv2.selections.errors.loadFailed': 'Failed to load selections: {message}',
  'projectsv2.selections.errors.loadPairingState': 'Failed to load pairing state.',
  'projectsv2.initialDispute.summaryTitle': 'Initial Dispute Summary',
  'projectsv2.initialDispute.deltaLabel': 'Delta / Disputed Amount:',
  'projectsv2.initialDispute.actions.continueToSelections': 'Continue to Selections',
  'projectsv2.initialDispute.status.continuing': 'Continuing…',
  'projectsv2.initialDispute.download.carrierPdf': 'Carrier (PDF)',
  'projectsv2.initialDispute.download.carrierXlsx': 'Carrier (XLSX)',
  'projectsv2.initialDispute.download.insuredPdf': 'Insured (PDF)',
  'projectsv2.initialDispute.download.insuredXlsx': 'Insured (XLSX)',
  'projectsv2.initialDispute.download.summaryPdf': 'Summary (PDF)',
  'projectsv2.initialDispute.download.summaryXlsx': 'Summary (XLSX)',
  'projectsv2.initialDispute.download.lineItemPdf': 'Line Item (PDF)',
  'projectsv2.initialDispute.download.lineItemXlsx': 'Line Item (XLSX)',
  'projectsv2.finalAward.errors.failedToLoad': 'Failed to load Final Award',
  'projectsv2.finalAward.docLabel.finalAward': 'Final Award',
  'projectsv2.finalAward.docLabel.finalRelease': 'Final Release',
  'projectsv2.finalAward.formTitle': 'Final Award Form',
  'projectsv2.finalAward.header': 'FINAL AWARD FORM',
  'projects.finalAward.saving': 'Saving…',
  'projects.finalAward.saveFailed': 'Couldn’t save changes. Please try again.',
  'projectsv2.finalInvoice.title': 'Final Invoice',
  'projectsv2.finalInvoice.subtitle': 'Select which awarded items should appear on the final invoice.',
  'projectsv2.finalInvoice.loading': 'Loading final invoice…',
  'projectsv2.finalInvoice.actions.downloadPdf': 'Download Final Invoice PDF',
  'projectsv2.finalInvoice.actions.selectArea': 'Select area',
  'projectsv2.finalInvoice.actions.deselectArea': 'Deselect area',
  'projectsv2.finalInvoice.empty.title': 'No eligible invoice items yet.',
  'projectsv2.finalInvoice.empty.subtitle': 'Adjust your selections to populate this page.',
  'projectsv2.finalInvoice.errors.loadFinalSummary': 'Failed to load final summary',
  'projectsv2.finalInvoice.errors.loadSelections': 'Failed to load invoice selections',
  'projectsv2.finalInvoice.errors.loadData': 'Failed to load final invoice data.',
  'projectsv2.finalInvoice.errors.saveSelections': 'Failed to save selections',
  'projectsv2.finalInvoice.toast.selectionsSaved': 'Invoice selections saved',
  'projectsv2.finalInvoice.areaTotals.selected': 'Total Selected: {rcv} (RCV) / {acv} (ACV)',
  'projectsv2.finalInvoice.table.select': 'Select',
  'projectsv2.finalInvoice.table.description': 'Description',
  'projectsv2.finalInvoice.table.coverage': 'Coverage',
  'projectsv2.finalInvoice.table.qty': 'Qty',
  'projectsv2.finalInvoice.table.unitPrice': 'Unit Price',
  'projectsv2.finalInvoice.table.op': 'O&P',
  'projectsv2.finalInvoice.table.tax': 'Tax',
  'projectsv2.finalInvoice.table.rcv': 'RCV',
  'projectsv2.finalInvoice.table.depreciation': 'Depreciation',
  'projectsv2.finalInvoice.table.acv': 'ACV',
  'projectsv2.declarationAppraisersUmpire.title': 'Declaration of Appraisers and Selection of Umpire',
  'projectsv2.declarationAppraisersUmpire.downloadPdf': 'Download PDF',
  'projectsv2.declarationAppraisersUmpire.section.declaration': 'Declaration of Appraisers',
  'projectsv2.declarationAppraisersUmpire.section.selection': 'Selection of Umpire',
  'projectsv2.declarationAppraisersUmpire.section.qualification': 'Qualification of Umpire',
  'projectsv2.declarationAppraisersUmpire.body.declaration':
    'We, the undersigned will act with strict impartiality in making an appraisement of the actual cash value and the amount of loss upon the property mentioned, that we will make a true, just and conscientious award of the same, according to the best of our knowledge, skill and judgment. We are competent to set the amount of the loss, are not related to the insured, either as creditors or otherwise, are not interested in said property or the insurance thereon. The deliberation of the Appraisal Panel is confidential and exempt from depositions or suit in case the Award is challenged, or a bad faith claim or breach of contract is filed. Furthermore, to the maximum extent permitted by law, no party will assert any claims against the named Appraisers or the named Umpire or their respective firms, seeking to hold them or their firms liable for any act or omission in performing their duties as an Appraiser or Umpire.',
  'projectsv2.declarationAppraisersUmpire.body.selection':
    'We the undersigned hereby select and appoint to act as umpire to settle matters of difference that shall exist between us.',
  'projectsv2.declarationAppraisersUmpire.body.qualification':
    'I, the undersigned, hereby accept the appointment of neutral Umpire, as provided in the foregoing agreement, and solemnly swear that I will act with strict impartiality in all matters of difference that shall be submitted to me in connection with this appointment, and I will make a true, just and conscientious award, according to the best of my knowledge, skill and judgment, and agree to supply an estimate that coincides with the award. I am not related to any of the parties to this memorandum nor interested as a creditor or otherwise in said property of insurance.',
  'projectsv2.declarationAppraisersUmpire.signBlock.insuredAppraiser': 'Insured’s Appraiser',
  'projectsv2.declarationAppraisersUmpire.signBlock.carrierAppraiser': 'Carrier’s Appraiser',
  'projectsv2.declarationAppraisersUmpire.signBlock.umpire': 'Appointed Umpire',
  'projectsv2.declarationAppraisersUmpire.notAvailable':
    'This document is available in Umpire Assistant projects only.',
  'projectsv2.finalRelease.docLabel': 'Final Release',
  'projectsv2.finalRelease.loadingEditor': 'Loading editor…',
  'projectsv2.finalRelease.sections.projectDetails': 'Project Details',
  'projectsv2.finalRelease.sections.releaseNarrative': 'Release Narrative',
  'projectsv2.finalRelease.sections.status': 'Status',
  'projectsv2.finalRelease.sections.totalAmount': 'Total Amount',
  'projectsv2.finalRelease.sections.signatures': 'Signatures',
  'projectsv2.finalRelease.projectDetails.carrier': 'Carrier',
  'projectsv2.finalRelease.projectDetails.insured': 'Insured',
  'projectsv2.finalRelease.projectDetails.claimNumber': 'Claim #',
  'projectsv2.finalRelease.projectDetails.dateOfLoss': 'Date of Loss',
  'projectsv2.finalRelease.projectDetails.property': 'Property',
  'projectsv2.finalRelease.projectDetails.location': 'Location',
  'projectsv2.finalRelease.labels.releaseText': 'Release Text',
  'projectsv2.finalRelease.labels.importantInformation': 'Important Information',
  'projectsv2.finalRelease.governingLaw.leadIn':
    'The terms of this Release are contractual, not a mere recital. This Release shall be governed by and construed under the laws of the',
  'projectsv2.finalRelease.governingLaw.selectState': 'Select state',
  'projectsv2.finalRelease.governingLaw.other': 'Other',
  'projectsv2.finalRelease.governingLaw.enterJurisdiction': 'Enter jurisdiction',
  'projectsv2.finalRelease.confirm.replaceWithDefaultTemplate':
    'Replace existing content with the default template?',
  'projectsv2.finalRelease.caution.title': 'CAUTION - THIS IS A RELEASE',
  'projectsv2.finalRelease.caution.subtitle': 'READ CAREFULLY BEFORE SIGNING',
  'projectsv2.finalRelease.actions.insertDefaultLanguage': 'Insert Default Language',
  'projectsv2.finalRelease.actions.downloadPdf': 'Download {docLabel} PDF',
  'projectsv2.finalRelease.signatures.helper': 'Capture signatures for each party to finalize the release.',
  'projectsv2.finalRelease.signorTypes.spouse': 'Spouse',
  'projectsv2.finalRelease.signorTypes.assignmentOfBenefits': 'Assignment of Benefits',
  'projectsv2.finalRelease.status.releaseAccepted.title': 'Release Accepted',
  'projectsv2.finalRelease.status.releaseAccepted.subtitle':
    'Indicates both parties have accepted the release.',
  'projectsv2.finalRelease.status.releaseAccepted.aria': 'Toggle release accepted',
  'projectsv2.finalRelease.notary.title': 'Notary Details',
  'projectsv2.finalRelease.notary.ariaToggle': 'Toggle notarized',
  'projectsv2.finalRelease.notary.labels.notaryName': 'Notary Name',
  'projectsv2.finalRelease.notary.labels.commissionNumber': 'Commission Number',
  'projectsv2.finalRelease.notary.labels.commissionExpiration': 'Commission Expiration',
  'projectsv2.finalRelease.notary.labels.state': 'State',
  'projectsv2.finalRelease.notary.labels.county': 'County',
  'projectsv2.finalRelease.notary.labels.appearedName': 'Appeared Name',
  'projectsv2.finalRelease.notary.labels.identification': 'Identification',
  'projectsv2.finalRelease.notary.labels.statuteReference': 'Statute Reference',
  'projectsv2.finalRelease.notary.labels.lawLocation': 'Law Location',
  'projectsv2.finalRelease.notary.labels.day': 'Day',
  'projectsv2.finalRelease.notary.labels.month': 'Month',
  'projectsv2.finalRelease.notary.labels.year': 'Year',
  'projectsv2.finalRelease.notary.placeholders.notaryName': 'Notary public name',
  'projectsv2.finalRelease.notary.placeholders.commissionNumber': 'Commission number',
  'projectsv2.finalRelease.notary.placeholders.state': 'State',
  'projectsv2.finalRelease.notary.placeholders.county': 'County',
  'projectsv2.finalRelease.notary.placeholders.appearedName': 'Person appearing before the notary',
  'projectsv2.finalRelease.notary.placeholders.identification': 'Identification presented',
  'projectsv2.finalRelease.notary.placeholders.statuteReference': 'Statute reference (optional)',
  'projectsv2.finalRelease.notary.placeholders.lawLocation': 'Location of law (optional)',
  'projectsv2.finalRelease.notary.placeholders.day': 'DD',
  'projectsv2.finalRelease.notary.placeholders.month': 'MM',
  'projectsv2.finalRelease.notary.placeholders.year': 'YYYY',
  'projectsv2.finalRelease.notary.seal.label': 'Notary Seal',
  'projectsv2.finalRelease.notary.seal.altPreview': 'Notary seal preview',
  'projectsv2.finalRelease.notary.seal.fileId': 'Seal file ID: {id}',
  'projectsv2.finalRelease.notary.seal.none': 'No seal uploaded',
  'projectsv2.finalRelease.notary.seal.actions.upload': 'Upload Seal',
  'projectsv2.finalRelease.notary.help.acceptedFormats': 'Accepted formats: PNG, JPG, or WebP up to 5 MB.',
  'projectsv2.finalRelease.notary.help.enableNotarization':
    'Enable notarization to capture notary details for ADR final releases.',
  'projectsv2.finalRelease.errors.notarySealMustBeImage': 'Notary seal must be an image file.',
  'projectsv2.finalRelease.errors.failedToReadNotarySeal': 'Failed to read notary seal.',
  'projectsv2.finalRelease.errors.loadFailed': 'Failed to load final release.',
  'projectsv2.finalRelease.errors.saveFailed': 'Failed to save final release.',
  'projectsv2.finalRelease.narrativeSections.introduction': 'INTRODUCTION',
  'projectsv2.finalRelease.narrativeSections.consideration': 'CONSIDERATION',
  'projectsv2.finalRelease.narrativeSections.fullRelease': 'FULL RELEASE OF ANY AND ALL CLAIMS',
  'projectsv2.finalRelease.narrativeSections.noReliance': 'NO RELIANCE ON REPRESENTATIONS',
  'projectsv2.finalRelease.narrativeSections.confidentiality': 'CONFIDENTIALITY',
  'projectsv2.finalRelease.narrativeSections.indemnification': 'INDEMNIFICATION',
  'projectsv2.finalRelease.narrativeSections.entireAgreement': 'ENTIRE AGREEMENT',
  'projectsv2.finalRelease.coverage.fallbackWithId': 'Coverage {id}',
  'projectsv2.finalRelease.coverage.uncategorized': 'Uncategorized',
  'projectsv2.finalRelease.totals.headers.coverage': 'Coverage',
  'projectsv2.finalRelease.totals.headers.rcv': 'RCV',
  'projectsv2.finalRelease.totals.headers.deprec': 'Deprec.',
  'projectsv2.finalRelease.totals.headers.acv': 'ACV',
  'projectsv2.finalRelease.totals.headers.deductible': 'Deductible ($)',
  'projectsv2.finalRelease.totals.headers.priorPayments': 'Prior Payments ($)',
  'projectsv2.finalRelease.totals.headers.remainingAcv': 'Remaining ACV ($)',
  'projectsv2.finalRelease.totals.totalRow': 'Total',
  'projectsv2.finalOutcome.v2.totalItems': 'Total items:',
  'projectsv2.finalOutcome.v2.actions.downloadCsv': 'Download {docLabel} CSV',
  'projectsv2.finalOutcome.v2.actions.downloadPdf': 'Download {docLabel} PDF',
  'projectsv2.finalOutcome.v2.errors.failedToLoadAward': 'Failed to load Final Award',
  'projectsv2.finalOutcome.v2.errors.couldntLoadAward': 'Couldn’t load Final Award',
  'projectsv2.finalOutcome.v2.errors.couldntLoadRelease': 'Couldn’t load Final Release',
  'projectsv2.finalOutcome.v2.empty.awardTitle': 'No final award items yet',
  'projectsv2.finalOutcome.v2.empty.releaseTitle': 'No final release items yet',
  'projectsv2.finalOutcome.v2.empty.subtitle': 'Complete selections to populate this page.',
  'projectsv2.finalOutcome.v2.empty.reviewFinalSummary': 'Review Final Dispute Summary',
  'projectsv2.finalOutcome.v2.summary.replacementCostValue': 'Replacement Cost Value',
  'projectsv2.finalOutcome.v2.summary.depreciation': 'Depreciation',
  'projectsv2.finalOutcome.v2.summary.actualCashValue': 'Actual Cash Value',
  'projectsv2.finalOutcome.v2.table.description': 'Description',
  'projectsv2.finalOutcome.v2.table.coverage': 'Coverage',
  'projectsv2.finalOutcome.v2.table.decision': 'Decision',
  'projectsv2.finalOutcome.v2.table.qty': 'Qty',
  'projectsv2.finalOutcome.v2.table.unitPrice': 'Unit Price',
  'projectsv2.finalOutcome.v2.table.rcv': 'RCV',
  'projectsv2.finalOutcome.v2.table.depreciation': 'Depreciation',
  'projectsv2.finalOutcome.v2.table.acv': 'ACV',
  'projectsv2.finalOutcome.v2.coverage.fallbackWithId': 'Coverage {id}',
  'projectsv2.finalOutcome.v2.coverage.unspecified': 'Unspecified',
  'projectsv2.finalOutcome.decision.carrier': 'Carrier',
  'projectsv2.finalOutcome.decision.insured': 'Insured',
  'projectsv2.finalOutcome.decision.split': 'Split',
  'projectsv2.finalOutcome.decision.neither': 'Neither',
  'projectsv2.summaryToggles.hideZeroItems': 'Do Not Show $0 Items',
  'projectsv2.summaryToggles.showTax': 'Show Tax',
  'projectsv2.summaryToggles.showOandP': 'Show O&P',
  'projectsv2.organize.pageTitle': 'Organize Items',
  'projectsv2.organize.toast.missingEstimates':
    'Upload and ingest both Carrier and Insured estimates to continue.',
  'projectsv2.organize.errorBoundary': 'Something went wrong loading Organize. Check console.',
  'projectsv2.organize.emptyArea': 'No items in this area yet.',
  'projectsv2.organize.loadSlow': 'Taking longer than expected. You can retry.',
  'projectsv2.organize.stepProgress': 'Step {current} of {total}',
  'projectsv2.organize.errors.editorUnavailable': 'Editor unavailable right now.',
  'projectsv2.organize.errors.dragDataInvalid': 'Drag data invalid.',
  'projectsv2.organize.errors.listChanged': 'List changed—refresh and try again.',
  'projectsv2.organize.errors.orderNotPersisted': 'Order not persisted—update pending migration.',
  'projectsv2.organize.errors.moveAcrossSides': 'You can’t move items across sides.',
  'projectsv2.organize.errors.invalidRequest': 'Invalid request—please retry.',
  'projectsv2.organize.errors.unexpected': 'Unexpected error—try again.',
  'projectsv2.organize.errors.saveOrderFailed': 'Failed to save order.',
  'projectsv2.organize.errors.invalidProjectLane': 'Invalid project or lane.',
  'projectsv2.organize.errors.deleteFailed': 'Unable to delete area.',
  'projectsv2.organize.errors.renameFailed': 'Rename failed.',
  'projectsv2.organize.errors.areaTotalsLoadFailed': 'Unable to load area totals.',
  'projectsv2.organize.errors.totalsLoadFailed': 'Unable to load totals.',
  'projectsv2.organize.errors.createAreaFailed': 'Unable to create area.',
  'projectsv2.organize.errors.saveItemFailed': 'Unable to save item.',
  'projectsv2.organize.errors.areaNameExists': 'An area with this name already exists.',
  'projectsv2.organize.errors.areaRenameUnavailable': 'This area cannot be renamed right now.',
  'projectsv2.organize.errors.unassignedAreasCannotBeRenamed': 'Unassigned areas cannot be renamed.',
  'projectsv2.organize.errorWithCode': '{code}: {message}',
  'projectsv2.organize.subtotalPlaceholder': 'Subtotal --',
  'projectsv2.organize.subtotalWithValue': 'Subtotal {value}',
  'projectsv2.organize.totals.rcvTotal': 'RCV Total: {value}',
  'projectsv2.organize.totals.acvTotal': 'ACV Total: {value}',
  'projectsv2.organize.totals.rcvTotalLabel': 'RCV Total:',
  'projectsv2.organize.totals.acvTotalLabel': 'ACV Total:',
  'projectsv2.organize.originalLineNumber': '#{line}',
  'projectsv2.organize.actions.dragToReorder': 'Drag to reorder',
  'projectsv2.organize.actions.dragToPair': 'Drag to pair',
  'projectsv2.organize.actions.expandArea': 'Expand area',
  'projectsv2.organize.actions.collapseArea': 'Collapse area',
  'projectsv2.organize.actions.openMenu': 'Open menu',
  'projectsv2.organize.actions.openPairingMenu': 'Open pairing menu',
  'projectsv2.organize.title': 'Organize Items',
  'projectsv2.organize.empty': 'No items yet.',
  'projectsv2.organize.readOnly': 'Read-only mode',
  'projectsv2.organize.expandAll': 'Expand all',
  'projectsv2.organize.collapseAll': 'Collapse all',
  'projectsv2.organize.carrier': 'Carrier',
  'projectsv2.organize.insured': 'Insured',
  'projectsv2.organize.areaHeader': '{label} Areas',
  'projectsv2.organize.areaFallback': 'Area {id}',
  'projectsv2.organize.addArea': 'Add area',
  'projectsv2.organize.addItem': 'Add item',
  'projectsv2.organize.addItemHere': 'Add item here',
  'projectsv2.organize.mirrorAreas': 'Mirror areas',
  'projectsv2.organize.laneMenu.add': 'Add',
  'projectsv2.organize.laneMenu.manage': 'Manage',
  'projectsv2.organize.laneMenu.view': 'View',
  'projectsv2.organize.mirrorComplete':
    'Mirror complete. Created {carrier} carrier areas and {insured} insured areas.',
  'projectsv2.organize.addDepreciation': 'Manage Depreciation',
  'projectsv2.organize.manageDepreciation': 'Manage Depreciation',
  'projectsv2.organize.addDepreciationTo': 'Add depreciation to {item}',
  'projectsv2.organize.removeDepreciationFrom': 'Remove depreciation from {item}',
  'projectsv2.organize.manageOandP': 'Manage O&P',
  'projectsv2.organize.manageOandPToArea': 'Manage O&P for {areaName}',
  'projectsv2.organize.manageOandPToItem': 'Manage O&P for {itemName}',
  'projectsv2.organize.reprice': 'Reprice',
  'projectsv2.organize.rearrangeAreas': 'Rearrange Areas',
  'projectsv2.organize.rearrangeItems': 'Rearrange Items',
  'projectsv2.organize.rearrange.title': 'Rearrange',
  'projectsv2.organize.rearrange.selectArea': 'Select area',
  'projectsv2.organize.rearrange.columnNumber': '#',
  'projectsv2.organize.rearrange.columnNewNumber': 'New #',
  'projectsv2.organize.rearrange.compact': 'Compact',
  'projectsv2.organize.rearrange.compare': 'Compare',
  'projectsv2.organize.rearrange.compareLane': 'Other Lane',
  'projectsv2.organize.rearrange.selectCompareArea': 'Select area to compare',
  'projectsv2.organize.rearrange.dragHandleAria': 'Drag to move dialog',
  'projectsv2.organize.rearrange.loading': 'Loading…',
  'projectsv2.organize.rearrange.dndHelp': 'Drag and drop items to set the order.',
  'projectsv2.organize.rearrange.empty': 'No items to rearrange.',
  'projectsv2.organize.rearrange.error.selectArea': 'Please select an area.',
  'projectsv2.organize.rearrange.error.invalidNumber': 'All positions must be whole numbers.',
  'projectsv2.organize.rearrange.error.outOfRange': 'Positions must be between 1 and {count}.',
  'projectsv2.organize.rearrange.error.duplicates': 'Each position number must be unique.',
  'projectsv2.organize.repriceItem': 'Reprice {item}',
  'projectsv2.organize.reorder.dragAria': 'Drag to reorder',
  'projectsv2.organize.reorder.moveUpAria': 'Move up',
  'projectsv2.organize.reorder.moveDownAria': 'Move down',
  'projectsv2.organize.reorder.failedToast': 'Failed to reorder areas',
  'projectsv2.organize.viewOriginalPdf': 'View original {label} PDF',
  'projectsv2.organize.viewOriginalCarrierPdf': 'Original Carrier PDF',
  'projectsv2.organize.viewOriginalInsuredPdf': 'Original Insured PDF',
  'projectsv2.organize.pdfNotUploaded': 'Original {label} PDF not uploaded',
  'projectsv2.organize.deltaDisputed': 'Delta (Disputed)',
  'projectsv2.organize.itemFallback': 'Item #{id}',
  'projectsv2.organize.itemCount': '({count})',
  'projectsv2.organize.untitledItem': 'Untitled item',
  'projectsv2.organize.aria.carrierItem': 'Carrier item',
  'projectsv2.organize.aria.insuredItem': 'Insured item',
  'projectsv2.organize.aria.quantity': 'Quantity: {quantity}',
  'projectsv2.organize.aria.area': 'Area: {area}',
  'projectsv2.organize.pairingMenu.title': 'Pairing',
  'projectsv2.organize.pairingMenu.toggleTooltip': 'Toggle pairing mode',
  'projectsv2.organize.pairingMenu.pairingMode': 'Pairing mode',
  'projectsv2.organize.areaMenu.title': 'Area actions',
  'projectsv2.organize.itemMenu.title': 'Item actions',
  'projectsv2.organize.highlightPaired': 'Highlight paired item',
  'projectsv2.organize.highlightPairedLabel': 'Highlight paired',
  'projectsv2.organize.jumpToCounterpart': 'Jump to counterpart',
  'projectsv2.organize.jumpToCounterpartNamed': 'Jump to {label}',
  'projectsv2.organize.dragHint': 'Drag to reorder',
  'projectsv2.organize.computedTotalsUsed': 'Computed totals used',
  'projectsv2.organize.qtyLabel': 'Qty: {value}',
  'projectsv2.organize.priceLabel': 'Price: {value}',
  'projectsv2.organize.rcvLabel': 'RCV: {value}',
  'projectsv2.organize.acvLabel': 'ACV: {value}',
  'projectsv2.organize.subtotal': 'Subtotal',
  'projectsv2.organize.originalLine': 'Original line',
  'projectsv2.organize.originalLineAria': 'Original line {line}',
  'projectsv2.organize.editAreaName': 'Edit area name',
  'projectsv2.organize.editItem': 'Edit item',
  'projectsv2.organize.unit': 'Unit',
  'projectsv2.organize.quantity': 'Quantity',
  'projectsv2.organize.unitPrice': 'Unit price',
  'projectsv2.organize.taxable': 'Taxable',
  'projectsv2.organize.taxRate': 'Tax rate',
  'projectsv2.organize.overhead': 'Overhead',
  'projectsv2.organize.profit': 'Profit',
  'projectsv2.organize.depreciation': 'Depreciation',
  'projectsv2.organize.coverage': 'Coverage',
  'projectsv2.organize.moveToAreaTitle': 'Move to area',
  'projectsv2.organize.moveToArea': 'Move to area',
  'projectsv2.organize.moveMultipleItems': 'Move multiple items',
  'projectsv2.organize.renameArea': 'Rename area',
  'projectsv2.organize.combineInto': 'Combine into',
  'projectsv2.organize.combineAreas': 'Combine areas',
  'projectsv2.organize.combineDestination': 'Destination area',
  'projectsv2.organize.combineNoAreas': 'No other areas available.',
  'projectsv2.organize.combinePrompt': 'Combine items from {name} into:',
  'projectsv2.organize.combine': 'Combine',
  'projectsv2.organize.combining': 'Combining…',
  'projectsv2.organize.combineFailed': 'Failed to combine areas.',
  'projectsv2.organize.deleteArea': 'Delete area',
  'projectsv2.organize.deleteAreaTitle': 'Delete area?',
  'projectsv2.organize.deleteAreaEmpty': 'This area has no items. Delete it?',
  'projectsv2.organize.deleteAreaHasItems':
    'This area contains {count} items. Move or delete them before deleting this area.',
  'projectsv2.organize.deleting': 'Deleting…',
  'projectsv2.organize.areaCreated': 'Area created',
  'projectsv2.organize.areaRenamed': 'Area renamed',
  'projectsv2.organize.areaDeleted': 'Area deleted',
  'projectsv2.organize.areasCombined': 'Areas combined',
  'projectsv2.organize.errors.areaNameRequired': 'Area name is required.',
  'projectsv2.organize.errors.areaNameLength': 'Area name must be 1-128 characters.',
  'projectsv2.organize.errors.areaNotFound': 'Area not found.',
  'projectsv2.organize.errors.chooseDestination': 'Choose a destination area.',
  'projectsv2.organize.errors.combineUnavailable': 'Combine is unavailable right now.',
  'projectsv2.organize.errors.deleteUnavailable': 'Delete is unavailable right now.',
  'projectsv2.organize.errors.renameUnavailable': 'Rename is unavailable right now.',
  'projectsv2.organize.errors.unassignedRename': 'Unassigned area cannot be renamed.',
  'projectsv2.organize.errors.unassignedDelete': 'Unassigned area cannot be deleted.',
  'projectsv2.organize.errors.areaMoveSides': 'Areas can’t move across sides.',
  'projectsv2.organize.oandp.title': 'Manage O&P for {scope}',
  'projectsv2.organize.oandp.subtitle': 'Apply overhead and profit adjustments to this scope.',
  'projectsv2.organize.oandp.modeLabel': 'Mode',
  'projectsv2.organize.oandp.modePercent': 'Percent',
  'projectsv2.organize.oandp.modeAmount': 'Amount',
  'projectsv2.organize.oandp.strategyLabel': 'Strategy',
  'projectsv2.organize.oandp.strategyOverride': 'Override',
  'projectsv2.organize.oandp.strategyAdd': 'Add',
  'projectsv2.organize.oandp.applyLabel': 'Apply style',
  'projectsv2.organize.oandp.applyCombined': 'Combined O&P',
  'projectsv2.organize.oandp.applySeparate': 'Separate overhead + profit',
  'projectsv2.organize.oandp.valueLabelPercent': 'Combined percent',
  'projectsv2.organize.oandp.valueLabelAmount': 'Combined amount',
  'projectsv2.organize.oandp.overheadLabelPercent': 'Overhead percent',
  'projectsv2.organize.oandp.profitLabelPercent': 'Profit percent',
  'projectsv2.organize.oandp.overheadLabelAmount': 'Overhead amount',
  'projectsv2.organize.oandp.profitLabelAmount': 'Profit amount',
  'projectsv2.organize.oandp.validationInvalid': 'Enter a valid value greater than or equal to zero.',
  'projectsv2.organize.oandp.previewEnterValue': 'Enter values to preview the O&P impact.',
  'projectsv2.organize.oandp.previewTotalChange': 'Total O&P change',
  'projectsv2.organize.oandp.previewItemsAffected': '{count} item{suffix} affected',
  'projectsv2.organize.oandp.previewDelta': 'Net change: {value}',
  'projectsv2.organize.oandp.applySuccess': 'O&P updated for {count} item{suffix}.',
  'projectsv2.organize.oandp.applyError': 'Unable to apply O&P adjustments.',
  'projectsv2.organize.loadFailed': 'Failed to load organize data.',
  'projectsv2.organize.saveFailed': 'Save failed',
  'projectsv2.organize.unassigned': 'Unassigned',
  'projectsv2.organize.moveItems.title': 'Move Items',
  'projectsv2.organize.moveItems.titleWithArea': 'Move Items — {area}',
  'projectsv2.organize.moveItems.subtitle': 'Select the items to move into another area on this lane.',
  'projectsv2.organize.moveItems.selectedCount': '{selected} of {total} selected',
  'projectsv2.organize.moveItems.emptyState': 'No items are currently assigned to this area.',
  'projectsv2.organize.moveItems.destinationPlaceholder': 'Select an area…',
  'projectsv2.organize.moveItems.noDestinationOptions': 'No other areas are available on this lane.',
  'projectsv2.organize.moveItems.action': 'Move items',
  'projectsv2.organize.moveItems.toast.failedTitle': 'Move failed',
  'projectsv2.organize.moveItems.errors.moveFailed': 'Failed to move items.',
  'projectsv2.organize.setRoom.title': 'Set Room',
  'projectsv2.organize.setRoom.roomLabel': 'Room name',
  'projectsv2.organize.setRoom.roomPlaceholder': 'Enter room name',
  'projectsv2.organize.adjustPrices.title': 'Adjust Prices',
  'projectsv2.organize.adjustPrices.adjustmentType.label': 'Adjustment type',
  'projectsv2.organize.adjustPrices.adjustmentType.percent': 'Percent',
  'projectsv2.organize.adjustPrices.adjustmentType.amount': 'Absolute amount',
  'projectsv2.organize.adjustPrices.operation.label': 'Operation',
  'projectsv2.organize.adjustPrices.operation.markup': 'Markup',
  'projectsv2.organize.adjustPrices.operation.markdown': 'Markdown',
  'projectsv2.organize.adjustPrices.valueLabel': 'Value',
  'projectsv2.organize.adjustPrices.placeholders.percent': 'Percent amount',
  'projectsv2.organize.adjustPrices.placeholders.amount': 'Dollar amount',
  'projectsv2.organize.normalizeUnits.title': 'Normalize Units',
  'projectsv2.organize.normalizeUnits.labels.factor': 'Factor',
  'projectsv2.organize.normalizeUnits.placeholders.from': 'e.g. SQFT',
  'projectsv2.organize.normalizeUnits.placeholders.to': 'e.g. SY',
  'projectsv2.organize.normalizeUnits.actions.addConversion': 'Add conversion',
  'projectsv2.organize.normalizeUnits.actions.normalize': 'Normalize',
  'projectsv2.organize.normalizeUnits.status.normalizing': 'Normalizing…',
  'projectsv2.organize.itemForm.title.add': 'Add Item',
  'projectsv2.organize.itemForm.title.edit': 'Edit Item',
  'projectsv2.organize.itemForm.originalLine': 'Original Line #{line}',
  'projectsv2.organize.itemForm.header.addingTo': 'Adding to {side}',
  'projectsv2.organize.itemForm.header.editing': 'Editing {side}',
  'projectsv2.organize.itemForm.placeholders.selectArea': 'Select area',
  'projectsv2.organize.itemForm.placeholders.description': 'Describe the work',
  'projectsv2.organize.itemForm.placeholders.unit': 'EA',
  'projectsv2.organize.itemForm.sections.overheadProfit': 'Overhead & Profit',
  'projectsv2.organize.itemForm.sections.totalsPreview': 'Totals Preview',
  'projectsv2.organize.itemForm.helpers.overheadProfit':
    '% is derived from $ based on Qty × Unit Price. $ is saved.',
  'projectsv2.organize.itemForm.labels.quantity': 'Quantity',
  'projectsv2.organize.itemForm.labels.unitOfMeasure': 'Unit of measurement',
  'projectsv2.organize.itemForm.labels.unitPrice': 'Unit price',
  'projectsv2.organize.itemForm.labels.unitPriceWithCurrency': 'Unit Price ({currency})',
  'projectsv2.organize.itemForm.labels.depreciation': 'Depreciation',
  'projectsv2.organize.itemForm.labels.depreciationWithCurrency': 'Depreciation ({currency})',
  'projectsv2.organize.itemForm.labels.taxRate': 'Tax Rate',
  'projectsv2.organize.itemForm.labels.taxRateWithPercent': 'Tax Rate ({percent})',
  'projectsv2.organize.itemForm.labels.taxAmount': 'Tax Amount',
  'projectsv2.organize.itemForm.labels.taxAmountWithCurrency': 'Tax Amount ({currency})',
  'projectsv2.organize.itemForm.labels.amountWithCurrency': 'Amount ({currency})',
  'projectsv2.organize.itemForm.labels.percentWithSymbol': 'Percent ({percent})',
  'projectsv2.organize.itemForm.labels.overheadAmount': 'Overhead amount',
  'projectsv2.organize.itemForm.labels.overheadPercent': 'Overhead percent',
  'projectsv2.organize.itemForm.labels.profitAmount': 'Profit amount',
  'projectsv2.organize.itemForm.labels.profitPercent': 'Profit percent',
  'projectsv2.organize.itemForm.errors.requiredField': '{field} is required.',
  'projectsv2.organize.itemForm.errors.descriptionRequired': 'Description is required.',
  'projectsv2.organize.itemForm.errors.unitRequired': 'Unit of measurement is required.',
  'projectsv2.organize.itemForm.errors.areaRequired': 'Area selection is required.',
  'projectsv2.organize.itemForm.errors.areaInvalid': 'Area selection is invalid.',
  'projectsv2.organize.itemForm.errors.reviewFields': 'Please review the highlighted fields.',
  'projectsv2.organize.itemForm.toast.saveFailed': 'Unable to save item.',
  'projectsv2.areaModal.title.add': 'Add area',
  'projectsv2.areaModal.title.rename': 'Rename area',
  'projectsv2.areaModal.labels.lane': 'Lane',
  'projectsv2.areaModal.labels.areaName': 'Area name',
  'projectsv2.areaModal.actions.creating': 'Creating…',
  'projectsv2.areaModal.actions.saving': 'Saving…',
  'projectsv2.areaModal.actions.createArea': 'Create area',
  'projectsv2.areaModal.actions.saveChanges': 'Save changes',
  'projectsv2.areaModal.errors.areaNameRequired': 'Area name is required.',
  'projectsv2.areaModal.errors.areaNameLength': 'Area name must be 1-128 characters.',
  'projectsv2.areaModal.errors.laneSideMissing':
    'Internal error: lane side is missing. Please reload and try again.',
  'projectsv2.areaModal.errors.areaNameNotUnique':
    'An area with this name already exists in this lane.',
  'projectsv2.areaModal.errors.unableToCreate': 'Unable to create area.',
  'projectsv2.areaModal.errors.unableToDetermineArea': 'Unable to determine area.',
  'projectsv2.areaModal.errors.unableToSave': 'Unable to save area.',
  'projectsv2.editItem.title.add': 'Add Item',
  'projectsv2.editItem.title.edit': 'Edit Item',
  'projectsv2.editItem.header.adding': 'Adding to {side}',
  'projectsv2.editItem.header.editing': 'Editing {side}',
  'projectsv2.editItem.originalLine': 'Original Line #{line}',
  'projectsv2.editItem.fields.selectArea': 'Select area',
  'projectsv2.editItem.fields.descriptionPlaceholder': 'Describe the work',
  'projectsv2.editItem.fields.quantity': 'Quantity',
  'projectsv2.editItem.fields.uom': 'Unit of measurement',
  'projectsv2.editItem.fields.uomPlaceholder': 'EA',
  'projectsv2.editItem.fields.unitPrice': 'Unit price',
  'projectsv2.editItem.fields.unitPriceWithCurrency': 'Unit Price ($)',
  'projectsv2.editItem.fields.depreciationWithCurrency': 'Depreciation ($)',
  'projectsv2.editItem.tax.title': 'Tax',
  'projectsv2.editItem.tax.taxableLabel': 'Taxable',
  'projectsv2.editItem.tax.taxableAria': 'Taxable',
  'projectsv2.editItem.tax.rateLabel': 'Tax Rate (%)',
  'projectsv2.editItem.tax.rateAria': 'Tax Rate',
  'projectsv2.editItem.tax.amountLabel': 'Tax Amount ($)',
  'projectsv2.editItem.tax.amountAria': 'Tax Amount',
  'projectsv2.editItem.overhead.title': 'Overhead & Profit',
  'projectsv2.editItem.overhead.helper': '% is derived from $ based on Qty × Unit Price. $ is saved.',
  'projectsv2.editItem.overhead.overheadLabel': 'Overhead',
  'projectsv2.editItem.overhead.profitLabel': 'Profit',
  'projectsv2.editItem.overhead.amountLabel': 'Amount ($)',
  'projectsv2.editItem.overhead.percentLabel': 'Percent (%)',
  'projectsv2.editItem.overhead.amountAria': 'Overhead amount',
  'projectsv2.editItem.overhead.percentAria': 'Overhead percent',
  'projectsv2.editItem.overhead.profitAmountAria': 'Profit amount',
  'projectsv2.editItem.overhead.profitPercentAria': 'Profit percent',
  'projectsv2.editItem.preview.title': 'Totals Preview',
  'projectsv2.editItem.preview.subtotal': 'Subtotal',
  'projectsv2.editItem.preview.opAmount': 'O&P $',
  'projectsv2.editItem.preview.preTax': 'Pre-Tax',
  'projectsv2.editItem.preview.taxRate': 'Tax Rate',
  'projectsv2.editItem.preview.tax': 'Tax',
  'projectsv2.editItem.preview.rcv': 'RCV',
  'projectsv2.editItem.preview.acv': 'ACV',
  'projectsv2.editItem.validation.required': '{field} is required.',
  'projectsv2.editItem.validation.reviewFields': 'Please review the highlighted fields.',
  'projectsv2.editItem.validation.areaRequired': 'Area selection is required.',
  'projectsv2.editItem.validation.areaInvalid': 'Area selection is invalid.',
  'projectsv2.editItem.errors.saveFailed': 'Unable to save item.',
  'projectsv2.editItem.actions.saving': 'Saving…',
  'projectsv2.editItem.aria.quantity': 'Quantity',
  'projectsv2.editItem.aria.unitPrice': 'Unit Price',
  'projectsv2.editItem.aria.depreciation': 'Depreciation',
  'projectsv2.finalOutcome.loading': 'Loading...',
  'projectsv2.finalOutcome.errors.httpStatus': 'HTTP {status}',
  'projectsv2.finalOutcome.title.ua': 'Final Award',
  'projectsv2.finalOutcome.title.default': 'Final Release',
  'projectsv2.finalOutcome.gateNotSatisfied': '{gate} gate not satisfied',
  'projectsv2.finalOutcome.totals.carrier': 'Carrier Totals: RCV {rcv} / ACV {acv}',
  'projectsv2.finalOutcome.totals.insured': 'Insured Totals: RCV {rcv} / ACV {acv}',
  'projectsv2.finalOutcome.pairedItems': 'Paired Items',
  'projectsv2.finalOutcome.noPairings': 'No pairings.',
  'projectsv2.finalOutcome.itemFallback': '#{id}',
  'projectsv2.finalOutcome.rcvAcv': 'RCV {rcv} / ACV {acv}',
  'projectsv2.finalOutcome.unpairedCarrier': 'Unpaired Carrier',
  'projectsv2.finalOutcome.unpairedInsured': 'Unpaired Insured',
  'projectsv2.modals.reprice.title.totalRcv': 'Reprice (Total RCV %) — {scopeLabel}',
  'projectsv2.modals.reprice.title.unitPrice': 'Reprice (Unit Price) — {scopeLabel}',
  'projectsv2.modals.reprice.tooltip.aria': 'How reprice is applied',
  'projectsv2.modals.reprice.tooltip.title': 'How reprice is applied',
  'projectsv2.modals.reprice.tooltip.totalRcv.li1':
    'Reprice changes the TOTAL RCV for the selected scope by a percent and distributes that change across items.',
  'projectsv2.modals.reprice.tooltip.totalRcv.li2':
    'Unit prices are adjusted and rounded to cents; O&P and Tax are recalculated using implied percentages so RCV remains consistent.',
  'projectsv2.modals.reprice.tooltip.totalRcv.li3':
    'Residual cents are distributed so the scope total matches the target total RCV to the cent.',
  'projectsv2.modals.reprice.tooltip.totalRcv.li4':
    'Depreciation is capped if needed so ACV never goes negative.',
  'projectsv2.modals.reprice.tooltip.totalRcv.li5':
    'Lane and area totals refresh automatically—no hard page refresh needed.',
  'projectsv2.modals.reprice.tooltip.unitPrice.li1':
    'Reprice updates each item’s Unit Price for the selected scope (item, area, or lane).',
  'projectsv2.modals.reprice.tooltip.unitPrice.li2':
    'After the price changes, O&P and Tax are recalculated using their implied percentages so RCV stays accurate.',
  'projectsv2.modals.reprice.tooltip.unitPrice.li3':
    'RCV is always (Qty × Price) + O&P + Tax, and ACV updates as RCV − Depreciation.',
  'projectsv2.modals.reprice.tooltip.unitPrice.li4':
    'If a reprice lowers RCV below existing depreciation, depreciation is automatically capped so ACV never goes negative.',
  'projectsv2.modals.reprice.tooltip.unitPrice.li5':
    'Lane and area totals refresh automatically—no hard page refresh needed.',
  'projectsv2.modals.reprice.description.totalRcv':
    'Adjust TOTAL RCV by a percent; values distribute across items automatically.',
  'projectsv2.modals.reprice.description.unitPrice':
    'Adjust each item’s Unit Price by a fixed $ amount or by a percentage. RCV/ACV will update automatically.',
  'projectsv2.modals.reprice.method.label': 'Method',
  'projectsv2.modals.reprice.method.helper': 'Switch between Total RCV and classic Unit Price.',
  'projectsv2.modals.reprice.method.unitPrice': 'Unit Price (Classic)',
  'projectsv2.modals.reprice.method.totalRcv': 'Total RCV % (Distributed)',
  'projectsv2.modals.reprice.method.aria': 'Toggle reprice method',
  'projectsv2.modals.reprice.scope': 'Scope: {scopeLabel}',
  'projectsv2.modals.reprice.mode.amount': '$ Amount',
  'projectsv2.modals.reprice.mode.amountHelper': 'Apply a fixed adjustment to Unit Price.',
  'projectsv2.modals.reprice.mode.percent': '% Percent',
  'projectsv2.modals.reprice.mode.percentHelper': 'Apply a percent of each item’s Unit Price.',
  'projectsv2.modals.reprice.mode.totalRcvHelper':
    'Apply a percent of TOTAL RCV (distributed across items).',
  'projectsv2.modals.reprice.direction.increase': 'Increase',
  'projectsv2.modals.reprice.direction.decrease': 'Decrease',
  'projectsv2.modals.reprice.input.label.totalRcv': 'Percent of TOTAL RCV for this scope',
  'projectsv2.modals.reprice.input.label.percent': 'Percent of Unit Price',
  'projectsv2.modals.reprice.input.label.amount': 'Dollar amount per Unit',
  'projectsv2.modals.reprice.input.helper.valueMin': 'Enter a value greater than 0.',
  'projectsv2.modals.reprice.input.helper.totalRcv':
    'Percent applies to TOTAL RCV for this scope.',
  'projectsv2.modals.reprice.input.helper.percent': 'Percent accepts decimal units.',
  'projectsv2.modals.reprice.input.helper.amount': 'Amounts round to 2 decimals.',
  'projectsv2.modals.reprice.preview.title': 'Live Preview',
  'projectsv2.modals.reprice.preview.unavailable': 'Preview unavailable.',
  'projectsv2.modals.reprice.preview.loading': 'Loading preview…',
  'projectsv2.modals.reprice.preview.noItems': 'No items available for preview.',
  'projectsv2.modals.reprice.preview.enterValue':
    'Enter a value greater than 0 to see the live preview.',
  'projectsv2.modals.reprice.preview.selectDirection': 'Select a direction to preview changes.',
  'projectsv2.modals.reprice.preview.preparing': 'Preparing preview…',
  'projectsv2.modals.reprice.preview.unitPrice': 'Unit Price',
  'projectsv2.modals.reprice.preview.rcv': 'RCV',
  'projectsv2.modals.reprice.preview.acv': 'ACV',
  'projectsv2.modals.reprice.preview.itemsAffected': '{count} item{suffix} affected.',
  'projectsv2.modals.reprice.actions.applying': 'Applying…',
  'projectsv2.modals.reprice.toast.applied': 'Applied to {count} item{suffix}.',
  'projectsv2.modals.reprice.errors.scopeUnavailable': 'Unable to determine adjustment scope.',
  'projectsv2.modals.reprice.errors.applyFailed': 'Unable to apply adjustment',
  'projects.v2.numbers.golden.title': 'Golden Check',
  'projects.v2.numbers.golden.sampleLabel': 'Sample:',
  'projects.v2.numbers.golden.part.numbers': 'numbers',
  'projects.v2.numbers.golden.part.csv': 'csv',
  'projects.v2.numbers.golden.part.pdfHtml': 'pdfHtml',
  'projects.v2.numbers.golden.runChecks': 'Run checks',
  'projects.v2.numbers.golden.pass': 'PASS',
  'projects.v2.numbers.golden.fail': 'FAIL',
  'projects.v2.numbers.golden.httpError': 'HTTP {status}',
  'projects.v2.new.pageTitle': 'New Project',
  'projects.v2.new.appraisers': 'Appraisers',
  'projects.v2.new.projectName': 'Project Name',
  'projects.v2.new.umpireName': 'Umpire Name',
  'projects.v2.new.insuredInfo': "Insured's Information",
  'projects.v2.new.insuredName': 'Insured Name',
  'projects.v2.new.insuranceProviderName': 'Insurance Provider Name',
  'projects.v2.new.claimNumber': 'Claim Number',
  'projects.v2.new.policyNumber': 'Policy Number',
  'projects.v2.new.lossDate': 'Loss Date',
  'projects.v2.new.typeOfLoss': 'Type of Loss',
  'projects.v2.new.causeOfLoss': 'Cause of Loss',
  'projects.v2.new.selectPlaceholder': 'Select…',
  'projects.v2.new.lossLocation': 'Location of the Loss',
  'projects.v2.new.address': 'Address',
  'projects.v2.new.city': 'City',
  'projects.v2.new.state': 'State',
  'projects.v2.new.zip': 'Zip',
  'projects.v2.new.claimFinancials': 'Claim Financials',
  'projects.v2.new.editCoverageFinancials': '$ Edit Deductible & Prior Payments by Coverage',
  'projects.v2.new.deductibleAmount': 'Deductible Amount',
  'projects.v2.new.priorPayments': 'Prior Payments',
  'projects.v2.new.createError': 'Failed to create project',
  'projects.v2.new.saveDetailsError': 'Failed to save project details',
  'projects.v2.new.saveCoverageError': 'Failed to save coverage financials',
  'projects.v2.new.genericError': 'Error',
  'projects.v2.upload.pageTitle': 'Upload',
  'projects.v2.upload.pageTitleWithName': 'Upload - {name}',
  'projects.v2.upload.uploadRequired': 'Upload at least one estimate to continue.',
  'projects.v2.upload.carrierLabel': 'Carrier',
  'projects.v2.upload.insuredLabel': 'Insured',
  'projects.v2.upload.ingestFailed': '{side} ingest failed',
  'projects.v2.upload.reingest': 'Re-ingest',
  'projects.v2.upload.downloadJson': 'Download {side} JSON',
  'projects.v2.organize.pageTitle': 'Organize Items',
  'projects.v2.organize.pageTitleWithName': 'Organize Items - {name}',
  'projects.v2.organize.invalidProjectUrl': 'Invalid project URL.',
  'projects.v2.organize.uploadRequired':
    'Upload and ingest both Carrier and Insured estimates to continue.',
  'projects.v2.organize.loadError': 'Something went wrong loading Organize. Check console.',
  'projects.v2.selections.pageTitle': 'Selections',
  'projects.v2.selections.pageTitleWithName': 'Selections - {name}',
  'projects.v2.selections.invalidProjectUrl': 'Invalid project URL.',
  'projects.v2.selections.loadError': 'Failed to load selections.',
  'projects.v2.selections.errorBanner': 'Failed to load selections: {message}',
  'projects.v2.selections.unknownError': 'Unknown error.',
  'projects.v2.finalAward.pageTitle': 'Final Award',
  'projects.v2.finalAward.pageTitleWithName': 'Final Award - {name}',
  'projects.v2.finalAward.clientErrorTitle': 'Final Award — client error',
  'projects.v2.finalAward.unknownError': 'Unknown error',
  'projects.v2.finalRelease.pageTitle': 'Final Release',
  'projects.v2.golden.title': 'Golden Check',
  'projects.v2.golden.sampleLabel': 'Sample:',
  'projects.v2.golden.part.numbers': 'numbers',
  'projects.v2.golden.part.csv': 'csv',
  'projects.v2.golden.part.pdfHtml': 'pdfHtml',
  'projects.v2.golden.runChecks': 'Run checks',
  'projects.v2.golden.pass': 'PASS',
  'projects.v2.golden.fail': 'FAIL',
  'projects.v2.golden.httpError': 'HTTP {status}',
  'settlefast.finalInvoice.pageTitle': 'SettleFast Project',
  'settlefast.finalInvoice.title': 'Final Invoice',
  'settlefast.finalInvoice.downloadPdf': 'Download Final Invoice PDF',
  'sf.dashboard.pageTitle': 'SettleFast Dashboard',
  'sf.dashboard.newProject': 'New Project',
  'sf.dashboard.invoiceSettings': 'Invoice Settings',
  'sf.dashboard.billing': 'Billing',
  'sf.dashboard.myAccount': 'My Account',
  'sf.dashboard.loadError': 'Failed to load',
  'sf.dashboard.recentProjectsTitle': 'Last 10 Projects (Newest First)',
  'sf.dashboard.noProjects': 'No projects yet.',
  'sf.dashboard.projectNumber': 'Project #{id}',
  'sf.dashboard.cards.totalSettlements': 'Total Settlements',
  'sf.dashboard.cards.pendingSettlements': 'Pending Settlements',
  'sf.dashboard.cards.closedSettlements': 'Closed Settlements',
  'sf.dashboard.cards.totalAmountSettled': 'Total Amount Settled',
  'sf.dashboard.cards.invoicesInProgressCount': 'Invoices In Progress (Count)',
  'sf.dashboard.cards.invoicesInProgressAmountDue': 'Invoices In Progress (Amount Due)',
  'sf.dashboard.cards.invoicesClosedCount': 'Invoices Closed (Count)',
  'sf.dashboard.cards.closedInvoiceRevenueAmount': 'Closed Invoice Revenue (Amount)',
  'admin.referUsers.pageTitle': 'Refer Users',
  'admin.referUsers.title': 'Refer Users',
  'admin.referUsers.subtitle': 'Send a referral invite so a new user can sign up.',
  'admin.referUsers.successIcon': '✓',
  'admin.referUsers.success': 'Invite Sent to {name}',
  'admin.referUsers.errors.loadRoles': 'Failed to load roles',
  'admin.referUsers.errors.loadCounts': 'Failed to load referral counts',
  'admin.referUsers.errors.loadInvites': 'Failed to load invites',
  'admin.referUsers.errors.sendInvite': 'Failed to send invite',
  'admin.referUsers.fields.companyOptional': 'Company (optional)',
  'admin.referUsers.fields.roleOptional': 'Role (optional)',
  'admin.referUsers.fields.selectRole': 'Select a role',
  'admin.referUsers.actions.sending': 'Sending…',
  'admin.referUsers.actions.sendInvite': 'Send invite',
  'admin.referUsers.actions.viewCounts': 'View Referral Counts',
  'admin.referUsers.actions.viewInvites': 'View Sent and Accepted Invitations',
  'admin.referUsers.counts.title': 'Referral Counts',
  'admin.referUsers.counts.invitesSent': 'Invites Sent',
  'admin.referUsers.counts.invitesUsed': 'Invites Used',
  'admin.referUsers.counts.referredSignups': 'Referred Signups',
  'admin.referUsers.counts.referredApproved': 'Referred Approved',
  'admin.referUsers.counts.loading': 'Loading…',
  'admin.referUsers.invites.title': 'Sent and Accepted Invitations',
  'admin.referUsers.invites.accepted': 'Accepted',
  'admin.referUsers.invites.loading': 'Loading invitations…',
  'admin.referUsers.invites.empty': 'No invites found.',
  'dev.selectionsSample.title': 'Selections Debug Preview',
  'dev.selectionsSample.description.before':
    'This page renders the Projects v2 selections experience with mock data when',
  'dev.selectionsSample.description.after': 'is enabled.',
  'dev.selectionsSample.envVar': 'NEXT_PUBLIC_UA_DEBUG_SELECTIONS_USE_SAMPLE',
  'dev.selectionsSample.coverage.dwelling': 'Dwelling',
  'dev.selectionsSample.coverage.otherStructures': 'Other Structures',
  'invoiceCenter.issueExport.title': 'Generate Invoice PDF',
  'invoiceCenter.issueExport.fields.recipient': 'Invoice Recipient',
  'invoiceCenter.issueExport.recipient.carrier': 'Carrier',
  'invoiceCenter.issueExport.recipient.insured': 'Insured',
  'invoiceCenter.issueExport.recipient.other': 'Other',
  'invoiceCenter.issueExport.fields.recipientProfile': 'Invoice recipient profile',
  'invoiceCenter.issueExport.fields.selectProfile': 'Select a profile',
  'invoiceCenter.issueExport.fields.recipientFallback': 'Recipient #{id}',
  'invoiceCenter.issueExport.fields.noOtherProfiles':
    'No “Other” recipient profiles exist for this project.',
  'invoiceCenter.issueExport.actions.manageRecipients': 'Manage recipients',
  'invoiceCenter.issueExport.fields.pdfType': 'Invoice PDF type',
  'invoiceCenter.issueExport.types.retainer': 'Retainer',
  'invoiceCenter.issueExport.types.full': 'Full',
  'invoiceCenter.issueExport.types.retainerDeposit': 'Retainer Deposit',
  'invoiceCenter.issueExport.types.deposit': 'Deposit',
  'invoiceCenter.issueExport.types.custom': 'Custom',
  'invoiceCenter.issueExport.fields.display': 'Invoice display',
  'invoiceCenter.issueExport.display.retainerOnly': 'Show retainer line only',
  'invoiceCenter.issueExport.display.includeTime': 'Include time details on this PDF',
  'invoiceCenter.issueExport.fields.amountDue': 'Amount due',
  'invoiceCenter.issueExport.deposit.retainer': 'Retainer deposit amount:',
  'invoiceCenter.issueExport.deposit.flat': 'Flat deposit amount:',
  'invoiceCenter.issueExport.invoiceMeta': 'Invoice #{invoiceNumber} · {projectTitle}',
  'invoiceCenter.issueExport.projectFallback': 'Project #{id}',
  'invoiceCenter.issueExport.actions.issuing': 'Issuing...',
  'invoiceCenter.issueExport.actions.issue': 'Issue Export',
  'invoiceCenter.issueExport.errors.amountDue': 'Amount due must be greater than 0.',
  'invoiceCenter.issueExport.errors.recipientProfile':
    'Select a recipient profile for the Other recipient.',
  'invoiceCenter.issueExport.errors.updateDisplayMode':
    'Failed to update invoice display mode.',
  'invoiceCenter.issueExport.errors.updateFailedTitle': 'Update failed',
  'invoiceCenter.issueExport.errors.issueFailed': 'Failed to issue export',
  'invoiceCenter.issueExport.toast.issuedTitle': 'Invoice export issued',
  'invoiceCenter.issueExport.toast.issuedDetail': 'Issued: {number}',
  'projects.projectModal.toast.saveFailed': 'Save failed',
  'projects.projectModal.toast.saved': 'Project saved',
  'projects.projectModal.title.edit': 'Edit Project',
  'projects.projectModal.title.add': 'Add Project',
  'projects.projectModal.sections.project': 'PROJECT',
  'projects.projectModal.sections.insuredInfo': 'INSURED’S INFORMATION',
  'projects.projectModal.sections.lossLocation': 'LOCATION OF THE LOSS',
  'projects.projectModal.sections.claimFinancials': 'CLAIM FINANCIALS',
  'projects.projectModal.sections.appraiserInfo': 'APPRAISER INFORMATION',
  'projects.projectModal.fields.projectName': 'Project Name*',
  'projects.projectModal.fields.umpireName': 'Umpire Name*',
  'projects.projectModal.fields.insuredName': 'Insured’s Name*',
  'projects.projectModal.fields.insuranceProvider': 'Insurance Provider Name*',
  'projects.projectModal.fields.policyNumber': 'Policy Number*',
  'projects.projectModal.fields.claimNumber': 'Claim Number*',
  'projects.projectModal.fields.dateOfLoss': 'Date of Loss*',
  'projects.projectModal.fields.uploadLogo': 'Upload Logo (Recommended: 80×80 px)',
  'projects.projectModal.fields.typeOfLoss': 'Type of Loss*',
  'projects.projectModal.fields.causeOfLoss': 'Cause of Loss*',
  'projects.projectModal.fields.selectPlaceholder': 'Select',
  'projects.projectModal.fields.address': 'Address*',
  'projects.projectModal.fields.city': 'City*',
  'projects.projectModal.fields.state': 'State*',
  'projects.projectModal.fields.zipCode': 'Zip Code*',
  'projects.projectModal.fields.deductibleAmount': 'Deductible Amount',
  'projects.projectModal.fields.priorPayments': 'Prior Payments',
  'projects.projectModal.fields.insuredAppraiser': 'Insured Appraiser*',
  'projects.projectModal.fields.carrierAppraiser': 'Carrier Appraiser*',
  'projects.addProjectModal.sections.project': 'PROJECT',
  'projects.addProjectModal.sections.insuredInfo': 'INSURED’S INFORMATION',
  'projects.addProjectModal.sections.lossLocation': 'LOCATION OF THE LOSS',
  'projects.addProjectModal.sections.claimFinancials': 'CLAIM FINANCIALS',
  'projects.addProjectModal.fields.projectName': 'Project Name*',
  'projects.addProjectModal.fields.umpireName': 'Umpire Name*',
  'projects.addProjectModal.fields.insuredName': 'Insured’s Name*',
  'projects.addProjectModal.fields.insuranceProvider': 'Insurance Provider Name*',
  'projects.addProjectModal.fields.policyNumber': 'Policy Number*',
  'projects.addProjectModal.fields.claimNumber': 'Claim Number*',
  'projects.addProjectModal.fields.dateOfLoss': 'Date of Loss*',
  'projects.addProjectModal.fields.uploadLogo': 'Upload Logo (Recommended: 80×80 px)',
  'projects.addProjectModal.fields.typeOfLoss': 'Type of Loss*',
  'projects.addProjectModal.fields.causeOfLoss': 'Cause of Loss*',
  'projects.addProjectModal.fields.selectPlaceholder': 'Select',
  'projects.addProjectModal.fields.address': 'Address*',
  'projects.addProjectModal.fields.city': 'City*',
  'projects.addProjectModal.fields.state': 'State*',
  'projects.addProjectModal.fields.zipCode': 'Zip Code*',
  'projects.addProjectModal.fields.deductibleAmount': 'Deductible Amount',
  'projects.addProjectModal.fields.priorPayments': 'Prior Payments',
  'projects.editItemModal.title': 'Edit {side} line',
  'projects.editItemModal.fields.description': 'Description',
  'projects.editItemModal.fields.unit': 'Unit',
  'projects.editItemModal.fields.quantity': 'Qty',
  'projects.editItemModal.fields.unitPrice': 'Unit price',
  'projects.editItemModal.fields.taxable': 'Taxable',
  'projects.editItemModal.fields.taxRate': 'Tax rate (%)',
  'projects.editItemModal.fields.taxAmount': 'Tax amount ($)',
  'projects.editItemModal.fields.overhead': 'Overhead %',
  'projects.editItemModal.fields.profit': 'Profit %',
  'projects.editItemModal.fields.depreciation': 'Depreciation amount ($)',
  'projects.editItemModal.fields.opBasis': 'Overhead & Profit basis',
  'projects.editItemModal.fields.opBasisPreTax': 'Pre-tax (default)',
  'projects.editItemModal.fields.opBasisPostTax': 'Post-tax',
  'projects.editItemModal.preview.title': 'Preview totals',
  'projects.editItemModal.preview.rcv': 'RCV',
  'projects.editItemModal.preview.acv': 'ACV',
  'projects.editItemModal.preview.tax': 'Tax',
  'projects.editItemModal.preview.opCombined': 'O&P (combined)',
  'projects.editItemModal.preview.helper.before': 'Changes are saved only when you click ',
  'projects.editItemModal.preview.helper.after': '.',
  'projects.finalSummary.errors.loadFailed': 'Failed to load final summary',
  'projects.finalSummary.loading': 'Loading final summary...',
  'projects.finalSummary.labels.ungrouped': 'Ungrouped',
  'projects.finalSummary.title': 'Final Dispute Summary',
  'finalSummary.adr.pageTitle': 'ADR Final Dispute Summary',
  'finalSummary.sf.pageTitle': 'SettleFast Final Dispute Summary',
  'projects.finalSummary.badge.releaseAccepted': 'Release Accepted',
  'projects.finalSummary.badge.paymentReceived': 'Payment Received',
  'projects.finalSummary.views.details': 'Details',
  'projects.finalSummary.views.delta': 'Δ Only',
  'projects.finalSummary.views.numbers': 'Numbers',
  'projects.finalSummary.columns.area': 'Area',
  'projects.finalSummary.columns.description': 'Description',
  'projects.finalSummary.columns.carrierAcv': 'Carrier ACV',
  'projects.finalSummary.columns.carrierRcv': 'Carrier RCV',
  'projects.finalSummary.columns.insuredAcv': 'Insured ACV',
  'projects.finalSummary.columns.insuredRcv': 'Insured RCV',
  'projects.finalSummary.columns.deltaRcv': 'Δ RCV',
  'projects.finalSummary.columns.percentDiff': 'Percent Diff',
  'projects.finalSummary.totals.carrier': 'Carrier Total:',
  'projects.finalSummary.totals.insured': 'Insured Total:',
  'projects.finalSummary.totals.finalDiff': 'Final Diff:',
  'projects.finalSummary.totals.percentDiff': 'Percent Diff:',
  'projectsv2.bulkAdjust.mode.amount': '$ Amount',
  'projectsv2.bulkAdjust.mode.amountHelper': 'Applies a fixed dollar amount.',
  'projectsv2.bulkAdjust.mode.percent': '% Percent',
  'projectsv2.bulkAdjust.mode.percentHelper': "Applies a percent of each item's RCV.",
  'projectsv2.bulkAdjust.errors.loadScopePreview': 'Unable to load preview data for this scope.',
  'projectsv2.bulkAdjust.toast.applied': 'Applied to {count} item{suffix}.',
  'projectsv2.bulkAdjust.errors.applyFailed': 'Unable to apply adjustment',
  'projectsv2.bulkAdjust.preview.unavailable': 'Preview unavailable.',
  'projectsv2.bulkAdjust.preview.loading': 'Loading preview…',
  'projectsv2.bulkAdjust.preview.empty': 'No items available for preview.',
  'projectsv2.bulkAdjust.preview.enterValue': 'Enter a value greater than or equal to 0 to see the live preview.',
  'projectsv2.bulkAdjust.preview.preparing': 'Preparing preview…',
  'projectsv2.bulkAdjust.preview.depreciationLabel': 'Depreciation',
  'projectsv2.bulkAdjust.preview.acvLabel': 'ACV',
  'projectsv2.bulkAdjust.preview.itemsAffected': '{count} item{suffix} affected.',
  'projectsv2.bulkAdjust.preview.capped': 'Capped by item floors.',
  'projectsv2.bulkAdjust.preview.noChangeItemsAlreadyAtZeroAcv': 'No change — items already at $0 ACV.',
  'projectsv2.bulkAdjust.preview.noChangeBelowFloors': 'No change — request is below item floors.',
  'projectsv2.bulkAdjust.preview.noChangeMustBeGreaterThanOrEqualToZero':
    'No change — request must be greater than or equal to $0.',
  'projectsv2.bulkAdjust.title': 'Manage Depreciation — {scope}',
  'projectsv2.bulkAdjust.tooltip.ariaLabel': 'How bulk depreciation is applied',
  'projectsv2.bulkAdjust.tooltip.title': 'How depreciation is applied',
  'projectsv2.bulkAdjust.tooltip.item.rcv': 'RCV is calculated as (Qty × Price) + O&P + Tax.',
  'projectsv2.bulkAdjust.tooltip.item.percent':
    'Percent (%) adds that % of total RCV for this scope, then distributes it across items based on each item’s current ACV (items with more ACV absorb more).',
  'projectsv2.bulkAdjust.tooltip.item.amount':
    'Dollar ($) adds that total $ amount across this scope using the same ACV-based balancing.',
  'projectsv2.bulkAdjust.tooltip.item.onlyDepreciation':
    'Use this to manage depreciation for the selected scope. Enter 0 to remove depreciation.',
  'projectsv2.bulkAdjust.tooltip.item.floors':
    'Items are protected from going negative; the system applies up to what’s safely possible and respects per-item floors.',
  'projectsv2.bulkAdjust.tooltip.item.resetExisting':
    'If enabled, existing depreciation is reset to $0 before applying the new adjustment.',
  'projectsv2.bulkAdjust.subtitle':
    'Choose an amount to set depreciation for the selected scope. Enter 0 to remove depreciation.',
  'projectsv2.bulkAdjust.fields.percentOfRcv': 'Percent of RCV',
  'projectsv2.bulkAdjust.fields.amount': 'Dollar amount',
  'projectsv2.bulkAdjust.helper.percent':
    'Enter a value greater than or equal to 0. Percent accepts decimal units. Enter 0 to remove all depreciation for the selected scope.',
  'projectsv2.bulkAdjust.helper.amount':
    'Enter a value greater than or equal to 0. Amounts round to 2 decimals. Enter 0 to remove all depreciation for the selected scope.',
  'projectsv2.bulkAdjust.helper.percentNonNegative':
    'Enter a value greater than or equal to 0. Percent accepts decimal units. Enter 0 to remove all depreciation for the selected scope.',
  'projectsv2.bulkAdjust.helper.amountNonNegative':
    'Enter a value greater than or equal to 0. Amounts round to 2 decimals. Enter 0 to remove all depreciation for the selected scope.',
  'projectsv2.bulkAdjust.fields.resetExistingLabel': 'Remove Existing Depreciation Before Adding',
  'projectsv2.bulkAdjust.fields.resetExistingHelper':
    'Reset items in this scope to $0 depreciation before applying this adjustment.',
  'projectsv2.bulkAdjust.preview.title': 'Live Preview',
  'projectsv2.bulkAdjust.actions.applying': 'Applying…',
  'projectsv2.projectsList.status.closed': 'Closed',
  'projectsv2.projectsList.errors.loadCredits': 'Failed to load credits summary',
  'projectsv2.projectsList.errors.reopenFailed': 'Failed to re-open project',
  'projectsv2.projectsList.errors.noModuleAccess': 'No module access.',
  'projectsv2.projectsList.confirm.close': 'Close this project? It will become read-only.',
  'projectsv2.projectsList.confirm.reopen': 'Re-open this project? It will become editable again.',
  'projectsv2.projectsList.searchPlaceholder': 'Search by name...',
  'projectsv2.projectsList.status.all': 'All',
  'projectsv2.projectsList.actions.clearDates': 'Clear Dates',
  'projectsv2.projectsList.sort.updated': 'Recently Updated',
  'projectsv2.projectsList.sort.titleAsc': 'Title A-Z',
  'projectsv2.projectsList.sort.titleDesc': 'Title Z-A',
  'projectsv2.projectsList.scope.myProjects': 'My Projects',
  'projectsv2.projectsList.scope.companyProjects': 'Company Projects',
  'projectsv2.projectsList.filters.showAllUsers': 'Show All Users',
  'projectsv2.projectsList.credits.free': 'Free: {used}/{assigned} used • {remaining} left',
  'projectsv2.projectsList.credits.prepaid': 'Prepaid: {used}/{assigned} used • {remaining} left',
  'projectsv2.projectsList.credits.subscriptionUnlimited':
    'Subscription: Unlimited • {used} created',
  'projectsv2.projectsList.credits.subscriptionInactive': 'Subscription: Not active',
  'projectsv2.projectsList.credits.unavailable': 'Credits unavailable',
  'projectsv2.projectsList.actions.newProject': 'New Project',
  'projectsv2.projectsList.actions.newProjectBillingRequired':
    'New Project (Billing Required)',
  'projectsv2.projectsList.loading': 'Loading...',
  'projectsv2.projectsList.columns.owner': 'Owner',
  'projectsv2.projectsList.columns.itemsPaired': 'Items/Paired',
  'projectsv2.projectsList.ownerUnknown': '(unknown)',
  'projectsv2.projectsList.actions.reassign': 'Reassign',
  'projectsv2.projectsList.actions.closing': 'Closing…',
  'projectsv2.projectsList.actions.reopening': 'Re-Opening…',
  'projectsv2.projectsList.actions.reopen': 'Re-Open',
  'projectsv2.projectsList.reassign.title': 'Reassign Project',
  'projectsv2.projectsList.reassign.currentOwner': 'Current owner: {owner}',
  'projectsv2.projectsList.reassign.newOwner': 'New owner',
  'projectsv2.projectsList.reassign.confirm': 'Reassign',
  'projectsv2.projectsList.reassign.cancel': 'Cancel',
  'projectsv2.projectsList.reassign.errors.failed': 'Reassignment failed',
  'projectsv2.projectsList.reassign.errors.selectOwner': 'Please select a new owner',
  'projectsv2.projectsList.empty.noneInSql':
    'No projects in SQL yet. Use ‘{action}’ to create one.',
  'projectsv2.projectsList.empty.noneFound': 'No projects found.',
  'projectsv2.finalSummary.loading': 'Loading...',
  'projectsv2.finalSummary.sections.paired': 'Paired Items',
  'projectsv2.finalSummary.empty.paired': 'No pairings.',
  'projectsv2.finalSummary.labels.carrier': 'Carrier',
  'projectsv2.finalSummary.labels.insured': 'Insured',
  'projectsv2.finalSummary.labels.rcvAcv': 'RCV {rcv} / ACV {acv}',
  'projectsv2.finalSummary.sections.unpairedCarrier': 'Unpaired Carrier',
  'projectsv2.finalSummary.sections.unpairedInsured': 'Unpaired Insured',
  'projectsv2.finalSummary.empty.none': 'None',
  'projectsv2.finalSummary.empty.title': 'No summary available yet',
  'projectsv2.finalSummary.empty.body':
    'Pair items and complete selections to generate a summary.',
  'projectsv2.finalSummary.areaTotals.emptyBody':
    'Area totals will appear here after selections are finalized.',
  'projectsv2.finalSummary.actions.continueToSelections': 'Continue to Selections',
  'projectsv2.finalSummary.actions.reviewPairItems': 'Review Pair Items',
  'projectsv2.finalSummary.downloads.pdfSummary': 'PDF (Summary)',
  'projectsv2.finalSummary.downloads.xlsxSummary': 'XLSX (Summary)',
  'pairing.errors.moduleNotSet': 'Module not set',
  'pairing.info.notPaired': 'Item is not currently paired.',
  'pairing.errors.unableResolveSides': 'Unable to resolve pairing sides.',
  'pairing.errors.failedBreakPairing': 'Failed to break pairing.',
  'projectsv2.finalSummary.error.title': 'Something went wrong',
  'projectsv2.finalSummary.error.tryAgain': 'Try again',
  'projectsv2.finalSummary.actions.continue': 'Continue to Final Award/Release',
  'projectsv2.finalSummary.unableToVerifyProgress': 'Unable to verify progress',
  'projectsv2.finalSummary.actions.continueToFinalAward': 'Continue to Final Award',
  'projectsv2.finalSummary.actions.continueToFinalRelease': 'Continue to Final Release',
  'projectsv2.debug.parityBadgeTitle':
    'Stored RCV {storedRcv} vs. Computed {computedRcv}; Stored ACV {storedAcv} vs. Computed {computedAcv}',
  'projectsv2.moveItems.title': 'Move multiple items',
  'projectsv2.moveItems.titleWithArea': 'Move multiple items — {area}',
  'projectsv2.moveItems.selectionSummary': '{selectedCount} selected of {totalCount}',
  'projectsv2.moveItems.itemsInArea': 'Items in {area}',
  'projectsv2.moveItems.selectAll': 'Select all',
  'projectsv2.moveItems.clear': 'Clear',
  'projectsv2.moveItems.untitledItem': 'Untitled item',
  'projectsv2.moveItems.unassigned': 'Unassigned',
  'projectsv2.moveItems.loadFailed': 'Failed to load items for this area.',
  'projectsv2.moveItems.moveFailedTitle': 'Move failed',
  'projectsv2.moveItems.moveFailed': 'Failed to move items.',
  'projectsv2.moveItems.noItems': 'No items found in this area.',
  'projectsv2.moveItems.moveSelectedTo': 'Move selected items to',
  'projectsv2.moveItems.noDestinationAreas': 'No destination areas on this side.',
  'projectsv2.moveItems.chooseArea': 'Choose an area…',
  'projectsv2.numbers.parityVerifier':
    'Parity verifier ON — stored totals used only when both RCV & ACV are present and > 0; otherwise recomputed.',
  'projectsv2.numbers.headers.description': 'Description',
  'projectsv2.numbers.headers.decision': 'Decision',
  'projectsv2.numbers.headers.coverage': 'Coverage',
  'projectsv2.numbers.headers.unitPrice': 'Unit Price',
  'projectsv2.numbers.headers.lineTotal': 'Line Total',
  'projectsv2.numbers.headers.room': 'Room',
  'projectsv2.numbers.totals.carrier': 'Carrier Total',
  'projectsv2.numbers.totals.insured': 'Insured Total',
  'projectsv2.numbers.totals.grand': 'Grand Total',
  'projectsv2.pair.loading': 'Loading…',
  'projectsv2.pair.allAreas': 'All areas',
  'projectsv2.pair.unpairedOnly': 'Unpaired only',
  'projectsv2.pair.brokenOnly': 'Broken only',
  'projectsv2.pair.activeSearch': 'Search: "{query}"',
  'projectsv2.pair.activeArea': 'Area: {area}',
  'projectsv2.pair.broken': 'Broken',
  'projectsv2.pair.badge.broken': 'Broken',
  'projectsv2.pair.noUnpaired': 'No unpaired items.',
  'projectsv2.pair.status.unpaired': 'Unpaired',
  'projectsv2.pair.unpairedSide': 'Unpaired {side}',
  'projectsv2.pair.selectPlaceholder': 'Select...',
  'projectsv2.pair.pairAction': 'Pair',
  'projectsv2.pair.currentPairings': 'Current Pairings',
  'projectsv2.pair.noPairings': 'No pairings.',
  'projectsv2.pair.hint.pairToCompare': 'Pair this item to compare across lanes.',
  'projectsv2.pair.coverage': 'Coverage',
  'projectsv2.pair.opBasis': 'O&P basis',
  'projectsv2.pair.opBasisPre': 'Pre-tax',
  'projectsv2.pair.opBasisPost': 'Post-tax',
  'projectsv2.pair.itemId': '#{id}',
  'projectsv2.pair.empty.noItemsForLane': 'No items to display for this lane.',
  'projectsV2.addProject.projectLabel': 'PROJECT',
  'projectsV2.addProject.editDeductibleByCoverage': 'Edit Deductible & Prior Payments by Coverage',
  'projectsV2.addProject.additionalSignors': 'Additional Signors',
  'projectsv2.setup.additionalSignors': 'Additional Signors',
  'projectsv2.setup.view': 'View',
  'projectsv2.setup.viewUpload': 'View Upload',
  'projectsv2.setup.continueToUpload': 'Continue to Upload',
  'projectsv2.selections.rowError': 'Row #{row}: {message}',
  'projectsv2.selections.noPairings': 'No pairings.',
  'projectsv2.selections.sideItemId': '{side} #{id}',
  'projectsv2.selections.selectCoverage': 'Select coverage',
  'projectsv2.selections.areaCount': '({count})',
  'projectsv2.selections.continueToSummary': 'Continue to Final Summary',
  'projectsv2.selections.mustCompleteBeforeProceeding':
    'Please make all selections before proceeding.',
  'projectsv2.selections.continueToFinalDisputeSummary': 'Continue to Final Dispute Summary',
  'projectsv2.selections.unassigned': 'Unassigned',
  'projectsv2.selections.decisionLabel': 'Decision',
  'projectsv2.selections.selectDecision': 'Select',
  'projectsv2.selections.carrierCoverageAria': 'Carrier coverage',
  'projectsv2.selections.insuredCoverageAria': 'Insured coverage',
  'projectsv2.selections.selectDecisionFirst': 'Select decision first',
  'projectsv2.selections.selectCarrierCoverage': 'Select carrier coverage',
  'projectsv2.selections.selectInsuredCoverage': 'Select insured coverage',
  'projectsv2.selections.actions.applyToAll': 'Apply to All',
  'projectsv2.selections.actions.clearAll': 'Clear All',
  'projectsv2.selections.actions.clearLane': 'Clear Lane',
  'projectsv2.selections.actions.resetAll': 'Reset (All)',
  'projectsv2.selections.status.applying': 'Applying…',
  'projectsv2.selections.status.clearing': 'Clearing…',
  'projectsv2.selections.status.resetting': 'Resetting…',
  'projectsv2.selections.status.loading': 'Loading selections…',
  'projectsv2.selections.coverageLabel': 'Coverage',
  'projectsv2.selections.applyToArea': 'Apply to Area',
  'projectsv2.selections.estimateLabel': 'Estimate',
  'projectsv2.selections.carrierRcv': 'Carrier RCV',
  'projectsv2.selections.carrierAcv': 'Carrier ACV',
  'projectsv2.selections.insuredRcv': 'Insured RCV',
  'projectsv2.selections.insuredAcv': 'Insured ACV',
  'projectsv2.selections.brokenCarrierOnly': '{side} Only',
  'projectsv2.selections.brokenInsuredOnly': '{side} Only',
  'projectsv2.selections.qtyLabel': 'Qty: {value}',
  'projectsv2.selections.priceLabel': 'Price: {value}',
  'projectsv2.selections.rcvLabel': 'RCV: {value}',
  'projectsv2.selections.decisionAria': 'Decision for row {row}',
  'projectsv2.selections.carrierCoverage': 'Carrier Coverage',
  'projectsv2.selections.insuredCoverage': 'Insured Coverage',
  'projectsv2.selections.noCoverage': 'No coverage',
  'projectsv2.selections.noCoverageRequired': 'No coverage required.',
  'projectsv2.selections.carrierOp': 'Carrier: {value}',
  'projectsv2.selections.insuredOp': 'Insured: {value}',
  'projectsv2.selections.totals.selectedRcv': 'Selected Total (RCV)',
  'projectsv2.selections.totals.carrierRcv': 'Carrier Total (RCV)',
  'projectsv2.selections.totals.insuredRcv': 'Insured Total (RCV)',
  'projectsv2.selections.errors.decisionRequired': 'Select a valid decision before applying.',
  'projectsv2.selections.errors.projectRequiredApply': 'Project must be selected before applying changes.',
  'projectsv2.selections.errors.laneRequiredApply': 'Select a lane before applying changes.',
  'projectsv2.selections.errors.decisionRequiredApply': 'Select a decision before applying changes.',
  'projectsv2.selections.errors.projectRequiredClear': 'Project must be selected before clearing selections.',
  'projectsv2.selections.errors.laneRequiredClear': 'Select a lane before clearing selections.',
  'projectsv2.selections.errors.applyFailed': 'Failed to apply selections.',
  'projectsv2.selections.errors.clearFailed': 'Failed to clear selections.',
  'projectsv2.selections.errors.resetAllFailed': 'Failed to reset all selections.',
  'projectsv2.selections.errors.loadFailedGeneric': 'Failed to load selections.',
  'projectsv2.selections.errors.invalidProjectId': 'Invalid project id.',
  'projectsv2.selections.errors.chooseDecisionOrCoverage': 'Choose a decision or coverage update before applying.',
  'projectsv2.selections.errors.selectValidCoverageApplyAllAreas':
    'Select a valid coverage before applying to all areas.',
  'projectsv2.selections.errors.applyAllFailed': 'Failed to apply updates to all rows.',
  'projectsv2.selections.errors.updateDecisionFailed': 'Failed to update decision.',
  'projectsv2.selections.errors.updateCoverageFailed': 'Failed to update coverage.',
  'projectsv2.selections.clearSuccess':
    'Cleared {decisions} decision{decisionsSuffix} and {coverages} coverage{coveragesSuffix} in this area.',
  'projectsv2.selections.toast.noteSaved': 'Note saved.',
  'projectsv2.selections.toast.noRowsToUpdate': 'No rows available to update.',
  'projectsv2.selections.toast.nothingToUpdateArea': 'Nothing to update for this area.',
  'projectsv2.selections.toast.updatesAppliedArea': 'Updates applied to area.',
  'projectsv2.selections.toast.someRowsFailed': 'Some rows failed to update.',
  'projectsv2.selections.toast.allSelectionsCleared': 'All selections cleared.',
  'projectsv2.selections.toast.areaSelectionsCleared': 'Area selections cleared.',
  'projectsv2.selections.toast.updatesAppliedAllRows': 'Updates applied to all rows.',
  'projectsv2.selections.rowLoadingFallback': 'Row loading—please click again.',
  'projectsv2.selections.notes.description':
    'Pair-specific notes are visible to all collaborators on this project.',
  'projectsv2.selections.notes.label': 'Notes',
  'projectsv2.selections.notes.opening': 'Opening…',
  'projectsv2.selections.notes.addAria': 'Add pairing note',
  'projectsv2.selections.notes.editAria': 'Edit pairing note',
  'projectsv2.selections.notes.placeholder': 'Add context for this pairing…',
  'projectsv2.selections.notes.shortcutHint': 'Press ⌘+Enter or Ctrl+Enter to save',
  'projectsv2.selections.notes.charCount': '{count} / {max}',
  'projectsv2.selections.notes.saving': 'Saving…',
  'projectsv2.selections.notes.addNoteAria': 'Add pairing note',
  'projectsv2.selections.notes.editNoteAria': 'Edit pairing note',
  'projectsv2.selections.notes.errors.missingPairing': 'Selection record missing.',
  'projectsv2.selections.notes.errors.tooLong':
    'Notes must be {max} characters or fewer.',
  'projectsv2.selections.notes.errors.tooLongTitle': 'Note too long',
  'projectsv2.selections.notes.errors.tooLongDescription':
    'Please keep notes under {max} characters.',
  'projectsv2.selections.notes.errors.saveFailed': 'Failed to save note',
  'projectsv2.modals.confirmDeleteItem.title': 'Delete item?',
  'projectsv2.modals.confirmDeleteItem.body':
    'This permanently deletes {item}. This action cannot be undone.',
  'projectsv2.modals.confirmDeleteItem.fallbackTitle': 'this item',
  'projectsv2.modals.confirmDeleteItem.toastSuccess': 'Item deleted',
  'projectsv2.modals.confirmDeleteItem.errorFallback': 'Unable to delete item',
  'projectsv2.modals.confirmDeleteItem.deleteAria': 'Delete item',
  'projectsv2.modals.confirmDeleteProject.title': 'Delete project?',
  'projectsv2.modals.confirmDeleteProject.body':
    'This permanently deletes the project and all related files, items, pairings, and history.',
  'projectsv2.modals.confirmDeleteProject.confirmPrefix': 'Type',
  'projectsv2.modals.confirmDeleteProject.confirmSuffix': 'to confirm.',
  'projectsv2.modals.confirmDeleteProject.confirmAria':
    'Type "{projectName}" to confirm project deletion',
  'projectsv2.modals.confirmDeleteProject.toastSuccess': 'Deleted "{projectName}"',
  'projectsv2.modals.confirmDeleteProject.errorFallback': 'Unable to delete project',
  'projectsv2.modals.confirmDeleteProject.deleteAria': 'Delete project',
  'projectsv2.modals.mirrorAreas.title': 'Mirror Areas',
  'projectsv2.modals.mirrorAreas.description':
    'Create missing areas and reorder the target side(s) using a balanced carrier-first merge.',
  'projectsv2.modals.mirrorAreas.mirroring': 'Mirroring…',
  'projectsv2.modals.mirrorAreas.carrierToInsured': 'Mirror Carrier → Insured',
  'projectsv2.modals.mirrorAreas.insuredToCarrier': 'Mirror Insured → Carrier',
  'projectsv2.modals.mirrorAreas.bothSides': 'Mirror Both Sides',
  'projectsv2.modals.mirrorAreas.errors.failed': 'Failed to mirror areas.',
  'ua.invoiceActivity.addExpense.title': 'Add Expense',
  'ua.invoiceActivity.addExpense.tabs.timeExpense': 'Time and Expenses',
  'ua.invoiceActivity.addExpense.tabs.timeMileage': 'Time and Mileage',
  'ua.invoiceActivity.addExpense.fields.startTime': 'Start Time',
  'ua.invoiceActivity.addExpense.fields.endTime': 'End Time',
  'ua.invoiceActivity.addExpense.fields.expenditure': 'Expenditure ($)',
  'ua.invoiceActivity.addExpense.fields.calculateHourly': 'Calculate from hourly rate',
  'ua.invoiceActivity.addExpense.fields.calculated': 'Calculated: {amount}',
  'ua.invoiceActivity.addExpense.fields.activityDate': 'Activity Date/Time',
  'ua.invoiceActivity.addExpense.fields.includeTime': 'Include time too',
  'ua.invoiceActivity.addExpense.fields.mileageEntryMode': 'Mileage entry mode',
  'ua.invoiceActivity.addExpense.fields.mileageStartEnd': 'Start/End',
  'ua.invoiceActivity.addExpense.fields.mileageTotal': 'Total miles',
  'ua.invoiceActivity.addExpense.fields.mileageStart': 'Start mileage',
  'ua.invoiceActivity.addExpense.fields.mileageEnd': 'End mileage',
  'ua.invoiceActivity.addExpense.fields.mileageTotalLabel': 'Total miles: {total}',
  'ua.invoiceActivity.addExpense.fields.mileageRate': 'Mileage rate ($/mile)',
  'ua.invoiceActivity.addExpense.errors.startEndRequired': 'Start and end times are required',
  'ua.invoiceActivity.addExpense.errors.endAfterStart':
    'The end time must be later than the start time',
  'ua.invoiceActivity.addExpense.errors.hourlyRateRange':
    'Start and end times must be set to calculate from hourly rate',
  'ua.invoiceActivity.addExpense.errors.saveFailed': 'Failed to save',
  'ua.invoiceActivity.addExpense.errors.descriptionRequired': 'Description is required',
  'ua.invoiceActivity.addExpense.errors.activityDateRequired': 'Activity date/time is required',
  'ua.invoiceActivity.addExpense.errors.mileageRateInvalid':
    'Mileage rate must be a non-negative number',
  'ua.invoiceActivity.addExpense.errors.totalMilesInvalid': 'Total miles must be greater than 0',
  'ua.invoiceActivity.addExpense.errors.mileageStartEndRequired':
    'Start and end mileage are required',
  'ua.invoiceActivity.addExpense.errors.calculatedRange':
    'Set valid start/end times to calculate the amount.',
  'common.state.error': 'Error',
  'common.untitled': 'Untitled',
  'common.status.loadingItems': 'Loading items...',
  'common.status.saving': 'Saving…',
  'common.status.autosaving': 'Autosaving…',
  'common.status.allChangesSaved': 'All changes saved',
  'common.status.refreshing': 'Refreshing…',
  'common.actions.save': 'Save',
  'common.actions.cancel': 'Cancel',
  'common.actions.confirm': 'Confirm',
  'common.actions.create': 'Create',
  'common.actions.edit': 'Edit',
  'common.actions.expand': 'Expand',
  'common.actions.collapse': 'Collapse',
  'common.actions.remove': 'Remove',
  'common.actions.delete': 'Delete',
  'common.actions.move': 'Move',
  'common.actions.moveUp': 'Move up',
  'common.actions.moveDown': 'Move down',
  'common.actions.moveToTop': 'Move to top',
  'common.actions.moveToBottom': 'Move to bottom',
  'common.actions.pair': 'Pair',
  'common.cancel': 'Cancel',
  'common.actions.unpair': 'Unpair',
  'common.actions.approve': 'Approve',
  'common.actions.refresh': 'Refresh',
  'common.actions.download': 'Download',
  'common.actions.downloadPdf': 'Download {docLabel} PDF',
  'common.actions.upload': 'Upload',
  'common.actions.saveNow': 'Save Now',
  'common.actions.expandAll': 'Expand all',
  'common.actions.collapseAll': 'Collapse all',
  'common.actions.saveView': 'Save View',
  'common.actions.resetToDefault': 'Reset to Default',
  'common.actions.close': 'Close',
  'common.actions.select': 'Select',
  'common.actions.add': 'Add',
  'common.actions.apply': 'Apply',
  'common.actions.clear': 'Clear',
  'common.actions.view': 'View',
  'common.actions.generate': 'Generate',
  'common.actions.search': 'Search',
  'common.actions.clearAll': 'Clear all',
  'common.actions.prev': 'Prev',
  'common.actions.next': 'Next',
  'common.actions.install': 'Install',
  'common.actions.submit': 'Submit',
  'common.actions.send': 'Send Feedback',
  'common.actions.retry': 'Retry',
  'common.actions.lookup': 'Lookup',
  'common.actions.downloadCsv': 'Download CSV',
  'common.actions.selectAll': 'Select all',
  'common.actions.deselectAll': 'Deselect all',
  'common.actions.signIn': 'Return to login',
  'common.actions.backToSignIn': 'Back to login',
  'common.actions.setPassword': 'Set Password',
  'common.state.loading': 'Loading…',
  'common.state.loadingLabel': 'Loading',
  'common.state.noResults': 'No matches',
  'common.state.empty': 'None',
  'common.state.saving': 'Saving...',
  'common.state.moving': 'Moving…',
  'common.state.deleting': 'Deleting…',
  'common.state.clearing': 'Clearing…',
  'common.state.applying': 'Applying…',
  'common.state.unsaved': 'Unsaved',
  'common.state.unpaired': 'Unpaired',
  'common.state.paired': 'Paired',
  'common.state.approving': 'Approving…',
  'common.state.forbidden': 'Forbidden',
  'common.labels.name': 'Name',
  'common.labels.area': 'Area',
  'common.labels.qty': 'Qty',
  'common.labels.unit': 'Unit',
  'common.labels.rcv': 'RCV',
  'common.labels.acv': 'ACV',
  'common.labels.notes': 'Notes',
  'common.labels.neither': 'Neither',
  'common.labels.firstName': 'First name',
  'common.labels.lastName': 'Last name',
  'common.labels.email': 'Email',
  'common.labels.phone': 'Phone',
  'common.labels.password': 'Password',
  'common.labels.confirmPassword': 'Confirm Password',
  'common.labels.company': 'Company',
  'common.labels.seats': 'Seats',
  'common.labels.role': 'Role',
  'common.labels.organization': 'Organization',
  'common.labels.organizationId': 'Organization ID',
  'common.labels.emailVerified': 'Email Verified',
  'common.labels.membershipStatus': 'Membership Status',
  'common.labels.yes': 'Yes',
  'common.labels.no': 'No',
  'common.labels.modules': 'Modules',
  'common.labels.billing': 'Billing',
  'common.labels.actions': 'Actions',
  'common.labels.status': 'Status',
  'common.labels.user': 'User',
  'common.labels.project': 'Project',
  'common.labels.invoice': 'Invoice #',
  'common.labels.date': 'Date',
  'common.labels.method': 'Method',
  'common.labels.amount': 'Amount',
  'common.labels.reference': 'Reference',
  'common.labels.memo': 'Memo',
  'common.labels.total': 'Total',
  'common.labels.from': 'From',
  'common.labels.to': 'To',
  'common.labels.paid': 'Paid',
  'common.labels.balanceDue': 'Balance Due',
  'common.labels.id': 'ID',
  'common.labels.created': 'Created',
  'common.labels.step': 'Step',
  'common.labels.description': 'Description',
  'common.labels.title': 'Title',
  'common.labels.question': 'Question',
  'common.labels.message': 'Message',
  'common.labels.tags': 'Tags',
  'common.labels.sortOrder': 'Sort order',
  'common.labels.active': 'Active',
  'common.labels.search': 'Search',
  'common.labels.sortBy': 'Sort by',
  'common.sides.carrier': 'Carrier',
  'common.sides.insured': 'Insured',
  'common.symbol.emDash': '—',
  'common.symbol.ellipsis': '…',
  'common.symbol.check': '✓',
  'common.symbol.close': '×',
  'common.days': 'days',
  'common.na': '—',
  'items.drawer.itemTitle': 'Item #{itemId}',
  'items.drawer.tabs.details': 'Details',
  'items.drawer.tabs.history': 'History',
  'items.drawer.descriptionLabel': 'Description:',
  'items.drawer.viewDetails': 'View details',
  'items.drawer.noHistory': 'No match-phase changes recorded for this item.',
  'projects.blockedReasons.title': 'Blocked by:',
  'projects.cleanup.success': 'Cleanup complete',
  'projects.cleanup.failed': 'Cleanup failed',
  'projects.cleanup.rows': 'Clean up rows',
  'projects.cleanup.tables': 'Clean up tables',
  'projects.finalAward.failedToLoadRows': 'Failed to load rows',
  'projects.finalAward.loading': 'Loading final award...',
  'projects.finalAward.noRows': 'No rows',
  'projects.finalAward.readOnlySummary': 'Read-only Final Award summary',
  'projects.finalAward.totalsTitle': 'Final Award Totals',
  'projects.finalAward.carrierTotal': 'Carrier Total',
  'projects.finalAward.insuredTotal': 'Insured Total',
  'projects.finalAward.umpireTotal': 'Umpire Total',
  'projects.finalAward.finalDiff': 'Final Diff',
  'projects.finalAward.percentDiff': 'Percent Diff',
  'projects.finalAward.awardSummaryPlaceholder': 'Award summary',
  'projects.finalAward.amountAwardedPlaceholder': 'Amount awarded',
  'projects.finalAward.saveAward': 'Save Award',
  'projects.finalAward.viewInvoice': 'View Invoice',
  'projects.disputeSummary.failedToLoad': 'Failed to load disputes',
  'projects.disputeSummary.loading': 'Loading disputes...',
  'projects.disputeSummary.title': 'Initial Dispute Summary',
  'projects.disputeSummary.empty': 'No disputes detected.',
  'projects.disputeSummary.expandAll': 'Expand All',
  'projects.disputeSummary.collapseAll': 'Collapse All',
  'projects.disputeSummary.carrierDescription': 'Carrier Description',
  'projects.disputeSummary.insuredDescription': 'Insured Description',
  'projects.disputeSummary.carrierRcv': 'Carrier RCV',
  'projects.disputeSummary.insuredRcv': 'Insured RCV',
  'projects.disputeSummary.deltaRcv': 'Δ RCV',
  'projects.disputeSummary.carrierAcv': 'Carrier ACV',
  'projects.disputeSummary.insuredAcv': 'Insured ACV',
  'projects.disputeSummary.deltaAcv': 'Δ ACV',
  'projects.selections.failedToLoad': 'Failed to load selections',
  'projects.selections.loading': 'Loading selections...',
  'projects.selections.title': 'Selections',
  'projects.selections.selectedTotal': 'Selected Total',
  'projects.selections.carrierTotal': 'Carrier Total',
  'projects.selections.insuredTotal': 'Insured Total',
  'projects.selections.percentDiff': 'Percent Diff',
  'projects.selections.inferredNotice': 'Showing inferred selections (no explicit selections saved yet).',
  'projects.selections.empty': 'No selections yet.',
  'projects.selections.ungrouped': 'Ungrouped',
  'projects.selections.carrierRcv': 'Carrier RCV',
  'projects.selections.insuredRcv': 'Insured RCV',
  'projects.selections.deltaRcv': 'Δ RCV',
  'projects.selections.percentDiffShort': '% Diff',
  'projects.selections.paired': 'Paired',
  'projects.selections.deprec': 'Deprec',
  'projects.selections.carrier': 'Carrier',
  'projects.selections.insured': 'Insured',
  'projects.lineItemCard.segments.qty': 'Qty {qty}{uom}',
  'projects.lineItemCard.segments.price': 'Price {price}',
  'projects.lineItemCard.segments.tax': 'Tax {tax}',
  'projects.lineItemCard.segments.rcv': 'RCV {rcv}',
  'projects.lineItemCard.segments.deprec': 'Deprec. {deprec}',
  'projects.lineItemCard.segments.acv': 'ACV {acv}',
  'projects.lineItemCard.original': 'Original',
  'projects.lineItemCard.line': 'Line',
  'projects.lineItemCard.lineNumber': '#{lineNo}',
  'projects.lineItemCard.opLabel': 'O&P:',
  'projects.lineItemCard.opBasis.postTax': 'post-tax',
  'projects.lineItemCard.opBasis.preTax': 'pre-tax',
  'projects.matchMerge.acv': 'ACV {value}',
  'projects.matchMerge.acvInline': 'ACV: {acv}',
  'projects.matchMerge.addArea': 'Add area',
  'projects.matchMerge.allAreas': 'All areas',
  'projects.matchMerge.allCoverage': 'All coverage',
  'projects.matchMerge.autoCreated': 'Auto-created',
  'projects.matchMerge.autoCreatedSummary': 'Auto-created {count} pair(s). Last run: {lastRun}',
  'projects.matchMerge.autoMerged': 'Auto-merged {count} pair(s).',
  'projects.matchMerge.candidateMeta': '{area} • RCV {rcv} • ACV {acv}',
  'projects.matchMerge.candidatesCount': '{count} candidate(s)',
  'projects.matchMerge.candidatesUnavailable': 'Candidates are unavailable right now.',
  'projects.matchMerge.carrier': 'Carrier',
  'projects.matchMerge.carrierAcv': 'Carrier ACV {value}',
  'projects.matchMerge.carrierPdf': 'Carrier PDF',
  'projects.matchMerge.carrierRcv': 'Carrier RCV {value}',
  'projects.matchMerge.carrierUnpaired': 'Carrier (unpaired)',
  'projects.matchMerge.carrierUpper': 'CARRIER',
  'projects.matchMerge.chooseCandidate': 'Choose a candidate',
  'projects.matchMerge.clickToPair': 'Click to pair',
  'projects.matchMerge.confirmChoices': 'Choices — Carrier: {carrier}, Insured: {insured}, Skip: {skip}.',
  'projects.matchMerge.confirmSummary': 'You’re about to merge {total} pair(s) ({decided} decided, {undecided} undecided).',
  'projects.matchMerge.confirmTitle': 'Confirm merge',
  'projects.matchMerge.copiedCsv': 'Copied CSV to clipboard.',
  'projects.matchMerge.decisionsCounts': 'Decisions — {decided} decided, {undecided} undecided • Carrier {carrier} • Insured {insured} • Skip {skip}.',
  'projects.matchMerge.depreciationInline': 'Depreciation: {value}',
  'projects.matchMerge.drag': 'Drag',
  'projects.matchMerge.dragFrom': 'Drag a line item from either side.',
  'projects.matchMerge.dropHere': 'Drop here',
  'projects.matchMerge.emptyCarrierSlot': 'Drop a carrier item here',
  'projects.matchMerge.emptyInsuredSlot': 'Drop an insured item here',
  'projects.matchMerge.guide': 'Guide',
  'projects.matchMerge.help': 'Help',
  'projects.matchMerge.insured': 'Insured',
  'projects.matchMerge.insuredAcv': 'Insured ACV {value}',
  'projects.matchMerge.insuredPdf': 'Insured PDF',
  'projects.matchMerge.insuredRcv': 'Insured RCV {value}',
  'projects.matchMerge.insuredUnpaired': 'Insured (unpaired)',
  'projects.matchMerge.insuredUpper': 'INSURED',
  'projects.matchMerge.line': 'Line',
  'projects.matchMerge.mergeSelected': 'Merge selected',
  'projects.matchMerge.mergedSelectionsSaved': 'Merged selections saved.',
  'projects.matchMerge.newAreaPrompt': 'Enter a new area name',
  'projects.matchMerge.noCarrierItem': 'No carrier item selected.',
  'projects.matchMerge.noInsuredItem': 'No insured item selected.',
  'projects.matchMerge.noNewSuggestions': 'No new suggestions found.',
  'projects.matchMerge.noPairs': 'No pairs yet.',
  'projects.matchMerge.noPdfUploaded': 'No original PDF uploaded.',
  'projects.matchMerge.noSuggestions': 'No suggestions available.',
  'projects.matchMerge.op': 'O&P {value}',
  'projects.matchMerge.openOriginalPdfTitle': 'Open original PDF',
  'projects.matchMerge.original': 'Original',
  'projects.matchMerge.originalPdfTitle': 'Original PDF',
  'projects.matchMerge.pairCount': '{count} pair(s)',
  'projects.matchMerge.pairCreated': 'Pair created.',
  'projects.matchMerge.pairs': 'Pairs',
  'projects.matchMerge.pairsCounts': 'Total {total} • Auto {auto} • Manual {manual}',
  'projects.matchMerge.pairsStatus': 'Saved {saved} • Pending {pending} • Remaining {remaining}',
  'projects.matchMerge.pendingSource': 'Now select an item from {target} to complete the pair.',
  'projects.matchMerge.preMergeReport': 'Pre-merge report',
  'projects.matchMerge.price': 'Price {value}',
  'projects.matchMerge.priceInline': 'Price: {price}',
  'projects.matchMerge.qty': 'Qty {value}',
  'projects.matchMerge.qtyInline': 'Qty: {quantity}',
  'projects.matchMerge.rcv': 'RCV {value}',
  'projects.matchMerge.rcvInline': 'RCV: {rcv}',
  'projects.matchMerge.remerge': 'Re-merge',
  'projects.matchMerge.remergeAdded': 'Added {count} pair(s) for re-merge.',
  'projects.matchMerge.runAutoMerge': 'Run auto-merge',
  'projects.matchMerge.sameAreaOnly': 'Same area only',
  'projects.matchMerge.savePairs': 'Save pairs',
  'projects.matchMerge.searchDescription': 'Search description…',
  'projects.matchMerge.skipUndecidedMerge': 'Skip undecided and merge',
  'projects.matchMerge.table.area': 'Area',
  'projects.matchMerge.table.carrierDesc': 'Carrier description',
  'projects.matchMerge.table.created': 'Created',
  'projects.matchMerge.table.insuredDesc': 'Insured description',
  'projects.matchMerge.table.reason': 'Reason',
  'projects.matchMerge.table.score': 'Score',
  'projects.matchMerge.tax': 'Tax {value}',
  'projects.matchMerge.taxInline': 'Tax: {tax}',
  'projects.matchMerge.topSuggestions': 'Top suggestions',
  'projects.matchMerge.twoColumnPreview': 'Two-column preview',
  'projects.matchMerge.unassigned': 'Unassigned',
  'projects.matchMerge.unpairedCount': '{count} unpaired',
  'projects.matchMerge.useBreakToUnpair': 'Use “Break” to unpair.',
  'projects.matchMerge.viewOriginalCarrier': 'View original carrier',
  'projects.matchMerge.viewOriginalInsured': 'View original insured',
  'projects.matchMerge.viewOriginalPdf': 'View original {side} PDF',
  'projects.matchMergeHelp.title': 'How to use Match & Merge',
  'projects.matchMergeHelp.atAGlanceLabel': 'At a glance:',
  'projects.matchMergeHelp.atAGlanceText': 'Goal/Result (Save or leave → auto-save)',
  'projects.matchMergeHelp.legacyTitle': 'Legacy (v1) — Auto-Match via Rename + Re-Merge',
  'projects.matchMergeHelp.legacySteps': '(steps: rename → Re-Merge → review → Save)',
  'projects.matchMergeHelp.legacyNote': 'Note: Re-Merge never overwrites manual pairs.',
  'projects.matchMergeHelp.v2Title': 'V2 — Manual Drag-and-Drop (no renaming required)',
  'projects.matchMergeHelp.v2Steps': '(steps: drag → choose side/skip → Save or leave)',
  'projects.matchMergeHelp.numbersNote':
    'Numbers: ingested first; fallback computed; zeros shown; pre-tax default, post-tax optional.',
  'projects.matchMergeHelp.resultsNote': 'Where to see result: Initial Dispute Summary after save/auto-save.',
  'projects.matchMergeHelp.helpNote': 'Need help? PDFs note.',
  'projects.matchMergeHelp.dontShow': 'Don’t show this again for this project',
  'projects.organize.failedToLoadItems': 'Failed to load items',
  'projects.organize.moveFailed': 'Move failed',
  'projects.organize.renameAreaPrompt': 'Rename area',
  'projects.organize.renameFailed': 'Rename failed',
  'projects.organize.mergeIntoAreaPrompt': 'Merge into area',
  'projects.organize.mergeFailed': 'Merge failed',
  'projects.organize.bothSidesNeedItems': 'Both sides need at least one item',
  'projects.organize.side.carrier': 'Carrier',
  'projects.organize.side.insured': 'Insured',
  'projects.organize.rename': 'Rename',
  'projects.organize.merge': 'Merge',
  'projects.organize.goToPairItems': 'Go to Pair Items',
  'projects.organize.areaCount': '({count})',
  'projects.organize.adjustPrices.title': 'Adjust Prices',
  'projects.organize.adjustPrices.percent': 'Percent',
  'projects.organize.adjustPrices.markup': 'Markup',
  'projects.organize.adjustPrices.markdown': 'Markdown',
  'projects.organize.adjustPrices.absolute': 'Absolute',
  'projects.organize.moveItems.title': 'Move Items',
  'projects.organize.noChange': '(no change)',
  'projects.organize.room': 'Room',
  'projects.organize.normalizeUnits.title': 'Normalize Units',
  'projects.organize.normalizeUnits.from': 'From',
  'projects.organize.normalizeUnits.to': 'To',
  'projects.organize.normalizeUnits.factor': 'Factor',
  'projects.organize.setRoom.title': 'Set Room',
  'projects.pairCard.metrics.price': 'Price',
  'projects.pairCard.metrics.tax': 'Tax',
  'projects.pairCard.metrics.rcv': 'RCV',
  'projects.pairCard.metrics.deprec': 'Deprec.',
  'projects.pairCard.metrics.acv': 'ACV',
  'projects.pairCard.origin.auto': 'Auto',
  'projects.pairCard.origin.manual': 'Manual',
  'projects.pairCard.approxPrefix': '~',
  'projects.pairCard.opLabel': 'O&P:',
  'projects.pairCard.opBasis.preTax': 'pre-tax',
  'projects.pairCard.opBasis.postTax': 'post-tax',
  'projects.pairCard.break': 'Break',
  'projects.filters.searchPlaceholder': 'Search by title...',
  'projects.filters.status.all': 'All',
  'projects.filters.status.inProgress': 'In Progress',
  'projects.filters.status.completed': 'Completed',
  'projects.filters.status.archived': 'Archived',
  'projects.filters.sort.recentlyUpdated': 'Recently Updated',
  'projects.filters.sort.titleAsc': 'Title A-Z',
  'projects.filters.sort.titleDesc': 'Title Z-A',
  'projects.table.carrierAppraiser': 'Carrier Appraiser',
  'projects.table.status.archived': 'Archived',
  'projects.table.status.completed': 'Completed',
  'projects.table.status.inProgress': 'In Progress',
  'projects.table.empty': 'No projects found.',
  'projects.list.addProject': 'Add Project',
  'projects.list.pageSize': 'Page size:',
  'projects.list.pageLabel': 'Page {page}',
  'projects.sfProjectModal.validation.titleRequired': 'Title is required',
  'projects.sfProjectModal.validation.typeOfLossRequired': 'Type of Loss is required',
  'projects.sfProjectModal.editTitle': 'Edit Project',
  'projects.sfProjectModal.addTitle': 'Add Project',
  'projects.sfProjectModal.projectName': 'Project Name',
  'projects.sfProjectModal.projectNamePlaceholder': 'Project Name',
  'projects.sfProjectModal.carrierAppraiser': 'Carrier Appraiser',
  'projects.sfProjectModal.carrierAppraiserPlaceholder': 'Carrier Appraiser',
  'projects.sfProjectModal.typeOfLoss': 'Type of Loss',
  'projects.sfProjectModal.selectTypeOfLoss': 'Select Type of Loss',
  'projects.sfProjectModal.noTypesAvailable': 'No types available',
  'projects.sfProjectModal.causeOfLoss': 'Cause of Loss',
  'projects.sfProjectModal.selectCauseOfLoss': 'Select Cause of Loss',
  'projects.sfProjectModal.noCausesAvailable': 'No causes available',
  'projects.upload.failedWithReason': 'Upload failed: {reason}',
  'projects.uploadStep.idleHelp': 'Click to choose or drop a PDF here',
  'projects.uploadStep.uploading': 'Uploading file…',
  'projects.uploadStep.processing': 'Processing and extracting…',
  'projects.uploadStep.complete': 'Complete',
  'projects.uploadStep.nextMatchMerge': 'Next: Match & Merge',
  'common.actions.backToTop': 'Back to top',
  'common.actions.break': 'Break',
  'common.actions.copyCsv': 'Copy CSV',
  'common.actions.dismiss': 'Dismiss',
  'common.actions.goBack': 'Go back',
  'common.actions.hide': 'Hide',
  'common.actions.undo': 'Undo',
  'common.actions.redo': 'Redo',
  'common.actions.loadMore': 'Load more',
  'common.actions.drag': 'Drag',
  'common.actions.archive': 'Archive',
  'common.actions.unarchive': 'Unarchive',
  'common.actions.update': 'Update',
  'common.state.saveFailed': 'Save failed',
  'common.state.updateFailed': 'Update failed',
  'common.validation.required': 'Required',
  'common.placeholders.emptyDash': '-',
  'common.labels.qty': 'Qty',
  'common.labels.unit': 'Unit',
  'common.labels.tax': 'Tax',
  'common.labels.rcv': 'RCV',
  'common.labels.acv': 'ACV',
  'common.labels.general': 'General',
  'common.labels.unassigned': 'Unassigned',
  'roles.superadmin': 'Superadmin',
  'roles.companyAdmin': 'Company Admin',
  'roles.user': 'User',
  'modules.ua': 'UA',
  'modules.adr': 'ADR',
  'modules.cr': 'ADR Case Ready',
  'modules.cr.label': 'ADR Case Ready',
  'modules.cr.short': 'Case Ready',
  'modules.umpireAssistant': 'Umpire Assistant',
  'modules.settleFast': 'SettleFast',
  'admin.i18n.status.title': 'Status',
  'admin.i18n.status.totalKeys': 'Total keys',
  'admin.i18n.status.missingKeys': 'Missing translations',
  'admin.i18n.status.needsReview': 'Needs review',
  'admin.i18n.status.lastUpdated': 'Last updated',
  'admin.i18n.ops.bulkGenerate': 'Bulk Generate Missing (until complete)',
  'admin.i18n.ops.stop': 'Stop',
  'admin.i18n.ops.bulkRunning': 'Bulk generation running…',
  'admin.i18n.ops.bulkStopped': 'Bulk generation stopped.',
  'admin.i18n.ops.noProgress': 'No further progress could be made.',
  'admin.i18n.ops.progressLine':
    'Processed {processed} this run. Missing {missing}. Needs review {needsReview}.',
  'admin.i18n.jobs.pause': 'Pause',
  'admin.i18n.jobs.resume': 'Resume',
  'admin.i18n.jobs.summaryHeader': 'Job #{id} · {status} · {processed}/{total}',
  'admin.i18n.jobs.summaryDetails': '{total} processed · {generated} generated',
  'admin.common.namespace': 'Namespace',
  'admin.common.namespace.app': 'app',
  'admin.common.limit': 'Limit',
  'admin.i18n.healthcheck.title': 'Translation Healthcheck',
  'admin.i18n.healthcheck.help':
    'Checks installed locales for missing translations and enqueues background jobs when needed.',
  'admin.i18n.healthcheck.run': 'Run healthcheck',
  'admin.i18n.healthcheck.autoEnqueueOn': 'Auto-enqueue jobs: On',
  'admin.i18n.healthcheck.autoEnqueueOff': 'Auto-enqueue jobs: Off',
  'admin.i18n.healthcheck.createdJobs': 'Created {count} job(s).',
  'admin.i18n.healthcheck.table.locale': 'Locale',
  'admin.i18n.healthcheck.table.totalKeys': 'Total keys',
  'admin.i18n.healthcheck.table.coverage': 'Coverage',
  'admin.i18n.healthcheck.table.missing': 'Missing',
  'admin.i18n.healthcheck.table.needsReview': 'Needs review',
  'admin.i18n.healthcheck.table.job': 'Job',
  'admin.i18n.healthcheck.table.lastError': 'Last error',
  'admin.i18n.healthcheck.table.actions': 'Actions',
  'admin.i18n.healthcheck.enqueue': 'Enqueue job',
  'admin.i18n.healthcheck.noData': 'No healthcheck data yet.',
  'admin.i18n.healthcheck.error': 'Unable to run healthcheck.',
  'admin.i18n.healthcheck.runTick': 'Run 1 Tick',
  'admin.i18n.healthcheck.jobId': '#{id}',
  'admin.i18n.healthcheck.statusTitle': 'Healthcheck status',
  'admin.i18n.healthcheck.state.idle': 'Idle',
  'admin.i18n.healthcheck.state.running': 'Running…',
  'admin.i18n.healthcheck.state.completed': 'Completed',
  'admin.i18n.healthcheck.state.error': 'Error',
  'admin.i18n.healthcheck.stateLabel': 'State',
  'admin.i18n.healthcheck.lastUpdated': 'Last updated',
  'admin.i18n.healthcheck.elapsed': 'Elapsed',
  'admin.i18n.healthcheck.elapsedValue': '{seconds}s',
  'admin.i18n.healthcheck.cancel': 'Cancel',
  'admin.i18n.healthcheck.retry': 'Retry',
  'admin.i18n.jobs.summaryTitle': 'Background jobs',
  'admin.i18n.jobs.none': 'No active jobs.',
  'admin.i18n.jobs.columns.locale': 'Locale',
  'admin.i18n.jobs.columns.job': 'Job',
  'admin.i18n.jobs.columns.status': 'Job status',
  'admin.i18n.jobs.columns.progress': 'Progress',
  'admin.i18n.jobs.columns.coverage': 'Coverage',
  'admin.i18n.jobs.columns.missing': 'Missing',
  'admin.i18n.jobs.columns.needsReview': 'Needs review',
  'admin.i18n.jobs.columns.generated': 'Generated',
  'admin.i18n.jobs.columns.lastRun': 'Last run',
  'admin.i18n.jobs.columns.lastError': 'Last error',
  'admin.i18n.jobs.coverageValue': '{coverage}%',
  'admin.i18n.jobs.diagnostics':
    'Diagnostics: processed {processed}/{total} · generated {generated}',
  'admin.i18n.jobs.diagnosticsWithCursor':
    'Diagnostics: processed {processed}/{total} · generated {generated} · cursorKeyId {cursorKeyId}',
  'admin.i18n.jobs.label.generated': 'Generated: ',
  'admin.i18n.jobs.label.lastRun': 'Last run: ',
  'admin.i18n.jobs.progressValue': '{processed}/{total}',
  'admin.i18n.monitor.title': 'Active Monitor',
  'admin.i18n.monitor.help':
    'Polls translation status on an interval so you can see progress.',
  'admin.i18n.activeMonitor.pollingOnly':
    'Monitor is polling status only (it does not run jobs).',
  'admin.i18n.monitor.start': 'Start monitor',
  'admin.i18n.monitor.stop': 'Stop monitor',
  'admin.i18n.monitor.runNow': 'Run now',
  'admin.i18n.monitor.lastRun': 'Last run',
  'admin.i18n.monitor.lastResult':
    'Updated {locales} locale(s), {activeJobs} active job(s)',
  'admin.i18n.monitor.noProgressWarning':
    'No progress detected for several runs. Check server logs and job errors.',
  'admin.i18n.jobs.inProgress': 'in progress',
  'admin.i18n.jobs.startBackground': 'Start Background Bulk Generate',
  'admin.i18n.jobs.runOneTickNow': 'Run 1 Tick Now',
  'admin.i18n.queueRunner.title': 'Queue Runner',
  'admin.i18n.queueRunner.help':
    'Runs background translation jobs continuously until the queue is finished.',
  'admin.i18n.queueRunner.runWholeQueue': 'Run Whole Queue',
  'admin.i18n.queueRunner.stop': 'Stop',
  'admin.i18n.queueRunner.runOnce': 'Run once',
  'admin.i18n.queueRunner.autoStartAfterEnqueue': 'Auto-run after enqueuing jobs',
  'admin.i18n.queueRunner.status': 'Status: {state}',
  'admin.i18n.queueRunner.status.idle': 'Idle',
  'admin.i18n.queueRunner.status.running': 'Running…',
  'admin.i18n.queueRunner.status.completed': 'Completed',
  'admin.i18n.queueRunner.status.noProgress': 'No progress',
  'admin.i18n.queueRunner.status.error': 'Error',
  'admin.i18n.queueRunner.lastRun': 'Last run',
  'admin.i18n.queueRunner.lastAttempt': 'Last attempt',
  'admin.i18n.queueRunner.lastSuccess': 'Last success',
  'admin.i18n.queueRunner.lastSummaryLabel': 'Last summary',
  'admin.i18n.queueRunner.lastSummary':
    'Ran {ran} job(s), progressed {progressed} job(s)',
  'admin.i18n.queueRunner.consecutiveFailures': 'Consecutive failures',
  'admin.i18n.queueRunner.failureCountValue': '{count}',
  'admin.i18n.queueRunner.nextRunIn': 'Next run in',
  'admin.i18n.queueRunner.nextRunInValue': '{seconds}s',
  'admin.i18n.queueRunner.noProgressWarning':
    'No progress detected for several cycles. Check job errors and server logs.',
  'admin.i18n.queueRunner.completedMessage': 'Queue finished.',
  'admin.i18n.queueRunner.stoppedMessage': 'Runner stopped.',
  'admin.i18n.queueRunner.errorMessage': 'Unable to run queue runner.',
  'admin.i18n.queueRunner.busyWaiting': 'Runner busy; waiting…',
  'admin.i18n.queueRunner.lockedWaiting':
    'Another runner is processing jobs — waiting…',
  'admin.i18n.queueRunner.connectionLostBackingOff':
    'Connection lost — backing off before retrying…',
  'admin.i18n.queueRunner.noProgressBackingOff':
    'No progress detected — slowing down and retrying…',
  'admin.i18n.queueRunner.timeoutRetrying': 'Runner timed out; retrying…',
  'admin.i18n.review.bulkApprove': 'Bulk approve',
  'admin.i18n.review.bulkApproveWithCount': 'Bulk approve ({count})',
  'admin.i18n.review.sourceScope': 'Source',
  'admin.i18n.review.source.ai': 'AI',
  'admin.i18n.review.source.all': 'All',
  'admin.i18n.review.bulkApproveConfirmTitle': 'Bulk approve translations',
  'admin.i18n.review.bulkApproveConfirmBody':
    'Approve {count} translations for {locale} / {namespace}?',
  'admin.i18n.review.bulkApproveConfirmYes': 'Approve',
  'admin.i18n.review.bulkApproveConfirmNo': 'Cancel',
  'admin.i18n.review.bulkApproveSuccess': 'Approved {count} translations.',
  'admin.i18n.review.bulkApproveError': 'Unable to bulk approve translations.',
  'admin.i18n.jobs.noEligibleTitle': 'Generation completed',
  'admin.i18n.jobs.noEligibleBody':
    'No eligible keys remain for AI generation (after cursor wrap). Review missing/manual/source-text items as needed.',
  'admin.i18n.jobs.lastErrorLabel': 'Last error',
  'admin.i18n.jobs.lastErrorAtLabel': 'Last error at {date}',
  'admin.whatsNew.title': 'What’s New Manager',
  'admin.whatsNew.subtitle': 'Create, edit, and publish What’s New posts for users.',
  'admin.whatsNew.currentBuild': 'Current build: {version}',
  'admin.whatsNew.buildUnknown': 'Unknown',
  'admin.whatsNew.form.version': 'Version',
  'admin.whatsNew.form.title': 'Title',
  'admin.whatsNew.form.body': 'Body',
  'admin.whatsNew.form.linkUrl': 'Link URL',
  'admin.whatsNew.form.isPublished': 'Published',
  'admin.whatsNew.form.create': 'Create',
  'admin.whatsNew.form.reset': 'Reset',
  'admin.whatsNew.list.header': 'Posts',
  'admin.whatsNew.list.published': 'Published',
  'admin.whatsNew.list.version': 'Version',
  'admin.whatsNew.list.title': 'Title',
  'admin.whatsNew.list.publishedAt': 'Published At',
  'admin.whatsNew.list.actions': 'Actions',
  'admin.whatsNew.actions.edit': 'Edit',
  'admin.whatsNew.actions.save': 'Save',
  'admin.whatsNew.actions.cancel': 'Cancel',
  'admin.whatsNew.status.published': 'Published',
  'admin.whatsNew.status.draft': 'Draft',
  'admin.whatsNew.loading': 'Loading…',
  'admin.whatsNew.errorLoading': 'Unable to load posts.',
  'admin.whatsNew.toast.createSuccess': 'Post created successfully.',
  'admin.whatsNew.toast.createError': 'Unable to create post.',
  'admin.whatsNew.toast.updateSuccess': 'Post updated successfully.',
  'admin.whatsNew.toast.updateError': 'Unable to update post.',
  'account.notifications.pageTitle': 'Notification Settings',
  'account.notifications.subtitle': 'Manage your email and in-app notification preferences.',
  'account.notifications.loading': 'Loading settings...',
  'account.notifications.digest.title': 'Weekly/monthly digests',
  'account.notifications.digest.description': 'Stay up to date with activity summaries.',
  'account.notifications.nudges.title': 'Nudges and reminders',
  'account.notifications.nudges.description': 'Receive reminders about pending work.',
  'account.notifications.adminAlerts.title': 'Admin alerts',
  'account.notifications.adminAlerts.description': 'Receive alerts for pending approvals.',

  'welcome.title': 'Welcome Hub',
  'welcome.subtitle': 'Complete onboarding steps, access your modules, and get support quickly.',
  'welcome.state.loading': 'Loading your welcome dashboard…',
  'welcome.state.error': 'Unable to load the welcome dashboard right now.',
  'welcome.state.errorDetailsLabel': 'Details',
  'welcome.actions.retry': 'Retry',
  'welcome.help.dismiss': 'Dismiss',
  'welcome.help.reopenAria': 'Reopen onboarding help information',
  'welcome.help.reopenAriaLabel': 'Reopen onboarding help information',
  'welcome.help.relatedVideos': 'Related videos',
  'welcome.help.openVideo': 'Open video',
  'welcome.help.watched': 'Watched',
  'welcome.hero.startHere.title': 'Start here',
  'welcome.hero.startHere.subtitle': 'Begin with the primary onboarding video and then explore the full training library.',
  'welcome.hero.startHere.openVideo': 'Open video',
  'welcome.hero.startHere.viewAllTraining': 'View all training videos',
  'welcome.hero.startHere.noVideo': 'No onboarding video is available yet. You can still browse all training videos below.',
  'welcome.hero.startHere.watched': 'Watched',
  'welcome.banner.firstProjectFree.title': 'First Project is Always Free — no credit card required',
  'welcome.banner.firstProjectFree.body': 'Use your free first project to set up your workflow and see how everything connects.',
  'welcome.banner.firstProjectFree.cta': 'Create your first project',
  'welcome.banner.subscription.title': 'You\'re covered and ready to go',
  'welcome.banner.subscription.body': 'Your subscription is active. Keep building projects with confidence.',
  'welcome.banner.subscription.cta': 'Create project',
  'welcome.banner.credits.title': 'You still have credits available',
  'welcome.banner.credits.body': 'Free credits: {free} · Prepaid credits: {prepaid}',
  'welcome.banner.credits.cta': 'Create project',
  'welcome.banner.billing.title': 'Ready to keep going?',
  'welcome.banner.billing.body': 'Subscribe or buy credits to continue creating projects.',
  'welcome.banner.billing.subscribe': 'Subscribe',
  'welcome.banner.billing.buyCredits': 'Buy credits',
  'welcome.banner.billing.unavailableTooltip': 'Billing options are not available for this account yet.',
  'welcome.assistance.title': 'Need More Assistance — Connect With Our Team',
  'welcome.assistance.body': 'Our support team can help with setup, onboarding, and best practices.',
  'welcome.assistance.cta': 'Connect with our team',
  'whatsNew.title': 'What’s New',
  'whatsNew.buildLabel': 'Build:',
  'whatsNew.buildUnknown': 'Unknown',
  'whatsNew.unreadBadge': '{count} unread',
  'whatsNew.viewAll': 'View all updates',
  'whatsNew.markAllRead': 'Mark all read',
  'whatsNew.empty': 'No published updates yet.',
  'whatsNew.loadError': 'Unable to load updates right now.',
  'whatsNew.openLink': 'Open link',
  'whatsNew.toast.markAllReadSuccess': 'All updates marked as read.',
  'whatsNew.toast.markAllReadError': 'Unable to mark updates as read.',
  'whatsNew.meta.versionOnly': 'Version {version}',
  'whatsNew.meta.withPublished': 'Version {version} · Published {publishedAt}',
  'whatsNew.page.title': 'What’s New',
  'whatsNew.page.subtitle': 'Review the latest published updates and prior release notes.',
  'whatsNew.page.buildLabel': 'Current build:',
  'whatsNew.page.versionFilter.label': 'Version',
  'whatsNew.page.versionFilter.all': 'All versions',
  'whatsNew.page.loadMore': 'Load more',
  'whatsNew.page.loading': 'Loading updates…',
  'whatsNew.page.loadError': 'Unable to load updates right now.',
  'whatsNew.post.read': 'Read',
  'whatsNew.post.markRead': 'Mark read',
  'whatsNew.post.openLink': 'Open link',
  'whatsNew.post.publishedOn': 'Published',
  'whatsNew.post.version': 'Version',
  'whatsNew.toast.markReadSuccess': 'Update marked as read.',
  'whatsNew.toast.markReadError': 'Unable to mark this update as read.',
  'whatsNew.group.buildPrefix': 'Build',
  'welcome.sections.helpTips': 'Help & tips',
  'welcome.checklist.title': 'Onboarding checklist',
  'welcome.checklist.status.complete': 'Complete',
  'welcome.checklist.status.incomplete': 'Incomplete',
  'welcome.checklist.status.optional': 'Optional',
  'welcome.checklist.status.configured': 'Configured',
  'welcome.checklist.recommendedConfigureFirst': 'Recommended to configure first.',
  'welcome.checklist.invoiceCenter.globalLabel': 'Invoice Center settings',
  'welcome.checklist.actions.configure': 'Configure',
  'welcome.checklist.actions.markComplete': 'Mark complete',
  'welcome.checklist.actions.open': 'Open',
  'welcome.checklist.actions.createProject': 'Create project',
  'welcome.checklist.actions.invite': 'Invite teammate',
  'welcome.checklist.tooltips.openInfo': 'Open checklist help tooltip',
  'welcome.checklist.watchOverview.title': 'Watch overview',
  'welcome.checklist.watchOverview.description': 'Start with a quick overview so you know what to configure first.',
  'welcome.checklist.typesOfLoss.title': 'Types of Loss',
  'welcome.checklist.typesOfLoss.description': 'Configure your Types of Loss for each module you use.',
  'welcome.checklist.invoiceCenter.title': 'Invoice Center',
  'welcome.checklist.invoiceCenter.description': 'Set up invoice behavior for each module.',
  'welcome.checklist.createFirstProject.title': 'Create first project (free)',
  'welcome.checklist.createFirstProject.description': 'Launch your first project and validate your onboarding setup.',
  'welcome.checklist.userGuide.title': 'User guide',
  'welcome.checklist.userGuide.description': 'Review best practices and feature walkthroughs in the guide.',
  'welcome.checklist.videos.title': 'Videos',
  'welcome.checklist.videos.description': 'Explore onboarding and featured videos for faster ramp-up.',
  'welcome.checklist.inviteTeammate.title': 'Invite teammate (optional)',
  'welcome.checklist.inviteTeammate.description': 'Invite teammates so everyone can collaborate in the same workspace.',
  'welcome.checklist.inviteTeammate.noInviteRoute': 'Invite teammate actions are available in admin workflows.',
  'welcome.whyTypesOfLoss.title': 'Why Types of Loss is Important',
  'welcome.whyTypesOfLoss.body': 'A strong Types of Loss setup improves consistency, reporting, and project accuracy.',
  'welcome.whyTypesOfLoss.tooltip': 'Types of Loss helps standardize categorization and improves downstream reporting.',
  'welcome.whyInvoiceCenter.title': 'Why Invoice Center is Important',
  'welcome.whyInvoiceCenter.body': 'Invoice Center settings help you produce clear invoices that match your workflow.',
  'welcome.whyInvoiceCenter.tooltip': 'Invoice Center ensures invoice defaults are ready before you scale project volume.',
  'welcome.videos.title': 'Featured onboarding videos',
  'welcome.videos.empty': 'No featured videos are available yet.',
  'welcome.videos.noDescription': 'No description provided.',
  'welcome.videos.open': 'Open video',
  'welcome.videos.watched': 'Watched',
  'welcome.videos.unwatched': 'Unwatched',
  'welcome.videos.markWatched': 'Mark watched',
  'welcome.videos.markUnwatched': 'Mark unwatched',
  'welcome.modules.title': 'Module access',
  'welcome.modules.openDashboard': 'Open dashboard',
  'welcome.modules.ua.title': 'UA',
  'welcome.modules.ua.description': 'Manage estimating workflows and project details for UA.',
  'welcome.modules.adr.title': 'ADR',
  'welcome.modules.adr.description': 'Run ADR workflows with module-specific tools and dashboards.',
  'welcome.modules.sf.title': 'SettleFast',
  'welcome.modules.sf.description': 'Access SettleFast dashboards and setup tools for fast execution.',
  'welcome.toast.saved': 'Saved.',
  'welcome.toast.errorTitle': 'Unable to save',
  'welcome.toast.genericError': 'Please try again.',

  'reportingCenter.pageTitle': 'Reporting Center',
  'reportingCenter.title': 'Reporting Center',
  'reportingCenter.selectProject.title': 'Select a project',
  'reportingCenter.selectProject.cta': 'Select project',
  'reportingCenter.selectProject.searchPlaceholder': 'Search projects',
  'reportingCenter.selectProject.empty': 'No projects found.',
  'reportingCenter.selectedProject.title': 'Reports for {project}',
  'reportingCenter.selectedProject.fallbackProjectLabel': 'Project {id}',
  'reportingCenter.formats.pdf': 'PDF',
  'reportingCenter.formats.xlsx': 'XLSX',
  'reportingCenter.formats.csv': 'CSV',
  'reportingCenter.formats.formatWithNotes': '{format} (With Notes)',
  'reportingCenter.formats.formatWithoutNotes': '{format} (Without Notes)',
  'reportingCenter.reports.initialDisputeDetailed.title': 'Initial Dispute Summary (Detailed)',
  'reportingCenter.reports.initialDisputeSummary.title': 'Initial Dispute Summary (Summary)',
  'reportingCenter.reports.selections.title': 'Selections',
  'reportingCenter.reports.notesReport.title': 'Notes Report',
  'reportingCenter.reports.projectNotes.title': 'All Project Notes',
  'reportingCenter.reports.finalSummaryDetailed.title': 'Final Dispute Summary (Detailed)',
  'reportingCenter.reports.finalSummarySummary.title': 'Final Dispute Summary (Summary)',
  'reportingCenter.reports.finalCsv.title': 'Final Dispute Summary (CSV)',
  'reportingCenter.reports.finalRelease.title': 'Final Release',
  'reportingCenter.reports.finalAward.title': 'Final Award',
  'reportingCenter.reports.declarationAppraisersUmpire.title': 'Declaration of Appraisers and Selection of Umpire',
  'reportingCenter.reports.finalInvoice.title': 'Final Invoice',

  'reportingCenter.errors.invalidProjectId': 'Please provide a valid project id.',
  'reportingCenter.errors.projectNotFoundOrNoAccess': 'Project not found or you do not have access.',
  'reportingCenter.status.notReady': 'Not ready',
  'reportingCenter.status.ready': 'Ready',
  'reportingCenter.status.checking': 'Checking…',
  'reportingCenter.reasons.completePairing': 'Complete pairing first.',
  'reportingCenter.reasons.completeSelections': 'Complete selections first.',
  'reportingCenter.warnings.moduleUnknown': 'Module unavailable for this project; some reports may not be shown.',

  'projectReports.openButton': 'Reports',
  'projectReports.modalTitle': 'Project Reports',
  'projectReports.modalDescriptionOptional': 'Open a report format to download or view it.',

  'projectsV2.actions.notes': 'Notes',
  'projectsV2.actions.reports': 'Reports',

  'projectNotes.openButton': 'Notes',
  'projectNotes.modalTitle': 'Project Notes',
  'projectNotes.empty': 'No notes yet.',
  'projectNotes.fields.date': 'Date',
  'projectNotes.fields.time': 'Time',
  'projectNotes.fields.timezone': 'Timezone',
  'projectNotes.fields.note': 'Note',
  'projectNotes.actions.add': 'Add note',
  'projectNotes.actions.save': 'Save',
  'projectNotes.actions.edit': 'Edit',
  'projectNotes.actions.delete': 'Delete',
  'projectNotes.actions.cancel': 'Cancel',
  'projectNotes.actions.confirmDelete': 'Confirm delete',
  'projectNotes.errors.noteRequired': 'Please enter a note.',
  'projectNotes.errors.invalidDateTime': 'Please provide a valid date and time.',
  'projectNotes.readOnlyNotice': 'This project is closed and notes are read-only.',

  'pdf.initialDisputeSummary.title': 'Initial Dispute Summary',
  'pdf.initialDisputeSummary.untitledProject': 'Untitled Project',
  'pdf.initialDisputeSummary.label.date': 'Date:',
  'pdf.initialDisputeSummary.label.projectName': 'Project Name:',
  'pdf.initialDisputeSummary.label.claimNumber': 'Claim Number:',
  'pdf.initialDisputeSummary.label.dateOfLoss': 'Date of Loss:',
  'pdf.initialDisputeSummary.columns.line': 'Line #',
  'pdf.initialDisputeSummary.columns.description': 'Description',
  'pdf.initialDisputeSummary.columns.carrierQty': 'Carrier Qty',
  'pdf.initialDisputeSummary.columns.carrierPrice': 'Carrier Price',
  'pdf.initialDisputeSummary.columns.carrierRcv': 'Carrier RCV',
  'pdf.initialDisputeSummary.columns.carrierAcv': 'Carrier ACV',
  'pdf.initialDisputeSummary.columns.insuredQty': 'Insured Qty',
  'pdf.initialDisputeSummary.columns.insuredPrice': 'Insured Price',
  'pdf.initialDisputeSummary.columns.insuredRcv': 'Insured RCV',
  'pdf.initialDisputeSummary.columns.insuredAcv': 'Insured ACV',
  'pdf.initialDisputeSummary.columns.percentDiff': 'Diff',
  'pdf.initialDisputeSummary.fallback.item': 'Item',
  'pdf.common.dash': '–',
  'pdf.common.contSuffix': ' (cont.)',
  'pdf.common.areaTotalLabel': '{area} TOTAL:',
  'pdf.common.totalLabel': 'TOTAL:',
  'pdf.common.totals': 'TOTALS',
  'pdf.common.pageOf': 'Page {page} of {total}',
  'pdf.common.poweredByUmpireAssistant': 'Powered By Umpire Assistant',

  'common.saved': 'Saved',
  'invite.decline.pageTitle': 'Invite response',
  'invite.decline.processing': 'Processing your request...',
  'invite.decline.returnToApp': 'Return to Umpire Assistant',
  'auth.verifyEmail.cta.resend': 'Resend verification email',
  'auth.verifyEmailResend.title': 'Resend verification email',
  'auth.verifyEmailResend.success':
    'If an account exists for that email, we have sent a new verification link.',
  'auth.verifyEmailResend.emailLabel': 'Email address',
  'notifications.ariaLabel': 'Notifications',
  'notifications.title': 'Notifications',
  'notifications.markAllRead': 'Mark all read',
  'notifications.empty': 'No notifications yet.',
};

export default en;
